// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ` /* Reset and base styles */
* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

html,
body,
#root {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
}

body {
    font-family: 'Lato', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    line-height: 1.6;
    color: #333;
    background: linear-gradient(135deg, #f6f9fc 0%, #eef2f7 100%);
    cursor: default;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

/* Allow text selection and I-beam cursor only for actual content/input areas */
input,
textarea,
[contenteditable="true"],
[contenteditable=""],
.selectable,
.selectable *,
.pdf-viewer-page,
.pdf-viewer-page .react-pdf__Page,
.pdf-viewer-page .react-pdf__Page__textContent,
.pdf-viewer-page .react-pdf__Page__textContent * {
    -webkit-user-select: text;
    -moz-user-select: text;
    -ms-user-select: text;
    user-select: text;
}

input,
textarea,
[contenteditable="true"],
[contenteditable=""] {
    cursor: text;
}

/* Base container styles */
.container {
    width: 100%;
    height: 100%;
    background: linear-gradient(135deg, #f6f9fc 0%, #eef2f7 100%);
    padding: 2rem;
    padding-top: 4rem;
    min-height: fit-content;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
}

/* Base typography */
h1 {
    text-align: left;
    font-size: 1.4rem;
    margin-bottom: 1rem;
    color: #2c3e50;
    cursor: default;
    user-select: none;
}

h2 {
    font-size: 2.5rem;
    color: #1a365d;
    font-weight: 900;
    text-align: center;
    margin: 0 0 2rem 0;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
    letter-spacing: 2px;
    cursor: default;
    user-select: none;
}

h3 {
    font-size: 3rem;
    color: #1a365d;
    margin-bottom: 2.5rem;
    text-align: center;
    font-weight: 800;
    letter-spacing: 1px;
    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1);
    cursor: default;
    user-select: none;
}

/* Base form elements - apply only to inputs in forms, exclude context menu inputs */
form input:not(.context-menu-input):not(.tolerance-input):not(.tolerantsi-sisend),
.container input:not(.context-menu-input):not(.tolerance-input):not(.tolerantsi-sisend),
.form input:not(.context-menu-input):not(.tolerance-input):not(.tolerantsi-sisend),
.contact-us-form input:not(.context-menu-input):not(.tolerance-input):not(.tolerantsi-sisend) {
    width: 100%;
    height: 52px;
    border: 1px solid #b0b4b9;
    padding: 1rem;
    margin: 0.5rem 0 0 0;
    font-size: 1rem;
    border-radius: 1rem;
    background: white;
    transition: all 0.2s ease;
    outline: none;
    color: #1a365d;
    cursor: text;
    user-select: text;
}

form input:not(.context-menu-input):not(.tolerance-input):not(.tolerantsi-sisend):focus,
.container input:not(.context-menu-input):not(.tolerance-input):not(.tolerantsi-sisend):focus,
.form input:not(.context-menu-input):not(.tolerance-input):not(.tolerantsi-sisend):focus,
.contact-us-form input:not(.context-menu-input):not(.tolerance-input):not(.tolerantsi-sisend):focus {
    box-shadow: 0 0 0 1px #1a365d;
}

form input:not(.context-menu-input):not(.tolerance-input):not(.tolerantsi-sisend)::placeholder,
.container input:not(.context-menu-input):not(.tolerance-input):not(.tolerantsi-sisend)::placeholder,
.form input:not(.context-menu-input):not(.tolerance-input):not(.tolerantsi-sisend)::placeholder,
.contact-us-form input:not(.context-menu-input):not(.tolerance-input):not(.tolerantsi-sisend)::placeholder {
    color: #b0b4b9;
    font-size: 0.9rem;
}

form input:not(.context-menu-input):not(.tolerance-input):not(.tolerantsi-sisend):disabled,
.container input:not(.context-menu-input):not(.tolerance-input):not(.tolerantsi-sisend):disabled,
.form input:not(.context-menu-input):not(.tolerance-input):not(.tolerantsi-sisend):disabled,
.contact-us-form input:not(.context-menu-input):not(.tolerance-input):not(.tolerantsi-sisend):disabled {
    background: #f1f5f9;
    border-color: #cbd5e1;
    cursor: not-allowed;
    color: #94a3b8;
}

/* Button styles */
button {
    cursor: pointer;
    transition: all 0.2s ease;
    font-size: 1rem;
    font-family: inherit;
}

button:disabled,
.btn-disabled {
    cursor: not-allowed;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    transform: none;
    opacity: 0.6;
    background: #cbd5e1;
    color: #000000;
}

button:disabled:hover,
.btn-disabled:hover {
    opacity: 1;
    transform: none;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.btn-underline {
    height: 20px;
    background: none;
    border: none;
    color: #1a365d;
    font-size: 0.9rem;
    text-decoration: underline;
    margin-top: 0.2rem;
    padding: 0;
    text-align: left;
    display: block;
    width: fit-content;
}

.btn-active {
    background: #75ee97;
    color: #1a365d;
    border: 2px solid #cad1dc;
    box-shadow: 0 4px 8px rgba(26, 54, 93, 0.2);
    border-radius: 12px;
    padding: 12px 24px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    text-decoration: none;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    width: 100%;
    height: 52px;
    margin-top: 1rem;
    min-width: 120px;
}

.btn-active-disabled {
    background: rgb(255, 255, 255);
    color: #9ca3af;
    border: 2px solid #cad1dc;
    box-shadow: 0 4px 8px rgba(26, 54, 93, 0.2);
}

.btn-active:not(:disabled):hover {
    background: #78f49b;
    border: 2px solid #1a365d;
    color: #1a365d;
    transform: translateY(-1px);
    box-shadow: 0 6px 12px rgba(37, 44, 40, 0.3);
}

/* Button loading state with spinner */
.button-loading-content {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
}

.button-spinner {
    width: 16px;
    height: 16px;
    border: 2px solid rgba(26, 54, 93, 0.2);
    border-top: 2px solid #1a365d;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
}

/* Base label styles */
label {
    display: block;
    margin-bottom: 1.2rem;
    font-size: 1rem;
    color: #2d3748;
    font-weight: 600;
    cursor: default;
    user-select: none;
}

label:focus-within {
    color: #1a365d;
}

/* Base form styles */
form:not(.contact-us-form) {
    background: white;
    padding: 4rem;
    border-radius: 24px;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08);
    width: 100%;
    max-width: 600px;
    display: flex;
    text-align: left;
    flex-direction: column;
    justify-content: center;
    backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.2);
    height: fit-content;
    margin: 0 0 2rem 0;
}

.no-organization-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100vh;
    background: linear-gradient(135deg, #f6f9fc 0%, #eef2f7 100%);
    padding: 2rem;
    gap: 1.5rem;
}

.no-organization-message {
    max-width: 480px;
    text-align: center;
    background: #ffffff;
    border-radius: 24px;
    padding: 2.5rem 2rem;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08);
    border: 1px solid rgba(255, 255, 255, 0.6);
    font-size: 1.1rem;
    color: #1f2937;
    position: relative;
}

.back-button {
    padding: 0.75rem 2rem;
    font-size: 1rem;
    font-weight: 600;
    background: #1a365d;
    color: white;
    border: none;
    border-radius: 12px;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 4px 12px rgba(26, 54, 93, 0.2);
}

.back-button:hover {
    background: #2d4a7c;
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(26, 54, 93, 0.3);
}

.no-organization-message::before {
    content: '!';
    position: absolute;
    top: -26px;
    left: 50%;
    transform: translateX(-50%);
    width: 52px;
    height: 52px;
    border-radius: 50%;
    background: linear-gradient(135deg, #f97373 0%, #ef4444 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
    font-weight: 800;
    font-size: 1.4rem;
    box-shadow: 0 10px 20px rgba(239, 68, 68, 0.35);
}

.row-container {
    display: flex;
    flex-direction: column;
}

/* PDF viewer route root */
.pdf-viewer-page {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    background: #fff;
    overflow: hidden;
    cursor: default;
}

/* Main PDF viewer container */
.pdf-viewer-page .pdf-viewer {
    position: relative;
    height: 100%;
    display: flex;
    flex-direction: column;
    width: 100%;
    background: #fff;
    overflow: hidden;
    transition: all 0.3s ease;
}

/* Top navigation bar */
.pdf-viewer-page .pdf-info-bar {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    background: #f0f0f0;
    padding: 6px 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    z-index: 1000;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

/* Drag hint for editor role */
.pdf-viewer-page .pdf-drag-hint {
    position: absolute;
    top: 60px;
    left: 12px;
    font-size: 12px;
    color: #666;
    z-index: 999;
    pointer-events: none;
}

/* Main content area with scrolling */
.pdf-viewer-page .pdf-canvas-centerer {
    position: absolute;
    top: 60px;
    /* высота верхнего инфобара */
    bottom: 65px;
    /* высота нижней панели с легендой + запас для горизонтального скроллбара */
    left: 0;
    right: 0;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
    background: #fff;
    overflow-x: auto;
    overflow-y: auto;
    padding: 0;
    transition: all 0.3s ease;
}

/* Portrait: center the PDF/Konva stack on wide viewports; safe avoids odd overflow when zoomed */
.pdf-viewer-page .pdf-canvas-centerer:not(.landscape) {
    justify-content: safe center;
}

.pdf-viewer-page.no-legend .pdf-canvas-centerer {
    bottom: 0;
}

/* PDF zoom wrapper - provides correct dimensions for scrolling when zoomed */
.pdf-viewer-page .pdf-zoom-wrapper {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    transition: width 0.1s ease, height 0.1s ease;
}

/* App-wide engineering loading overlay (frosted glass + technical animation) */
.app-engineering-loading-overlay {
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: all;
    background-color: rgba(248, 250, 252, 0.38);
    -webkit-backdrop-filter: blur(10px);
    backdrop-filter: blur(10px);
}

.app-engineering-loading-overlay--fullscreen {
    position: fixed;
    inset: 0;
    z-index: 10000;
    min-height: 100vh;
    width: 100%;
}

.app-engineering-loading-overlay--contained {
    position: absolute;
    inset: 0;
    z-index: 2000;
}

.app-engineering-loading-overlay--compact {
    position: relative;
    inset: auto;
    min-height: 200px;
    width: 100%;
    background: transparent;
    -webkit-backdrop-filter: none;
    backdrop-filter: none;
    pointer-events: none;
}

.app-engineering-loading-overlay--compact .pdf-save-engineering-loader {
    transform: scale(0.88);
}

.app-engineering-loading-overlay .pdf-save-engineering-loader {
    position: relative;
    width: min(380px, 92vw);
    height: 220px;
    box-sizing: border-box;
}

.app-engineering-loading-overlay .pdf-save-eng-scanline {
    position: absolute;
    left: -4%;
    right: -4%;
    height: 2px;
    top: 18%;
    background: linear-gradient(90deg, transparent 0%, rgba(71, 85, 105, 0.45) 45%, rgba(71, 85, 105, 0.45) 55%, transparent 100%);
    animation: pdf-save-eng-scan-vertical 2.6s ease-in-out infinite;
    pointer-events: none;
    z-index: 2;
}

.app-engineering-loading-overlay .pdf-save-eng-frame {
    position: absolute;
    inset: 0;
    pointer-events: none;
    z-index: 1;
}

.app-engineering-loading-overlay .pdf-save-eng-corner {
    position: absolute;
    width: 22px;
    height: 22px;
    border-color: #475569;
    border-style: solid;
    opacity: 0.85;
    animation: pdf-save-eng-corner-pulse 3.2s ease-in-out infinite;
}

.app-engineering-loading-overlay .pdf-save-eng-corner--tl {
    top: 0;
    left: 0;
    border-width: 2px 0 0 2px;
}

.app-engineering-loading-overlay .pdf-save-eng-corner--tr {
    top: 0;
    right: 0;
    border-width: 2px 2px 0 0;
}

.app-engineering-loading-overlay .pdf-save-eng-corner--bl {
    bottom: 0;
    left: 0;
    border-width: 0 0 2px 2px;
}

.app-engineering-loading-overlay .pdf-save-eng-corner--br {
    bottom: 0;
    right: 0;
    border-width: 0 2px 2px 0;
}

.app-engineering-loading-overlay .pdf-save-eng-corner--tr,
.app-engineering-loading-overlay .pdf-save-eng-corner--bl {
    animation-delay: 0.4s;
}

.app-engineering-loading-overlay .pdf-save-eng-stage {
    position: absolute;
    left: 50%;
    top: 52%;
    transform: translate(-50%, -50%);
    width: 88%;
    max-width: 320px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 18px;
    z-index: 3;
}

.app-engineering-loading-overlay .pdf-save-eng-caliper {
    position: relative;
    width: 100%;
    height: 36px;
    display: flex;
    align-items: flex-end;
    justify-content: center;
}

.app-engineering-loading-overlay .pdf-save-eng-caliper-bar {
    position: absolute;
    left: 12%;
    right: 12%;
    bottom: 10px;
    height: 4px;
    background: #64748b;
    border-radius: 1px;
}

.app-engineering-loading-overlay .pdf-save-eng-caliper-jaw {
    position: absolute;
    bottom: 0;
    width: 5px;
    height: 28px;
    background: #334155;
    border-radius: 1px;
    animation: pdf-save-eng-caliper-open 1.9s ease-in-out infinite;
}

.app-engineering-loading-overlay .pdf-save-eng-caliper-jaw--left {
    left: 22%;
    transform-origin: center bottom;
}

.app-engineering-loading-overlay .pdf-save-eng-caliper-jaw--right {
    right: 22%;
    transform-origin: center bottom;
    animation: pdf-save-eng-caliper-open-right 1.9s ease-in-out infinite;
}

.app-engineering-loading-overlay .pdf-save-eng-gears {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
}

.app-engineering-loading-overlay .pdf-save-eng-gear-svg {
    width: 52px;
    height: 52px;
    color: #334155;
    overflow: visible;
}

.app-engineering-loading-overlay .pdf-save-eng-gear-svg--secondary {
    width: 40px;
    height: 40px;
    margin-top: 6px;
}

.app-engineering-loading-overlay .pdf-save-eng-gear-hub {
    fill: #f1f5f9;
    stroke: #334155;
    stroke-width: 2;
}

.app-engineering-loading-overlay .pdf-save-eng-gear-spokes {
    stroke: #334155;
    stroke-width: 3.2;
}

.app-engineering-loading-overlay .pdf-save-eng-gear-spokes--six {
    stroke-width: 3;
}

.app-engineering-loading-overlay .pdf-save-eng-gear-spin {
    transform-origin: 28px 28px;
}

.app-engineering-loading-overlay .pdf-save-eng-gear-spin--cw {
    animation: pdf-save-eng-rotate-cw 2.8s linear infinite;
}

.app-engineering-loading-overlay .pdf-save-eng-gear-spin--ccw {
    animation: pdf-save-eng-rotate-ccw 3.6s linear infinite;
}

.app-engineering-loading-overlay .pdf-save-eng-scale {
    position: relative;
    width: 100%;
    height: 22px;
}

.app-engineering-loading-overlay .pdf-save-eng-scale-track {
    position: absolute;
    left: 0;
    right: 0;
    top: 10px;
    height: 2px;
    background: #94a3b8;
}

.app-engineering-loading-overlay .pdf-save-eng-scale-track::before {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    top: -8px;
    height: 10px;
    background-image: repeating-linear-gradient(
        90deg,
        #475569 0,
        #475569 1px,
        transparent 1px,
        transparent 5px,
        #64748b 5px,
        #64748b 6px,
        transparent 6px,
        transparent 14px
    );
    background-size: 28px 10px;
    animation: pdf-save-eng-ticks-slide 1.4s linear infinite;
    opacity: 0.9;
}

.app-engineering-loading-overlay .pdf-save-eng-scale-cursor {
    position: absolute;
    top: 2px;
    width: 2px;
    height: 18px;
    background: #0f172a;
    left: 8%;
    margin-left: -1px;
    animation: pdf-save-eng-cursor-sweep 2.2s ease-in-out infinite;
    box-shadow: 0 0 0 1px rgba(248, 250, 252, 0.9);
}

.app-engineering-loading-overlay .pdf-save-eng-scale-cursor::before,
.app-engineering-loading-overlay .pdf-save-eng-scale-cursor::after {
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    left: 50%;
    transform: translateX(-50%);
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
}

.app-engineering-loading-overlay .pdf-save-eng-scale-cursor::before {
    top: -5px;
    border-bottom: 5px solid #0f172a;
}

.app-engineering-loading-overlay .pdf-save-eng-scale-cursor::after {
    bottom: -5px;
    border-top: 5px solid #0f172a;
}

.app-engineering-loading-overlay .pdf-save-eng-reticle {
    position: absolute;
    right: 10%;
    top: 22%;
    width: 48px;
    height: 48px;
    transform: translate(50%, -50%);
    pointer-events: none;
    z-index: 2;
}

.app-engineering-loading-overlay .pdf-save-eng-reticle-ring {
    position: absolute;
    inset: 0;
    border: 1px dashed #64748b;
    border-radius: 50%;
    animation: pdf-save-eng-reticle-spin 5s linear infinite;
}

.app-engineering-loading-overlay .pdf-save-eng-reticle-cross {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 22px;
    height: 22px;
    transform: translate(-50%, -50%);
    border: 1px solid rgba(51, 65, 85, 0.65);
    animation: pdf-save-eng-cross-breathe 1.6s ease-in-out infinite;
}

.app-engineering-loading-overlay .pdf-save-eng-reticle-cross::before,
.app-engineering-loading-overlay .pdf-save-eng-reticle-cross::after {
    content: '';
    position: absolute;
    background: #475569;
}

.app-engineering-loading-overlay .pdf-save-eng-reticle-cross::before {
    left: 50%;
    top: 2px;
    bottom: 2px;
    width: 1px;
    transform: translateX(-50%);
}

.app-engineering-loading-overlay .pdf-save-eng-reticle-cross::after {
    top: 50%;
    left: 2px;
    right: 2px;
    height: 1px;
    transform: translateY(-50%);
}

@keyframes pdf-save-eng-scan-vertical {
    0%,
    100% {
        top: 14%;
        opacity: 0.35;
    }
    50% {
        top: 78%;
        opacity: 0.85;
    }
}

@keyframes pdf-save-eng-corner-pulse {
    0%,
    100% {
        opacity: 0.55;
    }
    50% {
        opacity: 1;
    }
}

@keyframes pdf-save-eng-caliper-open {
    0%,
    100% {
        transform: translateX(0);
    }
    50% {
        transform: translateX(-6px);
    }
}

@keyframes pdf-save-eng-caliper-open-right {
    0%,
    100% {
        transform: translateX(0);
    }
    50% {
        transform: translateX(6px);
    }
}

@keyframes pdf-save-eng-rotate-cw {
    to {
        transform: rotate(360deg);
    }
}

@keyframes pdf-save-eng-rotate-ccw {
    to {
        transform: rotate(-360deg);
    }
}

@keyframes pdf-save-eng-ticks-slide {
    0% {
        background-position: 0 0;
    }
    100% {
        background-position: 28px 0;
    }
}

@keyframes pdf-save-eng-cursor-sweep {
    0%,
    100% {
        left: 8%;
    }
    50% {
        left: 88%;
    }
}

@keyframes pdf-save-eng-reticle-spin {
    to {
        transform: rotate(-360deg);
    }
}

@keyframes pdf-save-eng-cross-breathe {
    0%,
    100% {
        transform: translate(-50%, -50%) scale(1);
        opacity: 0.85;
    }
    50% {
        transform: translate(-50%, -50%) scale(1.12);
        opacity: 1;
    }
}

@media (prefers-reduced-motion: reduce) {
    .app-engineering-loading-overlay .pdf-save-eng-scanline {
        animation-duration: 5s;
    }

    .app-engineering-loading-overlay .pdf-save-eng-corner {
        animation: none;
        opacity: 0.85;
    }

    .app-engineering-loading-overlay .pdf-save-eng-caliper-jaw {
        animation: none;
    }

    .app-engineering-loading-overlay .pdf-save-eng-gear-spin--cw {
        animation-duration: 10s;
    }

    .app-engineering-loading-overlay .pdf-save-eng-gear-spin--ccw {
        animation-duration: 12s;
    }

    .app-engineering-loading-overlay .pdf-save-eng-scale-track::before {
        animation: none;
    }

    .app-engineering-loading-overlay .pdf-save-eng-scale-cursor {
        animation-duration: 4s;
    }

    .app-engineering-loading-overlay .pdf-save-eng-reticle-ring {
        animation-duration: 20s;
    }

    .app-engineering-loading-overlay .pdf-save-eng-reticle-cross {
        animation: none;
    }
}

/* PDF and Konva container with fixed dimensions */
.pdf-viewer-page .pdf-konva-container {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: transparent;
    width: 1400px;
    height: 1600px;
    min-width: 1400px;
    min-height: 1200px;
    transition: all 0.3s ease;
    overflow: visible;
    /* Improve tap vs scroll on tablets (Konva over PDF). */
    touch-action: manipulation;
}

/* Landscape PDF container */
.pdf-viewer-page .pdf-konva-container.landscape {
    width: 2000px;
    height: 1600px;
    min-width: 2000px;
    min-height: 1600px;
    align-items: center;
    overflow: visible;
}

/* PDF wrapper with fixed dimensions */
.pdf-viewer-page .pdf-canvas-wrapper {
    position: relative;
    display: block;
    background: #fff;
    border: none;
    border-radius: 8px;
    width: 1400px;
    height: 1600px;
    min-width: 1400px;
    min-height: 1200px;
    overflow: visible;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
    margin: 0 auto;
}

/* Landscape PDF wrapper */
.pdf-viewer-page .pdf-canvas-wrapper.landscape {
    width: 2000px;
    height: 1600px;
    min-width: 2000px;
    min-height: 1600px;
    margin: 0 auto;
}

/* Konva Stage with absolute positioning over PDF */
.pdf-viewer-page .stage-absolute {
    position: absolute;
    left: 50%;
    top: 0;
    transform: translateX(-50%);
    width: 1400px !important;
    height: 1600px !important;
    min-width: 1400px !important;
    min-height: 1200px !important;
    pointer-events: auto;
    z-index: 10;
    border: none;
    border-radius: 6px;
    transition: all 0.3s ease;
    touch-action: manipulation;
}

/* Landscape PDF stage */
.pdf-viewer-page .stage-absolute.landscape {
    width: 2000px !important;
    height: 1600px !important;
    min-width: 2000px !important;
    min-height: 1600px !important;
    left: 50%;
    transform: translateX(-50%);
}

.pdf-viewer-page .ocr-markers-html-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    pointer-events: none;
    z-index: 5;
}

.pdf-viewer-page .ocr-marker-item {
    position: absolute;
    left: var(--ocr-x);
    top: var(--ocr-y);
    width: var(--ocr-w);
    height: var(--ocr-h);
    border: 2px solid;
    border-radius: 2px;
    box-sizing: border-box;
}

.pdf-viewer-page .ocr-marker-item.ocr-marker-pdfjs {
    border-color: #00b450;
    background-color: rgba(0, 180, 80, 0.3);
}

.pdf-viewer-page .ocr-marker-item.ocr-marker-gemini {
    border-color: #3c82f6;
    background-color: rgba(60, 130, 246, 0.3);
}

.pdf-viewer-page .ocr-marker-text {
    position: absolute;
    top: 100%;
    left: 0;
    margin-top: 2px;
    white-space: nowrap;
    font-size: 10px;
}

.pdf-viewer-page .ocr-marker-item.ocr-marker-pdfjs .ocr-marker-text {
    color: #00b450;
}

.pdf-viewer-page .ocr-marker-item.ocr-marker-gemini .ocr-marker-text {
    color: #3c82f6;
}
/* PDF canvas styling */
.pdf-viewer-page .pdf-canvas-wrapper canvas {
    display: block;
    width: 1400px !important;
    height: 1600px !important;
    min-width: 1400px !important;
    min-height: 1200px !important;
    margin: 0 !important;
    background: #fff;
    object-fit: contain !important;
    transform: none !important;
    transform-origin: center !important;
    scale: 1 !important;
    transition: all 0.3s ease;
}

/* Landscape PDF canvas */
.pdf-viewer-page .pdf-canvas-wrapper.landscape canvas {
    width: 2000px !important;
    height: 1600px !important;
    min-width: 2000px !important;
    min-height: 1600px !important;
}

/* React PDF page styling */
.pdf-viewer-page .react-pdf__Page {
    width: 1400px !important;
    height: 1600px !important;
    min-width: 1400px !important;
    min-height: 1200px !important;
    transform: none !important;
    scale: 1 !important;
    object-fit: contain !important;
    transition: all 0.3s ease;
}

.pdf-viewer-page .react-pdf__Page__canvas {
    width: 1400px !important;
    height: 1600px !important;
    min-width: 1400px !important;
    min-height: 1200px !important;
    transform: none !important;
    scale: 1 !important;
    object-fit: contain !important;
    transition: all 0.3s ease;
}

.pdf-viewer-page .react-pdf__Page__svg {
    width: 1400px !important;
    height: 1600px !important;
    min-width: 1400px !important;
    min-height: 1200px !important;
    transform: none !important;
    scale: 1 !important;
    object-fit: contain !important;
    transition: all 0.3s ease;
}

/* Landscape PDF pages */
.pdf-viewer-page .react-pdf__Page.landscape {
    width: 2000px !important;
    height: 1600px !important;
    min-width: 2000px !important;
    min-height: 1600px !important;
}

.pdf-viewer-page .react-pdf__Page__canvas.landscape {
    width: 2000px !important;
    height: 1600px !important;
    min-width: 2000px !important;
    min-height: 1600px !important;
}

.pdf-viewer-page .react-pdf__Page__svg.landscape {
    width: 2000px !important;
    height: 1600px !important;
    min-width: 2000px !important;
    min-height: 1600px !important;
}

/* Responsive scaling for PDF components */
@media (max-width: 1200px) {

    .pdf-viewer-page .pdf-canvas-wrapper,
    .pdf-viewer-page .stage-absolute,
    .pdf-viewer-page .pdf-canvas-wrapper canvas,
    .pdf-viewer-page .react-pdf__Page,
    .pdf-viewer-page .react-pdf__Page__canvas,
    .pdf-viewer-page .react-pdf__Page__svg {
        width: 1400px !important;
        height: 1600px !important;
        min-width: 1400px !important;
        min-height: 1200px !important;
    }

    .pdf-viewer-page .pdf-konva-container {
        width: 1400px;
        height: 1600px;
        min-width: 1400px;
        min-height: 1200px;
    }

    /* Landscape orientation */
    .pdf-viewer-page .pdf-canvas-wrapper.landscape,
    .pdf-viewer-page .stage-absolute.landscape,
    .pdf-viewer-page .pdf-canvas-wrapper.landscape canvas,
    .pdf-viewer-page .react-pdf__Page.landscape,
    .pdf-viewer-page .react-pdf__Page__canvas.landscape,
    .pdf-viewer-page .react-pdf__Page__svg.landscape {
        width: 2000px !important;
        height: 1600px !important;
        min-width: 2000px !important;
        min-height: 1600px !important;
    }

    .pdf-viewer-page .pdf-konva-container.landscape {
        width: 2000px;
        height: 1600px;
        min-width: 2000px;
        min-height: 1600px;
    }
}

/* All smaller breakpoints use same PDF dimensions */
@media (max-width: 1000px),
(max-width: 800px),
(max-width: 600px) {

    .pdf-viewer-page .pdf-canvas-wrapper,
    .pdf-viewer-page .stage-absolute,
    .pdf-viewer-page .pdf-canvas-wrapper canvas,
    .pdf-viewer-page .react-pdf__Page,
    .pdf-viewer-page .react-pdf__Page__canvas,
    .pdf-viewer-page .react-pdf__Page__svg {
        width: 1400px !important;
        height: 1600px !important;
        min-width: 1400px !important;
        min-height: 1200px !important;
    }

    .pdf-viewer-page .pdf-konva-container {
        width: 1400px;
        height: 1600px;
        min-width: 1400px;
        min-height: 1200px;
    }
}

/* Bottom measurement legend bar — всегда внизу экрана, над скроллбаром */
.pdf-viewer-page .measurement-legend-bar {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    background: transparent;
    padding: 62px 12px 16px 12px;
    box-shadow: none;
    z-index: 1000;
    display: flex;
    justify-content: flex-start;
    gap: 14px;
    font-size: 15px;
    overflow-x: auto;
    overflow-y: visible;
    flex-wrap: nowrap;
    pointer-events: none;
    min-width: 0;
    align-items: flex-end;
}

.pdf-viewer-page .measurement-legend-item {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 6px 10px;
    background: #f0efef;
    border-radius: 6px;
    border: 1px solid #000000;
    font-size: 15px;
    flex-shrink: 0;
    pointer-events: auto;
    cursor: inherit;
    height: 62px;
    box-sizing: border-box;
    transition: box-shadow 0.3s ease, border-color 0.3s ease, background-color 0.3s ease, transform 0.3s ease;
    box-shadow: 0 2px 16px rgba(44, 62, 80, 0.12), 0 1.5px 6px rgba(44, 62, 80, 0.12);
}

.pdf-viewer-page .measurement-legend-item-clickable {
    cursor: pointer;
    transition: box-shadow 0.3s ease, border-color 0.3s ease, background-color 0.3s ease, transform 0.3s ease;
}



.pdf-viewer-page .measurement-legend-item-selected {
    border-color: #383838;
    border-width: 2px;
    z-index: 1001;
    position: relative;
    background: #ffffff;
    transform: translateY(-25px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15), 0 2px 4px rgba(0, 0, 0, 0.1);
}

.pdf-viewer-page .measurement-legend-number,
.pdf-viewer-page .pdf-info-bar .legend-number {
    width: 38px;
    height: 38px;
    border-radius: 5px;
    position: relative;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    font-size: 16px;
}

.pdf-viewer-page .measurement-legend-img {
    max-height: 50px !important;
    max-width: 150px;
    width: 150px;
    height: 50px !important;
    object-fit: contain;
    margin-left: 0px;
    margin-right: 0px;
}

.pdf-viewer-page .measurement-legend-img-placeholder {
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #153472;
    border-radius: 5px;
    font-weight: bold;
    font-size: 20px;
    color: #ffffff;
}

.measurement-legend-number.legend-1 {
    background-color: rgba(37, 99, 235, 0.53);
}

.measurement-legend-number.legend-2 {
    background-color: rgba(220, 38, 38, 0.53);
}

.measurement-legend-number.legend-3 {
    background-color: rgba(22, 163, 74, 0.53);
}

.measurement-legend-number.legend-4 {
    background-color: rgba(124, 58, 237, 0.53);
}

.measurement-legend-number.legend-5 {
    background-color: rgba(234, 88, 12, 0.53);
}

.measurement-legend-number.legend-6 {
    background-color: rgba(234, 179, 8, 0.53);
}

/* Context menu styles */
.pdf-viewer-page .context-menu {
    position: fixed;
    width: fit-content;
    min-width: 170px;
    background: white;
    box-shadow: 0 0 5px grey;
    border-radius: 8px;
    z-index: 9999;
    padding: 16px;
    cursor: default;
    user-select: none;
}

.pdf-viewer-page .context-menu-editor {
    min-width: 170px;
}

/* ===== User context menu (role: user) ===== */
.pdf-viewer-page .context-menu.context-menu-user {
    padding: 0;
    width: fit-content;
    min-width: fit-content;
}

.pdf-viewer-page .context-menu-user .context-menu-user-sequence-number {
    flex-shrink: 0;
    align-self: flex-start;
    font-weight: normal;
    font-size: 1.125rem;
    line-height: 1;
    color: #000;
    min-width: 1.25em;
    text-align: left;
}

.pdf-viewer-page .context-menu-user .context-menu-user-submitted-with-sequence {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 8px;
    flex-wrap: wrap;
}

.pdf-viewer-page .context-menu-user .context-menu-user-submitted-with-sequence .context-menu-submitted-value {
    margin-bottom: 0;
}

/* --- Non-measurement tools: ok/no buttons | image | submit in one row --- */
.pdf-viewer-page .context-menu-user .context-menu-non-measurement-row {
    display: flex;
    align-items: center;
    gap: 24px;
    padding: 8px;
}

/* Match measurement row: vertically centered sequence number and spacing to tool image */
.pdf-viewer-page .context-menu-user .context-menu-non-measurement-row .context-menu-user-sequence-number {
    align-self: center;
    margin-left: 10px;
    margin-right: -16px;
}

.pdf-viewer-page .context-menu-non-measurement-row .ok-no-buttons-group {
    display: flex;
    gap: 6px;
    flex-shrink: 0;
}

.pdf-viewer-page .context-menu-non-measurement-row .context-menu-tool-image-row {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
    width: fit-content;
    min-height: 0;
    padding: 0 10px;
}

.pdf-viewer-page .context-menu-non-measurement-row .measurement-legend-img {
    width: auto !important;
    height: 50px !important;
    max-width: 150px !important;
    max-height: 50px !important;
    object-fit: contain;
    display: block;
    opacity: 0;
    transition: opacity 0.15s ease;
}

.pdf-viewer-page .context-menu-non-measurement-row .measurement-legend-img.measurement-legend-img-loaded {
    opacity: 1;
}

.pdf-viewer-page .context-menu-non-measurement-row .measurement-legend-img-placeholder {
    width: 60px;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.pdf-viewer-page .context-menu-non-measurement-row .context-menu-btn-done {
    flex-shrink: 0;
    margin: 0 10px;
}

/* --- Exam mode: image-based tool dropdown & result feedback --- */
.pdf-viewer-page .exam-tool-dropdown {
    position: relative;
    flex-shrink: 0;
}

.pdf-viewer-page .exam-tool-dropdown-trigger {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 52px;
    height: 52px;
    border: 2px solid #d1d5db;
    border-radius: 8px;
    background: #f9fafb;
    cursor: pointer;
    padding: 3px;
    transition: border-color 0.15s;
}

.pdf-viewer-page .exam-tool-dropdown-trigger:hover {
    border-color: #6366f1;
}

.pdf-viewer-page .exam-tool-dropdown-img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    border-radius: 4px;
}

.pdf-viewer-page .exam-tool-dropdown-placeholder {
    font-size: 11px;
    color: #9ca3af;
    text-align: center;
    line-height: 1.2;
}

.pdf-viewer-page .exam-tool-dropdown-placeholder-letter {
    font-size: 20px;
    font-weight: 600;
    color: #6b7280;
}

.pdf-viewer-page .exam-tool-dropdown-panel {
    position: absolute;
    top: calc(100% + 6px);
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    padding: 8px;
    background: #fff;
    border: 1px solid #d1d5db;
    border-radius: 10px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
    z-index: 100;
    max-width: 280px;
}

.pdf-viewer-page .exam-tool-dropdown-item {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 56px;
    height: 56px;
    border: 2px solid transparent;
    border-radius: 8px;
    background: #f3f4f6;
    cursor: pointer;
    padding: 3px;
    transition: border-color 0.15s, background 0.15s;
}

.pdf-viewer-page .exam-tool-dropdown-item:hover {
    border-color: #6366f1;
    background: #eef2ff;
}

.pdf-viewer-page .exam-tool-dropdown-item-selected {
    border-color: #4f46e5;
    background: #e0e7ff;
}

.pdf-viewer-page .exam-tool-dropdown-item-img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    border-radius: 4px;
}

.pdf-viewer-page .exam-tool-dropdown-item-placeholder {
    font-size: 18px;
    font-weight: 600;
    color: #6b7280;
}

.pdf-viewer-page .exam-tool-result {
    font-size: 13px;
    padding: 4px 10px;
    border-radius: 4px;
    white-space: nowrap;
}

.pdf-viewer-page .exam-tool-correct {
    color: #065f46;
    background-color: #d1fae5;
}

.pdf-viewer-page .exam-tool-incorrect {
    color: #991b1b;
    background-color: #fee2e2;
}

/* --- Measurement tools: image | input | submit in one row --- */
.pdf-viewer-page .context-menu-user .tolerance-input-group {
    flex-shrink: 0;
    padding: 8px;
}

.pdf-viewer-page .context-menu-user .context-menu-user-image-input-row {
    display: flex;
    align-items: center;
    gap: 24px;
    width: 100%;
}

.pdf-viewer-page .context-menu-user .context-menu-user-image-input-row .context-menu-user-sequence-number {
    align-self: center;
    margin-left: 10px;
    /* Negative right margin cancels parent gap (24px) so visual distance to image equals left indent */
    margin-right: -16px;
}

.pdf-viewer-page .context-menu-user .context-menu-user-image-input-row .context-menu-tool-image-row {
    flex-shrink: 0;
    width: fit-content;
    padding: 0 10px;
}

.pdf-viewer-page .context-menu-user .context-menu-user-image-input-row .measurement-legend-img {
    width: auto !important;
    max-width: 150px !important;
    max-height: 150px !important;
    height: auto;
    object-fit: contain;
    opacity: 0;
    transition: opacity 0.15s ease;
}

.pdf-viewer-page .context-menu-user .context-menu-user-image-input-row .measurement-legend-img.measurement-legend-img-loaded {
    opacity: 1;
}

.pdf-viewer-page .context-menu-user .context-menu-user-image-input-row .measurement-legend-img-placeholder {
    width: 60px;
    height: 60px;
    font-size: 48px;
}

.pdf-viewer-page .context-menu-user .context-menu-user-image-input-row .context-menu-user-dimension-info {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    flex-shrink: 0;
    font-family: 'Arial', sans-serif;
    white-space: nowrap;
    user-select: none;
}

.pdf-viewer-page .context-menu-user .context-menu-user-image-input-row .context-menu-user-dimension-nominal {
    font-size: 22px;
    font-weight: 600;
    line-height: 1;
    color: #222;
}

.pdf-viewer-page .context-menu-user .context-menu-user-image-input-row .context-menu-user-dimension-tolerances {
    display: inline-flex;
    flex-direction: column;
    justify-content: center;
    font-size: 13px;
    line-height: 1.15;
    color: #555;
}

.pdf-viewer-page .context-menu-user .context-menu-user-image-input-row .context-menu-user-dimension-tolerance-plus,
.pdf-viewer-page .context-menu-user .context-menu-user-image-input-row .context-menu-user-dimension-tolerance-minus {
    font-variant-numeric: tabular-nums;
}

.pdf-viewer-page .context-menu-user .context-menu-user-image-input-row .user-measurement-input {
    width: 90px;
    padding: 0 10px;
}

.pdf-viewer-page .context-menu-user .context-menu-user-image-input-row .context-menu-btn-done {
    margin: 0 10px;
}

.pdf-viewer-page .context-menu:has(.context-menu-submitted-value) {
    padding: 0px;
    min-width: auto;
    min-height: auto;
    width: fit-content;
    height: auto;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
}

.pdf-viewer-page .context-menu-input {
    height: 35px;
    padding: 0px;
    padding-left: 8px;
    border: 1px solid #ccc;
    border-radius: 6px;
    margin-top: 0px;
    margin-bottom: 0px;
    font-size: 14px;
    box-sizing: border-box;
    background: white;
    color: #1a365d;
    cursor: text;
    user-select: text;
}

.pdf-viewer-page .user-measurement-input {
    width: 90px;
    max-width: 90px;
    min-width: 0;
    cursor: text;
    user-select: text;
}

.pdf-viewer-page .context-menu input[type="text"]:not(.user-measurement-input) {
    width: 50px;
    height: 35px;
    padding: 0px;
    padding-left: 8px;
    box-sizing: border-box;
    background: white;
    color: #1a365d;
    cursor: text;
    user-select: text;
}

.pdf-viewer-page .tolerance-input-row-1 input {
    width: 70px;
}

.pdf-viewer-page .tolerance-input-row-tool-block {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.pdf-viewer-page .tolerance-input-row-tool-with-recognition {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    flex-wrap: nowrap;
    gap: 8px;
}

.pdf-viewer-page .tolerance-input-tool-and-recognized {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.pdf-viewer-page .tolerance-input-tool-row-with-ocr {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 6px;
    flex-wrap: nowrap;
}

.pdf-viewer-page .context-menu-region-ocr-btn {
    width: 40px;
    height: 40px;
    min-width: 40px;
    padding: 0;
    border: 1px solid #e5e7eb;
    border-radius: 4px;
    background-color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    color: #1a365d;
}

.pdf-viewer-page .context-menu-region-ocr-btn:hover:not(:disabled) {
    background-color: #f3f4f6;
}

.pdf-viewer-page .context-menu-region-ocr-btn-icon {
    width: 22px;
    height: 22px;
    display: block;
}

.pdf-viewer-page .context-menu-region-ocr-btn--loading .context-menu-region-ocr-btn-icon {
    animation: context-menu-region-ocr-pulse 0.9s ease-in-out infinite;
}

@keyframes context-menu-region-ocr-pulse {
    0%,
    100% {
        opacity: 1;
    }
    50% {
        opacity: 0.35;
    }
}

.pdf-viewer-page .tolerance-input-container .context-menu-recognized-value {
    font-size: 20px;
    color: #000000;
    font-weight: 600;
    max-width: 120px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.pdf-viewer-page .context-menu .tolerance-input-wrapper input[type="text"] {
    width: 70px;
    height: 35px;
    padding: 0px;
    padding-left: 8px;
    box-sizing: border-box;
    background: white;
    color: #1a365d;
    cursor: text;
    user-select: text;
}

/* PDF context menu checkbox: сбрасываем глобальные стили input, оставляем дефолтный чекбокс */
.pdf-viewer-page .context-menu input[type="checkbox"] {
    width: 30px;
    height: 30px;
    margin: 0 4px 0 4px;
    padding: 0;
    border-radius: 4px;
    border: 2px solid #d1d5db;
    background-color: #ffffff;
    /* same as context menu background when unchecked */
    box-shadow: none;
    appearance: none;
    /* fully custom checkbox */
    cursor: pointer;
    position: relative;
}

.pdf-viewer-page .context-menu input[type="checkbox"]:checked {
    background-color: #ffffff;
    border-color: #6b7280;
}

.pdf-viewer-page .context-menu input[type="checkbox"]:checked::after {
    content: "";
    position: absolute;
    left: 50%;
    top: 45%;
    width: 5px;
    height: 10px;
    border: solid #d12626;
    /* dark gray tick visible on white */
    border-width: 0 2px 2px 0;
    transform: translate(-50%, -50%) rotate(45deg);
}

.pdf-viewer-page .context-menu-input.input-error {
    border-color: #DC2626;
    background-color: #FEF2F2;
}

.pdf-viewer-page .context-menu-input.input-error:focus {
    border-color: #DC2626;
    outline-color: #DC2626;
}

.pdf-viewer-page .settings-file-error {
    padding: 10px;
    background-color: #fee;
    color: #c33;
    margin: 10px;
    border-radius: 4px;
    text-align: center;
}

.pdf-viewer-page .tool-input-error {
    color: #DC2626;
    font-size: 0.75rem;
    margin-top: 0.25rem;
    padding-left: 0.5rem;
}

.pdf-viewer-page .context-menu-input:focus {
    border-color: #a5b4fc;
    outline: none;
    box-shadow: 0 0 0 2px #e0e7ff;
}

.pdf-viewer-page .context-menu-submitted-value {
    padding: 8px 16px;
    border: 1px solid #d1d5db;
    border-radius: 6px;
    background-color: #f9fafb;
    color: #80736b;
    font-size: 24px;
    width: auto;
    height: auto;
    min-width: auto;
    min-height: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 0px;
    font-weight: 500;
    white-space: nowrap;
    flex-shrink: 0;
}

.pdf-viewer-page .context-menu-btn-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 12px;
}

.pdf-viewer-page .context-menu-btn-row .measurement-legend-img {
    flex: 1;
    width: fit-content;
    height: 50px !important;
    max-width: 150px;
    max-height: 50px !important;
    margin-right: 12px;
    object-fit: cover;
}

.pdf-viewer-page .context-menu-btn-delete {
    width: 48px;
    height: 48px;
    background: #fee2e2;
    border: 2px solid #fecaca;
    padding: 12px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    transition: all 0.2s ease;
    color: #414040;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.pdf-viewer-page .context-menu-btn-delete-small {
    width: 32px;
    height: 32px;
    padding: 6px;
    flex-shrink: 0;
}

.pdf-viewer-page .tool-input-row {
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    gap: 8px;
}

.pdf-viewer-page .tool-input-wrapper {
    display: flex;
    flex-direction: column;
    gap: 4px;
    flex: 1;
}

.pdf-viewer-page .tool-display-row {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-bottom: 8px;
}

.pdf-viewer-page .selected-tool-display {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 8px 12px;
    background: #f3f4f6;
    border-radius: 6px;
    border: 1px solid #e5e7eb;
}

.pdf-viewer-page .selected-tool-number {
    width: 32px;
    height: 32px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    font-size: 14px;
    flex-shrink: 0;
}

.pdf-viewer-page .selected-tool-name {
    font-size: 14px;
    color: #374151;
}

.pdf-viewer-page .no-tool-selected-message {
    padding: 8px 12px;
    background: #fef3c7;
    border-radius: 6px;
    border: 1px solid #f59e0b;
    font-size: 13px;
    color: #92400e;
}

.pdf-viewer-page .context-menu-btn-delete:hover {
    background: #fecaca;
    border-color: #f31717;
    transform: translateY(-1px);
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.pdf-viewer-page .context-menu-btn-done {
    /* step 2 */
    width: 45px;
    height: 45px;
    background: #d1fae5;
    border: 2px solid #a7f3d0;
    padding: 6px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    transition: all 0.2s ease;
    color: #414040;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    flex-shrink: 0;
}

.pdf-viewer-page .context-menu-btn-done:hover {
    background: #b4f0d4;
    border-color: #00f794;
    transform: translateY(-1px);
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.pdf-viewer-page .context-menu-btn-done:focus,
.pdf-viewer-page .context-menu-btn-done:focus-visible {
    outline: none;
    border-color: #00f794;
    box-shadow: 0 0 0 1px #566677;
}

.pdf-viewer-page .context-menu-btn-done:disabled,
.pdf-viewer-page .context-menu-btn-done.btn-disabled {
    width: 38px;
    height: 38px;
    padding: 5px;
    cursor: not-allowed;
    opacity: 0.6;
    background: #cbd5e1;
    border: 2px solid #cbd5e1;
    transform: none;
}

.pdf-viewer-page .context-menu-btn-done:disabled:hover,
.pdf-viewer-page .context-menu-btn-done.btn-disabled:hover {
    border: 2px solid #cbd5e1;
    opacity: 0.6;
    transform: none;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.pdf-viewer-page .context-menu-btn-done.btn-enabled {
    background: #d1fae5;
    border: 2px solid #a7f3d0;
    color: #414040;
    cursor: pointer;
    opacity: 1;
}

.pdf-viewer-page .context-menu-btn-done.btn-enabled:hover {
    background: #b4f0d4;
    border-color: #00f794;
    transform: translateY(-1px);
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}


.pdf-viewer-page .context-menu-btn-ok-no {
    flex: 0 0 auto;
    padding: 0.5rem;
    min-width: 40px;
    height: 40px;
    font-size: 1.2rem;
    font-weight: bold;
    border: 2px solid #d1d5db;
    border-radius: 8px;
    background-color: white;
    color: #374151;
    cursor: pointer;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;
}

.pdf-viewer-page .context-menu-btn-ok-no:hover {
    border-color: #1a365d;
    background-color: #f3f4f6;
}

.pdf-viewer-page .context-menu-btn-ok-no:focus,
.pdf-viewer-page .context-menu-btn-ok-no:focus-visible {
    outline: none;
    border-color: #1a365d;
    box-shadow: 0 0 0 1px #566677;
}

.pdf-viewer-page .context-menu-btn-ok-no.selected {
    border-color: #1a365d;
    background-color: #1a365d;
    color: white;
}

.pdf-viewer-page .context-menu-btn-ok-no.selected:focus,
.pdf-viewer-page .context-menu-btn-ok-no.selected:focus-visible {
    outline: none;
    border-color: #1a365d;
    box-shadow: 0 0 0 1px #566677;
}

.pdf-viewer-page .context-menu-btn-done-full-width {
    width: 100%;
    margin-top: 0.5rem;
}

/* Context menu positioning */
.pdf-viewer-page .context-menu-positioned {
    position: absolute;
}

/* Tolerance input styling */
.pdf-viewer-page .tolerance-input-group {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
    margin-bottom: 0px;
    width: 100%;
    padding-top: 16px;
    padding-bottom: 16px;
}

.pdf-viewer-page .tolerance-input-group .measurement-legend-img {
    width: 35px;
    height: 35px;
    object-fit: contain;
    flex-shrink: 0;
}

.pdf-viewer-page .context-menu-tool-image-row {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 8px;
}

.pdf-viewer-page .context-menu-tool-image-row .measurement-legend-img {
    width: 100%;
    height: 50px !important;
    max-width: 250px;
    max-height: 50px !important;
    object-fit: contain;
}


.pdf-viewer-page .tolerance-input-group:has(.context-menu-submitted-value) {
    padding: 0px;
    margin-bottom: 0px;
    flex-direction: column;
    height: auto;
    min-height: auto;
}

.pdf-viewer-page .tolerance-label {
    font-size: 14px;
    color: #374151;
    cursor: pointer;
    margin: 0;
    user-select: none;
    display: flex;
    align-items: center;
    line-height: 1;
}

.pdf-viewer-page .tolerance-input-container {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-bottom: 16px;
}

.pdf-viewer-page .tolerance-input-row-1 {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
}

.pdf-viewer-page .tolerance-input-row-1 input {
    width: 70px;
}

.pdf-viewer-page .tolerance-input-row-1 #nominal-dimension {
    width: 70px;
}

.pdf-viewer-page .tolerance-input-row-full-width .nominal-input-with-buttons {
    width: 100%;
}

.pdf-viewer-page .tolerance-input-row-full-width .nominal-input-with-buttons input {
    width: auto;
}

.pdf-viewer-page .tolerance-input-row-2 {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
}

.pdf-viewer-page .tolerance-input-row-3 {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
}

.pdf-viewer-page .tolerance-input-wrapper {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.pdf-viewer-page .tolerance-input-wrapper input {
    height: 35px !important;
    padding: 0px !important;
    padding-left: 8px !important;
    cursor: text;
    user-select: text;
}

.pdf-viewer-page .tolerance-input-label {
    font-weight: 500;
    font-size: 14px;
    color: #374151;
}

.pdf-viewer-page .tolerance-type-label {
    font-weight: 500;
    font-size: 14px;
    color: #374151;
    white-space: nowrap;
    margin: 0;
}

.pdf-viewer-page .nominal-input-with-buttons {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
}

.pdf-viewer-page .nominal-input-with-buttons input {
    flex: 1;
    min-width: 0;
}

.pdf-viewer-page .nominal-input-with-buttons-stacked {
    flex-direction: column;
    align-items: stretch;
    width: 100%;
}

.pdf-viewer-page .nominal-input-with-buttons-stacked input,
.pdf-viewer-page .tolerance-input-row-full-width .nominal-input-with-buttons-stacked input,
.pdf-viewer-page .nominal-input-with-buttons-stacked #nominal-dimension {
    width: 100% !important;
    min-width: 0;
    box-sizing: border-box;
    height: 35px;
    min-height: 35px;
}

.pdf-viewer-page .nominal-symbol-buttons {
    display: flex;
    gap: 6px;
    flex-shrink: 0;
}

.pdf-viewer-page .nominal-symbol-btn {
    width: 40px;
    height: 40px;
    padding: 0;
    border: 1px solid #e5e7eb;
    border-radius: 4px;
    background-color: #ffffff;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    transition: background-color 0.15s;
}

.pdf-viewer-page .nominal-symbol-btn:hover {
    background-color: #f3f4f6;
}

.pdf-viewer-page .nominal-symbol-btn.selected {
    border-color: #6b7280;
    border-width: 2px;
    box-shadow: 0 0 0 1px #6b7280;
}

.pdf-viewer-page .nominal-symbol-btn img {
    width: 70%;
    height: 70%;
    object-fit: contain;
}

.pdf-viewer-page .nominal-hole-shaft-wrapper {
    display: flex;
    flex-direction: column;
    gap: 4px;
    margin-top: 6px;
}

.pdf-viewer-page .nominal-hole-shaft-buttons {
    display: flex;
    gap: 6px;
}

.pdf-viewer-page .hole-shaft-error {
    font-size: 11px;
    color: #dc2626;
}

.pdf-viewer-page .context-menu-hole-shaft-btn {
    width: 40px;
    height: 40px;
    padding: 0;
    border: 1px solid #e5e7eb;
    border-radius: 4px;
    background-color: #ffffff;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    transition: background-color 0.15s;
}

.pdf-viewer-page .context-menu-hole-shaft-btn:hover {
    background-color: #f3f4f6;
}

.pdf-viewer-page .context-menu-hole-shaft-btn.selected {
    border-color: #6b7280;
    border-width: 2px;
    box-shadow: 0 0 0 1px #6b7280;
}

.pdf-viewer-page .context-menu-hole-shaft-btn.m-mode-active {
    border-color: #ea580c;
    border-width: 2px;
    box-shadow: 0 0 0 1px #ea580c;
}

.pdf-viewer-page .context-menu-hole-shaft-btn img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.pdf-viewer-page .hole-shaft-m-btn-wrapper {
    position: relative;
}

.pdf-viewer-page .context-menu-m-btn {
    font-size: 16px;
    font-weight: 700;
    font-family: 'Lato', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
}

.pdf-viewer-page .context-menu-m-btn.m-open {
    background-color: #f97316;
    border-color: #ea580c;
    color: #ffffff;
}

.pdf-viewer-page .context-menu-m-btn.m-open:hover {
    background-color: #ea580c;
}

.pdf-viewer-page .context-menu-m-btn.m-has-designation {
    min-width: 52px;
    font-size: 11px;
    padding: 0 4px;
}

.pdf-viewer-page .hole-shaft-m-dropdown {
    position: absolute;
    top: 100%;
    left: 0;
    margin-top: 4px;
    max-height: 280px;
    overflow-y: auto;
    background-color: #ffffff;
    border: 1px solid #e5e7eb;
    border-radius: 4px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    z-index: 1000;
    min-width: 120px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

.pdf-viewer-page .hole-shaft-m-dropdown-item {
    display: block;
    width: 100%;
    padding: 6px 12px;
    text-align: left;
    border: none;
    background: none;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    font-size: 13px;
    font-family: 'Lato', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
    color: #374151;
}

.pdf-viewer-page .hole-shaft-m-dropdown-item:hover {
    background-color: #f3f4f6;
}

.pdf-viewer-page .nominal-dimension-buttons {
    display: flex;
    gap: 8px;
    justify-content: flex-start;
    align-items: center;
}

.pdf-viewer-page .nominal-btn {
    padding: 0px 12px;
    width: 25px;
    border: 2px solid #d1d5db;
    border-radius: 4px;
    background-color: #ffffff;
    cursor: pointer;
    font-size: 18px;
    transition: all 0.1s ease;
    color: #374151;
    font-weight: 600;
    font-family: 'Lato', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
    background-clip: border-box;
    -webkit-background-clip: border-box;
    box-shadow: none;
    vertical-align: middle;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
}

.pdf-viewer-page .nominal-btn:hover {
    background-color: #ffffff;
    border-color: #9ca3af;
}

.pdf-viewer-page .nominal-btn.selected {
    background-color: #EFEAEA;
    color: rgba(0, 0, 0, 1);
    border-color: #6b7280;
    border-width: 2px;
    box-shadow: 0 0 0 1px #6b7280;
    font-weight: 900;
    font-size: 20px;
    background-clip: unset;
    -webkit-background-clip: unset;
    font-family: 'Lato', -apple-system, sans-serif;
}

.pdf-viewer-page .nominal-btn-small {
    height: auto;
    min-height: 40px;
}

/* b- */
/* .nominal-btn.btn-disabled {
    opacity: 0.5;=

    cursor: not-allowed;
} */

.pdf-viewer-page .tolerance-inputs-row {
    display: flex;
    flex-direction: column;
    gap: 8px;
    align-items: flex-start;
}

.pdf-viewer-page .tolerance-inputs-row-left {
    flex-shrink: 0;
    margin-right: 12px;
}

.pdf-viewer-page .tolerance-input-row-4 {
    display: flex;
    flex-direction: column;
    gap: 4px;
    align-items: flex-start;
    margin-left: 0;
    padding-left: 0;
}

.pdf-viewer-page .tolerance-input-row-4.iso2768-tolerance-row-with-actions {
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: flex-end;
    justify-content: space-between;
    gap: 10px;
    width: 100%;
}

.pdf-viewer-page .iso2768-tolerance-inputs-stack {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.pdf-viewer-page .iso2768-rc-buttons {
    display: flex;
    flex-direction: column;
    gap: 6px;
    flex-shrink: 0;
    align-self: flex-end;
    padding-bottom: 2px;
}

.pdf-viewer-page .iso2768-rc-btn.iso2768-rc-btn {
    min-width: 36px;
    min-height: 32px;
    font-weight: 700;
    font-size: 15px;
    line-height: 1;
    padding: 4px 8px;
    user-select: none;
    -webkit-user-select: none;
}

.pdf-viewer-page .tolerance-inputs-row-compact .tolerance-input-rida {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 2px;
    margin-left: 0;
    padding-left: 0;
}

.pdf-viewer-page .tolerance-inputs-row-compact .tolerantsi-silt {
    min-width: 16px;
    padding-right: 0;
    margin: 0;
    width: auto;
}

.pdf-viewer-page .tolerance-input-rida {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 8px;
    text-align: center;
}

.pdf-viewer-page .tolerantsi-silt {
    min-width: 50px;
    font-weight: normal;
    text-align: right;
    padding-right: 2px;
    line-height: 35px;
    font-size: 18px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    align-self: center;
    margin-bottom: 0px !important;
}


/* Pagination */
.pdf-viewer-page .pdf-pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 16px;
    padding: 16px;
    background: #f8fafc;
    border-top: 1px solid #e2e8f0;
}

.pdf-viewer-page .pdf-pagination button {
    padding: 8px 16px;
    border: 1px solid #d1d5db;
    border-radius: 6px;
    background: white;
    cursor: pointer;
    transition: all 0.2s ease;
}

.pdf-viewer-page .pdf-pagination button:hover:not(:disabled) {
    background: #f3f4f6;
    border-color: #9ca3af;
}


/* Specific button variants */
.pdf-viewer-page .pdf-back-btn {
    background: none;
    border: 2px solid #aeb2b0;
    padding: 12px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
    flex-shrink: 0;
    color: #000000;
}

.pdf-viewer-page .pdf-back-btn:hover {
    background: #EFEAEA;
    transform: translateY(-1px);
    box-shadow: 0 6px 12px #cfcbcb;
}

.pdf-viewer-page .pdf-role-switch {
    display: flex;
    border: 2px solid #aeb2b0;
    border-radius: 12px;
    overflow: hidden;
    flex-shrink: 0;
    margin-left: 12px;
}

.pdf-viewer-page .pdf-role-switch-option {
    width: 36px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    font-weight: 700;
    background: none;
    border: none;
    color: #000000;
    cursor: pointer;
    transition: background 0.2s ease, color 0.2s ease;
}

.pdf-viewer-page .pdf-role-switch-option:first-child {
    border-right: 1px solid #aeb2b0;
}

.pdf-viewer-page .pdf-role-switch-option.pdf-role-switch-active {
    background: #a4f4ba;
    color: #393939;
    border-color: #BBECCB;
}

.pdf-viewer-page .pdf-role-switch-option:not(.pdf-role-switch-active):hover {
    background: #EFEAEA;
}

.pdf-viewer-page .pdf-save-btn {
    background: none;
    color: #000000;
    border: 2px solid #aeb2b0;
    border-radius: 12px;
    padding: 12px;
    font-size: 16px;
    font-weight: 600;
    min-width: 48px;
    min-height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    text-decoration: none;
    flex: 0 0 auto;
    width: auto;
}

/* PDF save button enabled state */
.pdf-viewer-page .pdf-save-btn:not(.btn-disabled) {
    background: #a4f4ba;
    color: #393939;
    border: 2px solid #BBECCB;
}

.pdf-viewer-page .pdf-save-btn:not(.btn-disabled):hover {
    background: #78f49b;
    color: #000000;
    transform: translateY(-1px);
    box-shadow: 0 6px 12px rgba(37, 44, 40, 0.3);
}

/* PDF save button disabled state */
.pdf-viewer-page .pdf-save-btn.btn-disabled {
    background: none;
    color: #000000;
    border: 2px solid #aeb2b0;
    opacity: 0.5;
}

/* Info items (read-only labels; override .pdf-viewer-page user-select:text — no I-beam) */
.pdf-viewer-page .info-item,
.pdf-viewer-page .info-center {
    font-size: 14px;
    color: #374151;
    font-weight: 500;
    padding: 0;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    cursor: default;
}

.pdf-viewer-page .info-center {
    text-align: center;
}

/* Ensure buttons stay in place */
.pdf-viewer-page .pdf-back-btn,
.pdf-viewer-page .pdf-role-switch,
.pdf-viewer-page .pdf-save-btn,
.pdf-viewer-page .pdf-detect-btn,
.pdf-viewer-page .pdf-g-btn,
.pdf-viewer-page .pdf-help-btn {
    flex-shrink: 0;
}

/* Detect measurements button */
.pdf-viewer-page .pdf-detect-btn {
    position: relative;
    margin-left: 12px;
    background: none;
    color: #000000;
    border: 2px solid #aeb2b0;
    padding: 12px;
    border-radius: 8px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
    gap: 4px;
}

.pdf-viewer-page .pdf-detect-btn:not(.btn-disabled):hover {
    background: #e0e7ff;
    border-color: #6366f1;
    color: #4338ca;
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(99, 102, 241, 0.2);
}

.pdf-viewer-page .pdf-detect-btn-active {
    background: #e0e7ff;
    border-color: #6366f1;
    color: #4338ca;
}

.pdf-viewer-page .pdf-detect-btn.btn-disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.pdf-viewer-page .pdf-detect-btn.btn-disabled:hover {
    transform: none;
    box-shadow: none;
    background: none;
}

.pdf-viewer-page .pdf-g-btn {
    position: relative;
    background: none;
    color: #000000;
    border: 2px solid #aeb2b0;
    padding: 12px;
    border-radius: 8px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 48px;
    min-height: 48px;
    font-size: 18px;
    font-weight: 700;
    transition: all 0.2s ease;
}

.pdf-viewer-page .pdf-g-btn:not(.btn-disabled):hover {
    background: #e0e7ff;
    border-color: #6366f1;
    color: #4338ca;
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(99, 102, 241, 0.2);
}

.pdf-viewer-page .pdf-g-btn-active {
    background: #e0e7ff;
    border-color: #6366f1;
    color: #4338ca;
}

.pdf-viewer-page .pdf-g-btn.btn-disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.pdf-viewer-page .pdf-g-btn.btn-disabled:hover {
    transform: none;
    box-shadow: none;
    background: none;
}

.pdf-viewer-page .pdf-save-pdf-btn {
    position: relative;
    margin-left: 12px;
    background: none;
    color: #000000;
    border: 2px solid #aeb2b0;
    padding: 8px 12px;
    border-radius: 8px;
    cursor: pointer;
    font-size: 12px;
    font-weight: 600;
    transition: all 0.2s ease;
}

.pdf-viewer-page .pdf-save-pdf-btn:not(.btn-disabled):hover {
    background: #e0e7ff;
    border-color: #6366f1;
    color: #4338ca;
}

.pdf-viewer-page .pdf-save-pdf-btn.btn-disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.pdf-viewer-page .pdf-help-btn {
    position: relative;
    margin-left: 12px;
    background: none;
    color: #000000;
    border: 2px solid #aeb2b0;
    padding: 12px;
    border-radius: 8px;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 48px;
    min-height: 48px;
    font-size: 18px;
    font-weight: 700;
    transition: all 0.2s ease;
}

.pdf-viewer-page .pdf-help-btn:hover {
    background: #e0e7ff;
    border-color: #6366f1;
    color: #4338ca;
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(99, 102, 241, 0.2);
}

.pdf-viewer-page .pdf-settings-btn {
    position: relative;
    margin-left: 12px;
    background: none;
    color: #000000;
    border: 2px solid #aeb2b0;
    padding: 12px;
    border-radius: 8px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 48px;
    min-height: 48px;
    font-size: 18px;
    font-weight: 700;
    transition: all 0.2s ease;
}

.pdf-viewer-page .pdf-settings-btn:hover {
    background: #e0e7ff;
    border-color: #6366f1;
    color: #4338ca;
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(99, 102, 241, 0.2);
}

.pdf-viewer-page .pdf-settings-btn-icon {
    display: block;
}

.pdf-viewer-page .pdf-help-btn-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    cursor: pointer;
}

.pdf-viewer-page .help-menu-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.4);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10000;
}

.pdf-viewer-page .help-menu {
    background: #ffffff;
    border-radius: 12px;
    padding: 24px;
    max-width: 420px;
    width: 90%;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
}

.pdf-viewer-page .help-menu-title {
    font-size: 1.25rem;
    font-weight: 700;
    margin-bottom: 20px;
    color: #1a365d;
}

.pdf-viewer-page .help-menu-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-bottom: 20px;
}

.pdf-viewer-page .help-menu-row {
    display: flex;
    align-items: center;
    gap: 12px;
}

.pdf-viewer-page .help-menu-row kbd {
    flex-shrink: 0;
    min-width: 60px;
    padding: 4px 8px;
    background: #f1f5f9;
    border: 1px solid #cbd5e1;
    border-radius: 6px;
    font-family: inherit;
    font-size: 0.9rem;
}

.pdf-viewer-page .help-menu-close {
    width: 100%;
    padding: 10px 16px;
    background: #6366f1;
    color: white;
    border: none;
    border-radius: 8px;
    font-size: 1rem;
    font-weight: 600;
    cursor: pointer;
}

.pdf-viewer-page .help-menu-close:hover {
    background: #4f46e5;
}

.pdf-viewer-page .settings-menu-overlay {
    z-index: 10001;
}

.pdf-viewer-page .settings-menu {
    max-width: 480px;
}

.pdf-viewer-page .settings-menu.settings-menu--dialog-footer {
    padding: 0;
    display: flex;
    flex-direction: column;
}

.pdf-viewer-page .settings-menu.settings-menu--dialog-footer .settings-menu-dialog-body {
    padding: 24px;
}

.pdf-viewer-page .settings-menu.settings-menu--dialog-footer .modal-footer {
    margin-top: 0;
    gap: 0;
    padding: 14px 16px;
    width: 100%;
    box-sizing: border-box;
}

.pdf-viewer-page .settings-menu.settings-menu--dialog-footer .modal-footer .btn-secondary,
.pdf-viewer-page .settings-menu.settings-menu--dialog-footer .modal-footer .btn-primary {
    flex: 0 0 auto;
    width: auto;
    min-height: 0;
    height: auto;
    padding: 8px 16px;
    font-size: 14px;
    line-height: 1.25;
    border-radius: 8px;
}

.pdf-viewer-page .settings-menu.settings-menu--dialog-footer .modal-footer .btn-secondary {
    font-weight: 500;
}

.pdf-viewer-page .settings-menu.settings-menu--dialog-footer .modal-footer .btn-primary {
    font-weight: 600;
    box-shadow: none;
    min-height: 0;
}

.pdf-viewer-page .settings-menu.settings-menu--dialog-footer .modal-footer .btn-primary:hover:not(:disabled) {
    transform: none;
}

.pdf-viewer-page .settings-menu-list {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.pdf-viewer-page .settings-menu-checkboxes-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.pdf-viewer-page .settings-menu-checkbox {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 14px;
    cursor: pointer;
    user-select: none;
}

.pdf-viewer-page .settings-menu-checkbox input {
    width: 18px;
    height: 18px;
    cursor: pointer;
}

.pdf-viewer-page .settings-menu-row {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.pdf-viewer-page .settings-menu-label {
    font-size: 14px;
    font-weight: 600;
    color: #1a365d;
}

.pdf-viewer-page .settings-menu-path-row {
    display: flex;
    align-items: center;
    gap: 12px;
}

.pdf-viewer-page .settings-menu-path-value {
    flex: 1;
    font-size: 13px;
    color: #6b7280;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.pdf-viewer-page .settings-menu-choose-btn {
    flex-shrink: 0;
    padding: 8px 16px;
    background: #6366f1;
    color: white;
    border: none;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
}

.pdf-viewer-page .settings-menu-choose-btn:hover {
    background: #4f46e5;
}

.pdf-viewer-page .settings-menu-clear-btn {
    flex-shrink: 0;
    padding: 8px 16px;
    background: #f1f5f9;
    color: #475569;
    border: none;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
}

.pdf-viewer-page .settings-menu-clear-btn:hover {
    background: #e2e8f0;
    color: #1e293b;
}

.pdf-viewer-page .editor-standard-menu {
    position: absolute;
    top: 52px;
    left: 12px;
    z-index: 999;
    background: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    margin-top: 20px;
    padding: 8px 16px 12px 16px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    min-width: 220px;
    max-width: min(420px, calc(100vw - 24px));
    overflow: hidden;
    box-sizing: border-box;
    transition:
        max-width 0.45s cubic-bezier(0.4, 0, 0.2, 1),
        padding 0.45s cubic-bezier(0.4, 0, 0.2, 1),
        border-radius 0.35s ease,
        box-shadow 0.45s ease,
        min-width 0.45s cubic-bezier(0.4, 0, 0.2, 1);
}

.pdf-viewer-page .editor-standard-menu--collapsed {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-width: 0;
    width: 44px;
    max-width: 44px;
    padding: 6px;
    box-sizing: border-box;
    border-radius: 10px;
    box-shadow: 0 3px 14px rgba(26, 54, 93, 0.12);
}

.pdf-viewer-page .editor-standard-menu-header {
    display: flex;
    flex-direction: column;
    gap: 4px;
    margin-bottom: 10px;
    transition: margin-bottom 0.35s ease;
}

.pdf-viewer-page .editor-standard-menu--collapsed .editor-standard-menu-header {
    margin-bottom: 0;
    width: 100%;
    align-items: center;
}

.pdf-viewer-page .editor-standard-menu-header-top {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    width: 100%;
}

.pdf-viewer-page .editor-standard-menu--collapsed .editor-standard-menu-header-top {
    position: relative;
    justify-content: center;
    gap: 0;
    width: auto;
    min-width: 0;
}

.pdf-viewer-page .editor-standard-menu-expandable {
    max-height: 2000px;
    opacity: 1;
    overflow: hidden;
    margin-top: 0;
    transition:
        max-height 0.48s cubic-bezier(0.4, 0, 0.2, 1),
        opacity 0.32s ease,
        margin-top 0.35s ease,
        visibility 0s linear 0s;
    visibility: visible;
}

.pdf-viewer-page .editor-standard-menu-expandable--collapsed {
    max-height: 0;
    opacity: 0;
    margin-top: 0;
    margin-bottom: 0;
    pointer-events: none;
    visibility: hidden;
    transition:
        max-height 0.42s cubic-bezier(0.4, 0, 0.2, 1),
        opacity 0.28s ease,
        margin-top 0.3s ease,
        visibility 0s linear 0.42s;
}

.pdf-viewer-page .editor-standard-menu-collapse-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 32px;
    height: 32px;
    padding: 0;
    border: 1px solid #e5e7eb;
    border-radius: 6px;
    background-color: #ffffff;
    color: #1a365d;
    cursor: pointer;
    transition:
        transform 0.28s cubic-bezier(0.34, 1.56, 0.64, 1),
        border-radius 0.35s ease,
        box-shadow 0.35s ease,
        background-color 0.2s ease,
        border-color 0.2s ease;
}

.pdf-viewer-page .editor-standard-menu-collapse-btn:hover {
    background-color: #f3f4f6;
}

.pdf-viewer-page .editor-standard-menu-collapse-btn:active {
    transform: scale(0.92);
}

.pdf-viewer-page .editor-standard-menu--collapsed .editor-standard-menu-collapse-btn--collapsed-only {
    border-radius: 8px;
    animation: editor-standard-collapse-btn-float 2.8s ease-in-out infinite;
}

@keyframes editor-standard-collapse-btn-float {
    0%,
    100% {
        box-shadow: 0 0 0 1px rgba(26, 54, 93, 0.06), 0 2px 10px rgba(26, 54, 93, 0.1);
    }
    50% {
        box-shadow: 0 0 0 1px rgba(26, 54, 93, 0.08), 0 3px 14px rgba(26, 54, 93, 0.14);
    }
}

.pdf-viewer-page .editor-standard-menu-collapse-btn-icon {
    display: block;
    transition: transform 0.35s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.pdf-viewer-page .editor-standard-menu-collapse-btn:hover .editor-standard-menu-collapse-btn-icon {
    transform: scale(1.12);
}

.pdf-viewer-page .editor-standard-menu--collapsed .editor-standard-menu-collapse-btn:hover .editor-standard-menu-collapse-btn-icon {
    transform: scale(1.15) translateY(1px);
}

.pdf-viewer-page .editor-standard-label {
    flex: 1 1 auto;
    min-width: 0;
    font-size: 12px;
    color: #6b7280;
    font-weight: 600;
    cursor: default;
    user-select: none;
    transition:
        opacity 0.3s ease,
        max-width 0.4s cubic-bezier(0.4, 0, 0.2, 1),
        margin 0.35s ease,
        transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

/* Label out of flex flow when collapsed so gap:8px does not offset the lone button */
.pdf-viewer-page .editor-standard-menu--collapsed .editor-standard-label {
    position: absolute;
    width: 0;
    height: 0;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    opacity: 0;
    margin: 0;
    padding: 0;
    border: 0;
    flex: none;
    transform: none;
    pointer-events: none;
    white-space: nowrap;
}

.pdf-viewer-page .editor-standard-value {
    font-size: 14px;
    color: #166534;
    font-weight: 600;
}

.pdf-viewer-page .editor-standard-value.editor-standard-error {
    color: #b91c1c;
}

.pdf-viewer-page .editor-standard-sentences {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.pdf-viewer-page .editor-standard-sentence {
    font-size: 13px;
    color: #166534;
    font-weight: 500;
}

.pdf-viewer-page .editor-standard-checkbox {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    cursor: pointer;
    margin-bottom: 8px;
}

.pdf-viewer-page .editor-standard-checkbox input {
    width: 18px;
    height: 18px;
    cursor: pointer;
}

.pdf-viewer-page .editor-standard-row {
    display: flex;
    flex-direction: column;
    gap: 4px;
    margin-bottom: 10px;
}

.pdf-viewer-page .editor-standard-row:last-child {
    margin-bottom: 0;
}

.pdf-viewer-page .editor-standard-row-hole-shaft {
    display: flex;
    flex-direction: row;
    gap: 16px;
}

.pdf-viewer-page .editor-standard-row-hole-shaft .editor-standard-row-item {
    display: flex;
    flex-direction: column;
    gap: 4px;
    flex: 1;
}

.pdf-viewer-page .editor-standard-sublabel {
    font-size: 12px;
    color: #6b7280;
    font-weight: 600;
    cursor: default;
    user-select: none;
}

.pdf-viewer-page .editor-standard-dropdown {
    width: 100%;
    padding: 8px 12px;
    font-size: 14px;
    border: 1px solid #d1d5db;
    border-radius: 6px;
    background: #fff;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

/* Text inputs in the same block keep I-beam (class order: dropdown + input) */
.pdf-viewer-page .editor-standard-input {
    cursor: text;
    -webkit-user-select: text;
    -moz-user-select: text;
    -ms-user-select: text;
    user-select: text;
}

.pdf-viewer-page .editor-standard-iso22081-inputs {
    display: flex;
    flex-direction: column;
    gap: 0;
}

.pdf-viewer-page .ocr-badge {
    position: absolute;
    top: -6px;
    right: -6px;
    background: #6366f1;
    color: #ffffff;
    font-size: 11px;
    font-weight: 700;
    min-width: 20px;
    height: 20px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 5px;
    line-height: 1;
}

@keyframes ocr-spin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
}

.pdf-viewer-page .ocr-spinner {
    animation: ocr-spin 1s linear infinite;
}

/* Make all info elements flex items with even spacing */
.pdf-viewer-page .info-item,
.pdf-viewer-page .info-center {
    flex: 1;
    text-align: center;
}

/* Purple color for measurement numbers */
.pdf-viewer-page .measurement-number {
    color: #3c2eb4;
}

/* Responsive adjustments */
@media (max-width: 768px) {
    .pdf-viewer-page .pdf-info-bar {
        flex-wrap: wrap;
        gap: 8px;
    }

    .pdf-viewer-page .info-center {
        order: -1;
        width: 100%;
        text-align: center;
        margin-bottom: 8px;
    }

    .pdf-viewer-page .measurement-legend-bar {
        flex-wrap: nowrap;
        justify-content: flex-start;
        gap: 8px;
        overflow-x: auto;
        overflow-y: visible;
        padding: 62px 12px 16px 12px;
    }

    .pdf-viewer-page .measurement-legend-item {
        font-size: 12px;
        padding: 2px 6px;
        height: 40px;
        box-sizing: border-box;
    }

    .pdf-viewer-page .measurement-legend-img {
        max-height: 32px;
        max-width: 150px;
        width: auto;
        height: auto;
    }

    .pdf-viewer-page .measurement-legend-img-placeholder {
        width: 32px;
        height: 32px;
        font-size: 14px;
    }

    .pdf-viewer-page .measurement-legend-number {
        width: 24px;
        height: 24px;
        font-size: 12px;
    }
}

/* Specific form variants inherit from base styles above */


.input-disabled {
    background: #f1f5f9;
    color: #94a3b8;
    cursor: not-allowed;
    border-color: #cbd5e1;
}

.input-disabled:focus {
    border-color: #cbd5e1;
    box-shadow: none;
    background: #f1f5f9;
}

.file-row {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    margin-bottom: 2rem;
}

.file-row>div {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
}

.file-btn {
    background: transparent;
    color: #4299e1;
    border: 2px solid #4299e1;
    padding: 1rem 2rem;
    border-radius: 16px;
    cursor: pointer;
    font-size: 1.2rem;
    font-weight: 600;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.8rem;
    box-shadow: 0 4px 6px rgba(66, 153, 225, 0.1);
    width: 100%;
    min-height: 48px;
}

.file-btn:hover {
    background: #4299e1;
    color: white;
    transform: translateY(-1px);
    box-shadow: 0 6px 12px rgba(66, 153, 225, 0.2);
}

.file-btn-error {
    background: transparent;
    color: #e53e3e;
    border-color: #e53e3e;
    box-shadow: 0 4px 6px rgba(229, 62, 62, 0.1);
}

.file-btn-error:hover {
    background: #e53e3e;
    color: white;
    transform: translateY(-1px);
    box-shadow: 0 6px 12px rgba(229, 62, 62, 0.2);
}

.file-btn-selected {
    background: #4299e1;
    color: white;
    border-color: #4299e1;
    box-shadow: 0 4px 6px rgba(66, 153, 225, 0.2);
}

.file-btn-selected:hover {
    background: #3182ce;
    border-color: #3182ce;
    transform: translateY(-1px);
    box-shadow: 0 6px 12px rgba(66, 153, 225, 0.3);
}

.pdf-icon {
    background: rgba(66, 153, 225, 0.1);
    padding: 0.4rem 0.7rem;
    border-radius: 8px;
    font-size: 1.1rem;
    font-weight: 700;
    transition: all 0.3s ease;
}

.file-btn:hover .pdf-icon {
    background: rgba(255, 255, 255, 0.2);
}

.file-btn-selected .pdf-icon {
    background: rgba(255, 255, 255, 0.2);
}

.file-name {
    color: #2d3748;
    font-size: 1.3rem;
    display: flex;
    align-items: center;
    gap: 0.8rem;
    font-weight: 500;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    padding-left: 0.5rem;
}

.file-img {
    font-size: 1.5rem;
}

.file-error {
    color: #e53e3e;
    font-size: 1rem;
    margin-top: 0.5rem;
    font-weight: 500;
    text-align: center;
}

.request-error {
    position: absolute;
    text-align: center;
    color: #e53e3e;
    font-size: 0.8rem;
    font-weight: 500;
}

/* Submit button inherits from .save-btn, .submit-button styles above */

.arrow {
    font-size: 1.4rem;
    transition: transform 0.3s ease;
}

.submit-btn:hover:not(:disabled) .arrow {
    transform: translateX(5px);
}

.checkbox-group {
    display: flex;
    justify-content: center;
    gap: 2rem;
    margin-bottom: 2rem;
}

.checkbox-label {
    position: relative;
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    font-size: 1.2rem;
    color: #6B7280;
    font-weight: 500;
    padding: 0.5rem;
    border-radius: 8px;
    transition: all 0.2s ease;
}

.checkbox-label:hover {
    color: #1a365d;
}

.checkbox-label input[type="checkbox"] {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
}

.checkbox-label .checkmark {
    position: relative;
    display: inline-block;
    width: 18px;
    height: 18px;
    background: white;
    border: 2px solid #D1D5DB;
    border-radius: 4px;
    transition: all 0.2s ease;
}

.checkbox-label:hover .checkmark {
    border-color: #1a365d;
}

.checkbox-label input[type="checkbox"]:checked~.checkmark {
    background: #1a365d;
    border-color: #1a365d;
}

.checkbox-label input[type="checkbox"]:checked~.checkmark:after {
    content: "";
    position: absolute;
    display: block;
    left: 50%;
    top: 45%;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 2px 2px 0;
    transform: translate(-50%, -50%) rotate(45deg);
}

.checkbox-label.active {
    color: #1a365d;
    font-weight: 600;
}

.hidden {
    display: none;
}



/* Registration page specific styles */
.btn-back {
    height: 52px;
    display: flex;
    justify-content: left;
    margin-top: 1rem;
    padding-top: 0.5rem;
    border-top: 1px solid #e2e8f0;
}

/* Material Design Dropdown Styles */
.material-dropdown {
    position: relative;
    width: 100%;
    margin: 0.5rem 0 0 0;
}

.dropdown-button {
    width: 100%;
    border: 1px solid #b0b4b9;
    padding: 1rem;
    font-size: 1rem;
    border-radius: 1rem;
    background: white;
    transition: all 0.2s ease;
    outline: none;
    color: #1a365d;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    text-align: left;
    font-family: inherit;
    min-height: 56px;
}

.dropdown-button.dropdown-open {
    border-color: #1a365d;
    box-shadow: 0 0 0 1px #1a365d;
}

.dropdown-button.dropdown-disabled {
    background: #f1f5f9;
    color: #94a3b8;
    cursor: not-allowed;
    border-color: #cbd5e1;
}

.dropdown-text {
    font-size: 1rem;
    flex: 1;
    color: inherit;
}

.dropdown-text:empty::before {
    content: attr(placeholder);
    color: #b0b4b9;
}

.dropdown-arrow {
    color: #b0b4b9;
    font-size: 0.8rem;
    transition: transform 0.2s ease;
    margin-left: 0.5rem;
}

.dropdown-arrow-open {
    transform: rotate(180deg);
    color: #1a365d;
}

.dropdown-menu {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background: white;
    border: 1px solid #b0b4b9;
    border-radius: 1rem;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    z-index: 1000;
    margin-top: 0.25rem;
    max-height: 200px;
    overflow-y: auto;
    animation: dropdownFadeIn 0.2s ease;
}

@keyframes dropdownFadeIn {
    from {
        opacity: 0;
        transform: translateY(-8px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.dropdown-option {
    padding: 1rem;
    color: #1a365d;
    cursor: pointer;
    transition: all 0.2s ease;
    border-bottom: 1px solid #f1f5f9;
    font-size: 1rem;
}

.dropdown-option:last-child {
    border-bottom: none;
}

.dropdown-option-focused {
    background: #e2e8f0;
    color: #1a365d;
}

.dropdown-option-selected {
    background: #1a365d;
    color: white;
    font-weight: 600;
}

.dropdown-option-selected:hover {
    background: #1a365d;
    color: white;
}

/* Pricing plans styles */
.pricing-plans-container {
    display: flex;
    flex-direction: row;
    margin-bottom: 2rem;
    gap: 1.5rem;
    justify-content: center;
}

.pricing-card {
    background: white;
    border-radius: 1rem;
    padding: 2rem;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    border: 2px solid #e2e8f0;
    transition: all 0.3s ease;
    min-width: 280px;
    max-width: 320px;
    width: 300px;
    flex: 0 0 auto;
    position: relative;
    display: flex;
    flex-direction: column;
}

.pricing-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
    border-color: #1a365d;
}

.pricing-card.selected {
    border-color: #1a365d;
    background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
}

.pricing-card-header {
    text-align: center;
    margin-bottom: 1.5rem;
}

.pricing-card-title {
    font-size: 1.5rem;
    font-weight: 700;
    color: #1a365d;
    margin-bottom: 0.5rem;
}

.pricing-card-price {
    font-size: 2.5rem;
    font-weight: 900;
    color: #1a365d;
    margin-bottom: 0.25rem;
}

.pricing-card-period {
    font-size: 1rem;
    color: #64748b;
    font-weight: 500;
}

.pricing-card-features {
    list-style: none;
    padding: 0;
    margin: 1.5rem 0;
    flex: 1;
}

.pricing-card-feature {
    display: flex;
    align-items: center;
    padding: 0.75rem 0;
    border-bottom: 1px solid #f1f5f9;
    font-size: 0.95rem;
    color: #475569;
}

.pricing-card-feature:last-child {
    border-bottom: none;
}

.pricing-card-feature-icon {
    width: 20px;
    height: 20px;
    margin-right: 0.75rem;
    color: #10b981;
    font-weight: bold;
}

.pricing-card-feature-text {
    flex: 1;
}

.pricing-card-feature-highlight {
    font-weight: 600;
    color: #1a365d;
}

.pricing-card-feature-comment {
    font-size: 0.9rem;
    color: #969da8;
    font-weight: 500;
    text-align: center;
}

.pricing-card-button {
    width: 100%;
    height: 52px;
    padding: 1rem;
    background: #1a365d;
    color: white;
    border: none;
    border-radius: 0.75rem;
    font-size: 1rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
    margin-top: auto;
}

.pricing-card-button-contact {
    width: 100%;
    height: 52px;
    padding: 1rem;
    background: white;
    color: #1a365d;
    border: 2px solid #1a365d;
    border-radius: 0.75rem;
    font-size: 1rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
    margin-top: auto;
}

.pricing-card-button-contact:hover {
    background: #1a365d;
    color: white;
    transform: translateY(-1px);
}

.pricing-card-button:hover {
    background: #2d4a6b;
    transform: translateY(-1px);
}


.pricing-card.selected .pricing-card-button {
    background: #10b981;
}

.pricing-card.selected .pricing-card-button:hover {
    background: #059669;
}

.remove-tools-section {
    margin-top: 2rem;
    display: flex;
    justify-content: center;
}

.remove-tools-card {
    background: white;
    border: 2px solid #e2e8f0;
    border-radius: 1rem;
    padding: 1.5rem;
    max-width: 300px;
    width: 100%;
    display: flex;
    flex-direction: column;
    transition: all 0.2s ease;
}

.remove-tools-card:hover {
    border-color: #cbd5e1;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.remove-tools-header {
    text-align: center;
    margin-bottom: 1rem;
}

.remove-tools-title {
    font-size: 1rem;
    font-weight: 600;
    color: #1a365d;
    margin-bottom: 0.5rem;
}

.remove-tools-price {
    font-size: 1.5rem;
    font-weight: 700;
    color: #1a365d;
    line-height: 1.2;
}

.remove-tools-period {
    font-size: 0.875rem;
    color: #64748b;
    margin-top: 0.25rem;
}

.remove-tools-description {
    font-size: 0.875rem;
    color: #64748b;
    text-align: center;
    margin-bottom: 1rem;
    line-height: 1.4;
}

.remove-tools-button {
    width: 100%;
    height: 44px;
    padding: 0.75rem;
    background: #1a365d;
    color: white;
    border: none;
    border-radius: 0.75rem;
    font-size: 0.9rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
    margin-top: auto;
}

.remove-tools-button:hover:not(:disabled) {
    background: #2d4a6b;
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(26, 54, 93, 0.2);
}


@media (max-width: 768px) {
    .pricing-plans-container {
        flex-direction: row;
        align-items: stretch;
        flex-wrap: wrap;
        justify-content: center;
        gap: 1rem;
    }

    .pricing-card {
        min-width: 250px;
        max-width: 280px;
        width: 250px;
        flex: 0 0 auto;
    }
}





/* Language switcher */

.language-switcher {
    position: absolute;
    top: 20px;
    right: 20px;
    display: flex;
    gap: 4px;
    z-index: 1000;
}

.lang-btn {
    padding: 8px 12px;
    background: #f3f4f6;
    border: 1px solid #d1d5db;
    border-radius: 6px;
    cursor: pointer;
    font-size: 12px;
    font-weight: 500;
    color: #6b7280;
    transition: all 0.2s ease;
    min-width: 50px;
}

.lang-btn:hover {
    background: #e5e7eb;
    border-color: #9ca3af;
}

.lang-btn.active {
    background: #1a365d;
    border-color: #1a365d;
    color: white;
}

.lang-btn.active:hover {
    background: #1a365d;
}

/* Contact Us page styles */
.contact-form-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
    padding: 2rem;
    padding-top: 4rem;
    padding-bottom: 4rem;
}

.contact-us-form {
    background: white;
    padding: 4rem;
    padding-bottom: 4rem;
    border-radius: 24px;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08);
    width: 100%;
    max-width: 700px;
    display: flex;
    flex-direction: column;
    backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.2);
    margin: 0;
    min-height: fit-content;
    position: relative;
}

.contact-us-header {
    text-align: center;
    margin-bottom: 1.5rem;
}

.contact-us-header h2 {
    font-size: 2.5rem;
    color: #1a365d;
    font-weight: 900;
    margin-bottom: 0.5rem;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
    letter-spacing: 2px;
}

.contact-us-header h3 {
    font-size: 1.5rem;
    color: #64748b;
    font-weight: 600;
    margin-bottom: 1rem;
}

.contact-us-description {
    font-size: 1.1rem;
    color: #64748b;
    line-height: 1.6;
    max-width: 500px;
    margin: 0 auto;
}

.character-counter {
    text-align: right;
    font-size: 0.875rem;
    color: #64748b;
    margin-top: 0.25rem;
    font-weight: 500;
}

.form-row {
    margin-bottom: 1.5rem;
}

.form-row label {
    display: block;
    margin-bottom: 0.5rem;
    font-size: 1rem;
    color: #2d3748;
    font-weight: 600;
}

.form-row input,
.form-row textarea {
    width: 100%;
    border: 1px solid #b0b4b9;
    padding: 1rem;
    margin: 0.5rem 0 0 0;
    font-size: 1rem;
    border-radius: 1rem;
    background: white;
    transition: all 0.2s ease;
    outline: none;
    color: #1a365d;
    font-family: inherit;
}

.form-row input:focus,
.form-row textarea:focus {
    box-shadow: 0 0 0 1px #1a365d;
}

.form-row input::placeholder,
.form-row textarea::placeholder {
    color: #b0b4b9;
    font-size: 0.9rem;
}

.form-row textarea {
    resize: vertical;
    min-height: 120px;
}

.input-error {
    border-color: #e53e3e !important;
    box-shadow: 0 0 0 1px #e53e3e !important;
}

.error-message {
    color: #e53e3e;
    font-size: 0.9rem;
    margin-top: 0.1rem;
    display: block;
    font-weight: 500;
}

.success-message {
    background: #d1fae5;
    color: #065f46;
    padding: 1rem;
    border-radius: 0.75rem;
    margin-bottom: 1.5rem;
    border: 1px solid #a7f3d0;
    font-weight: 500;
    text-align: center;
}

.form-actions {
    display: flex;
    gap: 1rem;
    align-items: center;
    padding-top: 1.5rem;
    border-top: 1px solid #e2e8f0;
}

.form-actions .btn-back {
    background: none;
    color: #64748b;
    border: 2px solid #cbd5e1;
    padding: 1rem 2rem;
    border-radius: 0.75rem;
    font-size: 1rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
    text-decoration: none;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 120px;
    min-height: 48px;
}

.form-actions .btn-back:hover {
    background: #f1f5f9;
    border-color: #94a3b8;
    color: #475569;
}

.form-actions .btn-active {
    flex: 1;
    background: #1a365d;
    color: white;
    border: 2px solid #1a365d;
    border-radius: 0.75rem;
    padding: 1rem 2rem;
    font-size: 1rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
    min-height: 48px;
}

.form-actions .btn-active:hover:not(:disabled) {
    background: #2d4a6b;
    border-color: #2d4a6b;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(26, 54, 93, 0.3);
}



@media (max-width: 768px) {
    .contact-form-wrapper {
        padding: 1rem;
        padding-top: 2rem;
        padding-bottom: 2rem;
    }

    .contact-us-form {
        padding: 2rem;
        padding-bottom: 2rem;
        margin: 0;
    }

    .contact-us-header h2 {
        font-size: 2rem;
    }

    .contact-us-header h3 {
        font-size: 1.25rem;
    }

    .form-actions {
        flex-direction: column;
        gap: 1rem;
    }

    .form-actions .btn-back,
    .form-actions .btn-active {
        width: 100%;
    }
}

/* No Connection Page Styles */
.no-connection-page {
    width: 100%;
    height: 100vh;
    background: linear-gradient(135deg, #f6f9fc 0%, #eef2f7 100%);
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 2rem;
}

.no-connection-container {
    max-width: 600px;
    width: 100%;
    text-align: center;
    background: white;
    border-radius: 20px;
    padding: 3rem 2rem;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.2);
}

.no-connection-icon {
    margin-bottom: 2rem;
    color: #e74c3c;
    display: flex;
    justify-content: center;
}

.no-connection-icon svg {
    filter: drop-shadow(0 4px 8px rgba(231, 76, 60, 0.3));
}

.no-connection-title {
    font-size: 2.5rem;
    font-weight: 900;
    color: #2c3e50;
    margin-bottom: 1.5rem;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
}

.no-connection-description {
    font-size: 1.2rem;
    color: #5a6c7d;
    line-height: 1.6;
    margin-bottom: 2rem;
    max-width: 500px;
    margin-left: auto;
    margin-right: auto;
}

.no-connection-tips {
    background: #f8f9fa;
    border-radius: 15px;
    padding: 2rem;
    margin-bottom: 2rem;
    text-align: left;
    border-left: 4px solid #3498db;
}

.no-connection-tips h3 {
    font-size: 1.3rem;
    color: #2c3e50;
    margin-bottom: 1rem;
    text-align: center;
}

.no-connection-tips ul {
    list-style: none;
    padding: 0;
}

.no-connection-tips li {
    padding: 0.5rem 0;
    color: #5a6c7d;
    position: relative;
    padding-left: 2rem;
}

.no-connection-tips li::before {
    content: "✓";
    position: absolute;
    left: 0;
    color: #27ae60;
    font-weight: bold;
    font-size: 1.1rem;
}

.retry-button {
    background: linear-gradient(135deg, #3498db 0%, #2980b9 100%);
    color: white;
    border: none;
    padding: 1rem 2.5rem;
    font-size: 1.1rem;
    font-weight: 600;
    border-radius: 50px;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 8px 20px rgba(52, 152, 219, 0.3);
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.retry-button:hover {
    transform: translateY(-2px);
    box-shadow: 0 12px 25px rgba(52, 152, 219, 0.4);
    background: linear-gradient(135deg, #2980b9 0%, #1f5f8b 100%);
}

.retry-button:active {
    transform: translateY(0);
    box-shadow: 0 6px 15px rgba(52, 152, 219, 0.3);
}

.retry-button:disabled {
    background: linear-gradient(135deg, #bdc3c7 0%, #95a5a6 100%);
    box-shadow: 0 4px 10px rgba(149, 165, 166, 0.3);
}

.retry-button:disabled:hover {
    box-shadow: 0 4px 10px rgba(149, 165, 166, 0.3);
    background: linear-gradient(135deg, #bdc3c7 0%, #95a5a6 100%);
}

/* Responsive design for no connection page */
@media (max-width: 768px) {
    .no-connection-page {
        padding: 1rem;
    }

    .no-connection-container {
        padding: 2rem 1.5rem;
    }

    .no-connection-title {
        font-size: 2rem;
    }

    .no-connection-description {
        font-size: 1.1rem;
    }

    .no-connection-tips {
        padding: 1.5rem;
    }

    .retry-button {
        padding: 0.8rem 2rem;
        font-size: 1rem;
    }
}

@media (max-width: 480px) {
    .no-connection-container {
        padding: 1.5rem 1rem;
    }

    .no-connection-title {
        font-size: 1.8rem;
    }

    .no-connection-description {
        font-size: 1rem;
    }

    .no-connection-tips {
        padding: 1rem;
    }

    .no-connection-tips h3 {
        font-size: 1.1rem;
    }
}

/* Legacy spinner keyframes (e.g. inline buttons); full-page loading uses EngineeringLoadingScreen */
@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

/* Dashboard main title */
.dashboard-main-title {
    font-size: 1.3rem;
    color: #1a365d;
    font-weight: 300;
    text-align: center;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
    letter-spacing: 2px;
    position: fixed;
    bottom: 12rem;
    right: 0rem;
    transform: rotate(-90deg);
    transform-origin: right bottom;
    z-index: 900;
}

/* User Profile */
.user-profile {
    position: fixed;
    top: 1rem;
    right: 1.5rem;
    display: flex;
    align-items: center;
    gap: 12px;
    height: 2.875rem;
    padding: 0 16px 0 20px;
    background: white;
    border: 2px solid #e5e7eb;
    border-radius: 50px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    z-index: 1000;
    transition: all 0.2s ease;
    cursor: pointer;
}

.user-profile:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
    border-color: #1a365d;
    transform: translateY(-1px);
}

.user-profile-name {
    font-size: 14px;
    font-weight: 400;
    color: #1a365d;
}

.user-profile-avatar {
    width: 2rem;
    height: 2rem;
    border-radius: 50%;
    overflow: hidden;
    flex-shrink: 0;
}

.user-avatar-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.user-avatar-placeholder {
    width: 100%;
    height: 100%;
    background: linear-gradient(135deg, #3ece81 0%, #2eb872 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 14px;
    font-weight: 700;
}

/* Profile Page Styles */
.profile-container {
    background: white;
    padding: 3rem;
    border-radius: 24px;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08);
    width: 100%;
    max-width: 700px;
    margin-top: 0;
    margin-bottom: 2rem;
}

.profile-title {
    font-size: 2rem;
    color: #1a365d;
    margin-bottom: 2rem;
    text-align: center;
    font-weight: 700;
}

.profile-content {
    margin-bottom: 2rem;
}

.profile-section {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
}

.profile-field {
    display: flex;
    flex-direction: column;
    gap: 0;
}

.language-buttons {
    display: flex;
    gap: 0.75rem;
    margin-top: 0.5rem;
    flex-wrap: wrap;
}

.language-flag-btn {
    background: white;
    color: #1a365d;
    border: 2px solid #cad1dc;
    box-shadow: 0 4px 8px rgba(26, 54, 93, 0.1);
    border-radius: 12px;
    padding: 8px 16px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 45px;
    height: 40px;
    line-height: 1;
}

.language-flag-btn:hover {
    background: #f9fafb;
    border-color: #1a365d;
    transform: translateY(-2px);
    box-shadow: 0 6px 12px rgba(26, 54, 93, 0.2);
}

.language-flag-btn-active {
    background: #1a365d;
    color: #ffffff;
    border-color: #1a365d;
    box-shadow: 0 4px 12px rgba(26, 54, 93, 0.25);
}

.language-flag-btn-active:hover {
    background: #2c5282;
    border-color: #2c5282;
    transform: translateY(-2px);
    box-shadow: 0 6px 14px rgba(26, 54, 93, 0.3);
}

/* Profile: PDF workflow mode toggle (segmented control, navy selected state) */
.profile-segment-buttons {
    display: flex;
    gap: 0.75rem;
    margin-top: 0.5rem;
    flex-wrap: wrap;
}

.profile-segment-btn {
    background: white;
    color: #1a365d;
    border: 2px solid #cad1dc;
    box-shadow: 0 4px 8px rgba(26, 54, 93, 0.1);
    border-radius: 12px;
    padding: 8px 16px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-height: 40px;
    line-height: 1;
}

.profile-segment-btn:hover:not(:disabled) {
    background: #f9fafb;
    border-color: #1a365d;
    transform: translateY(-2px);
    box-shadow: 0 6px 12px rgba(26, 54, 93, 0.2);
}

.profile-segment-btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
}

.profile-segment-btn-active {
    background: #1a365d;
    color: #ffffff;
    border-color: #1a365d;
    box-shadow: 0 4px 12px rgba(26, 54, 93, 0.25);
}

.profile-segment-btn-active:hover:not(:disabled) {
    background: #2c5282;
    border-color: #2c5282;
    transform: translateY(-2px);
    box-shadow: 0 6px 14px rgba(26, 54, 93, 0.3);
}

.profile-pdf-workflow-hint {
    margin: 0.5rem 0 0;
    padding: 0;
    font-size: 0.8125rem;
    line-height: 1.45;
    color: #6b7280;
    font-weight: 400;
    background: transparent;
    border: none;
}

.profile-pdf-workflow-hint--success {
    color: #059669;
}

.profile-label {
    font-size: 0.9rem;
    font-weight: 600;
    color: #6b7280;
    letter-spacing: 0.5px;
    margin-bottom: 0px;
}

.profile-value {
    font-size: 1.1rem;
    color: #1a365d;
    font-weight: 400;
    padding: 0.75rem 1rem;
    background: #f9fafb;
    border-radius: 8px;
    border: 1px solid #e5e7eb;
}

.profile-field-input-group {
    display: flex;
    gap: 0.75rem;
    align-items: flex-start;
}

.profile-logo-row {
    display: flex;
    gap: 1rem;
    align-items: center;
    flex-wrap: wrap;
}

.profile-logo-preview {
    width: 80px;
    height: 80px;
    object-fit: contain;
    background: #ffffff;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    padding: 0.5rem;
}

.profile-logo-actions {
    display: flex;
    gap: 0.75rem;
    align-items: center;
    flex-wrap: wrap;
}

.profile-secondary-btn {
    padding: 0.75rem 1.5rem;
    font-size: 0.95rem;
    font-weight: 600;
    color: #1a365d;
    background: #ffffff;
    border: 1px solid #d1d5db;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s ease;
    white-space: nowrap;
}

.profile-secondary-btn:hover:not(:disabled) {
    background: #f9fafb;
    transform: translateY(-1px);
    box-shadow: 0 4px 6px rgba(17, 24, 39, 0.08);
}


.profile-logo-modal-preview {
    width: 140px;
    height: 140px;
    object-fit: contain;
    background: #ffffff;
    border: 1px solid #e5e7eb;
    border-radius: 12px;
    padding: 0.75rem;
}

.profile-logo-modal-controls {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
}

.profile-file-input {
    width: 100%;
}

.profile-checkbox-row {
    display: flex;
    gap: 0.5rem;
    align-items: center;
}

.profile-input {
    width: 100%;
    font-size: 1.1rem;
    color: #1a365d;
    font-weight: 500;
    padding: 0.75rem 1rem;
    background: #ffffff;
    border-radius: 8px;
    border: 1px solid #e5e7eb;
    transition: border-color 0.2s ease;
    margin-top: 0px !important;
}

.profile-input:focus {
    outline: none;
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.profile-input:disabled {
    background: #f9fafb;
    cursor: not-allowed;
    opacity: 0.6;
}

.profile-save-btn {
    padding: 0.75rem 1.5rem;
    font-size: 0.95rem;
    font-weight: 600;
    color: #ffffff;
    background: #3b82f6;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s ease;
    white-space: nowrap;
}

.profile-save-btn:hover:not(:disabled) {
    background: #2563eb;
    transform: translateY(-1px);
    box-shadow: 0 4px 6px rgba(59, 130, 246, 0.2);
}

.profile-save-btn:active:not(:disabled) {
    transform: translateY(0);
}


.profile-error-message {
    font-size: 0.875rem;
    color: #ef4444;
    margin-top: 0.25rem;
    padding-left: 0.25rem;
}

.profile-actions {
    display: flex;
    justify-content: center;
    gap: 1rem;
    margin-top: 2rem;
    flex-wrap: wrap;
}

/* Logout button */
.logout-btn {
    position: fixed;
    top: 1rem;
    left: 1rem;
    background: white;
    color: #6b7280;
    border: 2px solid #e5e7eb;
    border-radius: 12px;
    height: 2.875rem;
    padding: 0 24px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
}

.logout-btn:hover {
    background: #f3f4f6;
    border-color: #9ca3af;
}

/* Profile back button */
.profile-back-btn {
    position: fixed;
    top: 1rem;
    left: 1rem;
    background: white;
    color: #6b7280;
    border: 2px solid #e5e7eb;
    border-radius: 12px;
    padding: 12px;
    width: 48px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s ease;
    z-index: 1000;
}

.profile-back-btn:hover {
    background: #f3f4f6;
    border-color: #9ca3af;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.profile-back-btn svg {
    width: 24px;
    height: 24px;
}

/* Admin/Manager Panel */
.admin-panel {
    background: white;
    padding: 4rem;
    border-radius: 24px;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08);
    width: 100%;
    max-width: 800px;
    text-align: center;
}

.admin-panel-header {
    margin-bottom: 3rem;
}

.admin-panel-header .title {
    font-size: 3rem;
    color: #1a365d;
    margin-bottom: 1.5rem;
    font-weight: 800;
    text-align: center;
}

.admin-role-badge {
    text-align: center;
    padding: 1rem;
    border-radius: 12px;
    font-size: 1.4rem;
    color: #1a365d;
    font-weight: 600;
}

.admin-role-badge.admin-badge {
    background-color: #fee2e2;
    border: 2px solid #ef4444;
}

.admin-role-badge.manager-badge {
    background-color: #fef3c7;
    border: 2px solid #f59e0b;
}

.company-name-above-search {
    font-size: 2.5rem;
    color: #1a365d;
    font-weight: 700;
    text-align: center;
    margin-bottom: 1.5rem;
}

.admin-search-container {
    display: flex;
    gap: 1rem;
    align-items: center;
    justify-content: center;
}

.admin-search-input {
    flex: 1;
    width: 100%;
    height: 52px;
    border: 2px solid #e2e8f0;
    padding: 1.2rem;
    font-size: 1.4rem;
    border-radius: 16px;
    background: #f8fafc;
    transition: all 0.3s ease;
    color: #2d3748;
}

.admin-search-input:focus {
    outline: none;
    border-color: #1a365d;
    box-shadow: 0 0 0 1px #1a365d;
}

.admin-search-input.input-error {
    border-color: #ef4444;
    box-shadow: 0 0 0 1px #ef4444;
}

.admin-search-input.input-error:focus {
    border-color: #ef4444;
    box-shadow: 0 0 0 2px #ef4444;
}

.email-error-message {
    color: #ef4444;
    font-size: 0.95rem;
    margin-top: 0.75rem;
    text-align: center;
    font-weight: 500;
}

.email-success-message {
    color: #10b981;
    font-size: 0.95rem;
    margin-top: 0.75rem;
    text-align: center;
    font-weight: 500;
}

/* Organization logo preview on registration form */
.organization-logo-row {
    margin-top: 0.5rem;
    display: flex;
    align-items: flex-start;
    gap: 1rem;
}

.organization-logo-label {
    flex: 0 0 50%;
    max-width: 50%;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}

.organization-logo-input-wrapper {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}

.organization-logo-header-row {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    width: 100%;
    justify-content: center;
}

.organization-logo-title-text {
    font-size: 1rem;
    font-weight: 600;
    color: #2d3748;
}

.organization-logo-or-text {
    flex: 1;
    text-align: center;
    font-size: 0.9rem;
    color: #4b5563;
}

.organization-logo-preview {
    flex: 0 0 50%;
    max-width: 50%;
    display: flex;
    justify-content: center;
}

.organization-logo-preview img {
    max-width: 100%;
    max-height: 120px;
    border-radius: 8px;
    border: 1px solid #e2e8f0;
    object-fit: contain;
    background-color: #f8fafc;
}

.organization-logo-input-hidden {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    border: 0;
    clip: rect(0, 0, 0, 0);
    overflow: hidden;
}

.organization-logo-icon-button {
    width: 100%;
    min-height: 48px;
    border-radius: 8px;
    border: 2px dashed #cbd5e1;
    background-color: #f8fafc;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: border-color 0.2s ease, background-color 0.2s ease;
    font-size: 1rem;
    color: #1f2933;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.organization-logo-icon-button i {
    font-size: 1.6rem;
}

.organization-logo-icon-button:hover {
    border-color: #94a3b8;
    background-color: #e2e8f0;
}

/* Default logo checkbox on registration form */
.organization-logo-default-row {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 0.9rem;
    margin-left: auto;
}

.organization-logo-default-row label {
    display: flex;
    align-items: center;
    gap: 0.5rem;
}

.container .organization-logo-header-row .organization-logo-default-row input[type="checkbox"],
form .organization-logo-header-row .organization-logo-default-row input[type="checkbox"],
.organization-logo-header-row .organization-logo-default-row input[type="checkbox"] {
    width: 20px !important;
    height: 20px !important;
    margin: 0 !important;
    margin-top: 0px !important;
    padding: 0 !important;
    border-radius: 3px !important;
    background-color: white !important;
    background: white !important;
    border: 1px solid #b0b4b9 !important;
    appearance: none !important;
    -webkit-appearance: none !important;
    -moz-appearance: none !important;
    cursor: pointer !important;
    box-sizing: border-box !important;
}

.container .organization-logo-header-row .organization-logo-default-row input[type="checkbox"]:checked,
form .organization-logo-header-row .organization-logo-default-row input[type="checkbox"]:checked,
.organization-logo-header-row .organization-logo-default-row input[type="checkbox"]:checked {
    background-color: white !important;
    background: white !important;
    border-color: #1a365d !important;
    position: relative !important;
}

.container .organization-logo-header-row .organization-logo-default-row input[type="checkbox"]:checked::after,
form .organization-logo-header-row .organization-logo-default-row input[type="checkbox"]:checked::after,
.organization-logo-header-row .organization-logo-default-row input[type="checkbox"]:checked::after {
    content: "" !important;
    position: absolute !important;
    left: 50% !important;
    top: 45% !important;
    width: 5px !important;
    height: 10px !important;
    border: solid #d12626 !important;
    border-width: 0 2px 2px 0 !important;
    transform: translate(-50%, -50%) rotate(45deg) !important;
}

/* Company Members Section */
.company-members-section {
    padding-top: 2rem;
}

.members-title {
    font-size: 1.5rem;
    font-weight: 700;
    color: #1a365d;
    margin-bottom: 1.5rem;
    text-align: left;
}

.loading-members {
    text-align: center;
    padding: 2rem;
    color: #64748b;
    font-size: 1rem;
}

.members-list {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
}

.member-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1rem 1.25rem;
    background: white;
    border: 2px solid #e2e8f0;
    border-radius: 12px;
    transition: all 0.2s ease;
}

.member-item:hover {
    border-color: #cbd5e1;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.member-info {
    display: flex;
    align-items: center;
    flex: 1;
}

.member-email {
    font-size: 1rem;
    color: #1a365d;
    font-weight: 500;
}

.member-actions {
    display: flex;
    align-items: center;
    gap: 1.5rem;
}

.member-role-selector {
    display: flex;
    gap: 1rem;
    align-items: center;
}

.member-action-buttons {
    display: flex;
    align-items: center;
    gap: 0.5rem;
}

.role-box {
    padding: 0.5rem 1.25rem;
    border: 2px solid #cbd5e1;
    border-radius: 8px;
    cursor: pointer;
    font-size: 0.95rem;
    color: #64748b;
    font-weight: 600;
    transition: all 0.3s ease;
    user-select: none;
    background: white;
    box-shadow: 0 0 0 0 transparent;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.role-box:hover {
    border-color: #94a3b8;
}

.role-box.selected {
    border-color: #475569;
    color: white;
    background: #475569;
}

.role-box.from-db {
    border-color: #475569;
    color: white;
    background: #475569;
}

.member-action-btn {
    width: 36px;
    height: 36px;
    background: white;
    color: #6b7280;
    border: 2px solid #cbd5e1;
    border-radius: 8px;
    font-size: 1.5rem;
    font-weight: 700;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
    line-height: 1;
    padding: 0;
    min-width: 36px;
    min-height: 36px;
    max-width: 36px;
    max-height: 36px;
}

.member-action-btn svg {
    display: block;
}

.save-btn {
    border-color: #10b981;
}

.save-btn:hover:not(:disabled) {
    background: #d1fae5;
    border-color: #059669;
    color: #374151;
    transform: scale(1.1);
}

.save-btn:disabled {
    border-color: #cbd5e1;
    opacity: 0.5;
}

.delete-btn {
    border-color: #ef4444;
}

.delete-btn:hover {
    background: #fef2f2;
    border-color: #dc2626;
    color: #374151;
    transform: scale(1.1);
}

.member-action-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    transform: none;
}

.no-members {
    text-align: center;
    padding: 2rem;
    color: #94a3b8;
    font-size: 1rem;
    font-style: italic;
}

.company-tools-section {
    padding-top: 4rem;
}

.tools-section-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1.5rem;
    flex-wrap: wrap;
    gap: 1rem;
}

.save-all-colors-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    background: #3ece81;
    color: white;
    border: none;
    border-radius: 12px;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 4px 8px rgba(72, 187, 120, 0.2);
    padding: 0;
}

.save-all-colors-btn:hover:not(:disabled) {
    background: #2db86a;
    transform: translateY(-1px);
    box-shadow: 0 6px 12px rgba(72, 187, 120, 0.3);
}


.save-all-colors-btn svg {
    width: 20px;
    height: 20px;
    flex-shrink: 0;
}

.tools-title-wrapper {
    display: flex;
    align-items: center;
    gap: 0.75rem;
}

.tools-title {
    font-size: 1.5rem;
    font-weight: 700;
    color: #1a365d;
    margin: 0;
}

.tools-add-container {
    position: relative;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    flex-wrap: wrap;
}

.tool-error-message {
    color: #ef4444;
    font-size: 0.9rem;
    margin-right: 0.5rem;
    white-space: nowrap;
}

.add-tool-button {
    background: #3ece81;
    color: white;
    border: none;
    box-shadow: 0 4px 8px rgba(72, 187, 120, 0.2);
    border-radius: 12px;
    padding: 0;
    font-size: 1rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
}

.add-tool-button:hover:not(:disabled) {
    background: #2db86a;
    box-shadow: 0 6px 12px rgba(72, 187, 120, 0.3);
    transform: translateY(-1px);
}


.add-tool-button svg {
    width: 20px;
    height: 20px;
}

.add-custom-tool-button {
    background: #6366f1;
    width: auto;
    padding: 0.75rem 1.5rem;
    min-width: 44px;
}

.add-custom-tool-button:hover:not(:disabled) {
    background: #4f46e5;
    box-shadow: 0 6px 12px rgba(99, 102, 241, 0.3);
    transform: translateY(-1px);
}


.tools-dropdown {
    position: absolute;
    top: 100%;
    right: 0;
    margin-top: 0.5rem;
    background: white;
    border: 2px solid #e2e8f0;
    border-radius: 12px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
    z-index: 1000;
    min-width: 250px;
    max-height: 400px;
    overflow-y: auto;
}

.tool-dropdown-item {
    display: flex;
    align-items: center;
    gap: 1rem;
    padding: 1rem 1.25rem;
    cursor: pointer;
    transition: all 0.2s ease;
    border-bottom: 1px solid #f1f5f9;
}

.tool-dropdown-item:last-child {
    border-bottom: none;
}

.tool-dropdown-item:hover {
    background: #f8fafc;
}

.tool-dropdown-image {
    width: 40px;
    height: 40px;
    object-fit: contain;
}

.tool-dropdown-empty {
    padding: 1.5rem;
    text-align: center;
    color: #94a3b8;
    font-size: 0.95rem;
}

.loading-tools {
    text-align: center;
    padding: 2rem;
    color: #64748b;
    font-size: 1rem;
}

.tools-list {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
    gap: 1.25rem;
    padding: 0.5rem 0;
}

.tool-card {
    display: flex;
    flex-direction: column;
    background: white;
    border: 2px solid #e2e8f0;
    border-radius: 16px;
    padding: 1rem;
    transition: all 0.2s ease;
    position: relative;
    overflow: visible;
}

.tool-card:hover {
    border-color: #cbd5e1;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    transform: translateY(-2px);
}

.tool-card-header {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    margin-bottom: 0.75rem;
}

.tool-card-header .tool-delete-button {
    margin-left: auto;
}

.tool-badge-wrapper {
    position: relative;
    display: flex;
    align-items: center;
    gap: 0.5rem;
}

.tool-number-badge {
    min-width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #1a365d;
    border-radius: 8px;
    font-size: 0.875rem;
    font-weight: 700;
    flex-shrink: 0;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.tool-number-badge-clickable {
    cursor: pointer;
    transition: all 0.2s ease;
}

.tool-number-badge-clickable:hover {
    transform: scale(1.05);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.tool-color-picker-input {
    position: absolute;
    opacity: 0;
    width: 0;
    height: 0;
    pointer-events: none;
}

.tool-save-color-btn {
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #10b981;
    color: white;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.2s ease;
    padding: 0;
    box-shadow: 0 2px 4px rgba(16, 185, 129, 0.2);
}

.tool-save-color-btn:hover {
    background: #059669;
    transform: scale(1.1);
    box-shadow: 0 4px 8px rgba(16, 185, 129, 0.3);
}

.tool-save-color-btn:active {
    transform: scale(0.95);
}

.tool-save-color-btn svg {
    width: 14px;
    height: 14px;
}

.tool-remove-btn {
    width: 28px;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    color: #64748b;
    cursor: pointer;
    transition: all 0.2s ease;
    padding: 0;
}

.tool-remove-btn:hover {
    background: #fee2e2;
    border-color: #fca5a5;
    color: #dc2626;
}

.tool-precision-class {
    font-size: 0.875rem;
    color: #6b7280;
    white-space: nowrap;
    flex: 1;
    text-align: center;
}

.tool-delete-button {
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    color: #64748b;
    cursor: pointer;
    transition: all 0.2s ease;
    padding: 0;
    flex-shrink: 0;
}

.tool-delete-button:hover:not(:disabled) {
    background: #fee2e2;
    border-color: #fca5a5;
    color: #dc2626;
    transform: scale(1.05);
}

.tool-delete-button:disabled {
    opacity: 0.5;
}

.tool-delete-button svg {
    width: 16px;
    height: 16px;
}

.tool-remove-btn:disabled {
    opacity: 0.5;
}

.tool-card-image {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 120px;
    height: 180px;
    margin-bottom: 0.75rem;
    padding: 0.5rem;
    flex: 1;
    position: relative;
    overflow: visible;
}

.tool-image {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.tool-image-placeholder {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f1f5f9;
    border: 2px dashed #cbd5e1;
    border-radius: 8px;
    color: #94a3b8;
}

.tool-card-image {
    position: relative;
}

.tool-card-footer {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 0.5rem;
    border-top: 1px solid #f1f5f9;
}

.tool-name {
    font-size: 0.875rem;
    font-weight: 500;
    color: #1e293b;
    text-align: center;
    line-height: 1.4;
}

.min-precision-dropdown-container {
    position: absolute;
    bottom: 0.25rem;
    right: 0.25rem;
    z-index: 20;
}

.tool-min-precision {
    position: absolute;
    bottom: 0.25rem;
    right: 0.25rem;
    font-size: 0.875rem;
    color: #6b7280;
    white-space: nowrap;
    z-index: 10;
}

.min-precision-dropdown-button {
    display: flex;
    align-items: center;
    gap: 0.25rem;
    padding: 0.375rem 0.625rem;
    font-size: 0.75rem;
    font-weight: 500;
    color: #374151;
    background-color: #ffffff;
    border: 1px solid #d1d5db;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.2s ease;
}

.min-precision-dropdown-button:hover:not(:disabled) {
    background-color: #f9fafb;
    border-color: #9ca3af;
}

.min-precision-dropdown-button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.min-precision-value {
    min-width: 2rem;
    text-align: center;
}

.min-precision-dropdown {
    position: absolute;
    bottom: 100%;
    right: 0;
    margin-bottom: 0.25rem;
    background-color: #ffffff;
    border: 1px solid #d1d5db;
    border-radius: 6px;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
    z-index: 30;
    min-width: 4rem;
    overflow: hidden;
}

.min-precision-option {
    display: block;
    width: 100%;
    padding: 0.5rem 0.75rem;
    font-size: 0.75rem;
    font-weight: 500;
    color: #374151;
    background-color: #ffffff;
    border: none;
    border-bottom: 1px solid #f3f4f6;
    cursor: pointer;
    text-align: center;
    transition: background-color 0.15s ease;
}

.min-precision-option:last-child {
    border-bottom: none;
}

.min-precision-option:hover {
    background-color: #f9fafb;
}

.min-precision-option.active {
    background-color: #2563eb;
    color: #ffffff;
}

.min-precision-option.active:hover {
    background-color: #1d4ed8;
}

@media (max-width: 768px) {
    .tools-list {
        grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
        gap: 1rem;
    }

    .tool-card {
        padding: 0.75rem;
    }

    .tool-card-image {
        min-height: 100px;
        height: 140px;
    }

    .tool-image {
        width: 100%;
        height: 100%;
    }

    .tool-image-placeholder {
        width: 100%;
        height: 100%;
    }
}

@media (max-width: 480px) {
    .tools-list {
        grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
        gap: 0.75rem;
    }

    .tool-card {
        padding: 0.625rem;
    }

    .tool-card-image {
        min-height: 80px;
        height: 100px;
    }

    .tool-image {
        width: 100%;
        height: 100%;
    }

    .tool-image-placeholder {
        width: 100%;
        height: 100%;
    }

    .tool-name {
        font-size: 0.8125rem;
    }
}

.custom-tool-image-preview {
    position: relative;
    margin-top: 1rem;
    display: inline-block;
}

.preview-image {
    max-width: 200px;
    max-height: 200px;
    border-radius: 8px;
    border: 2px solid #e2e8f0;
    object-fit: contain;
}

.remove-preview-btn {
    position: absolute;
    top: -8px;
    right: -8px;
    width: 24px;
    height: 24px;
    background: #ef4444;
    color: white;
    border: none;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.remove-preview-btn:hover {
    background: #dc2626;
    transform: scale(1.1);
}

.remove-preview-btn svg {
    width: 14px;
    height: 14px;
}

.color-picker-wrapper {
    position: relative;
    margin-top: 0.5rem;
}

.color-picker-input {
    position: absolute;
    opacity: 0;
    width: 0;
    height: 0;
    pointer-events: none;
}

.color-picker-button {
    display: inline-flex;
    align-items: center;
    gap: 0.75rem;
    padding: 0.75rem 1.5rem;
    background: white;
    border: 1px solid #b0b4b9;
    border-radius: 12px;
    cursor: pointer;
    transition: all 0.2s ease;
    width: 100%;
    height: 44px;
    justify-content: flex-start;
}

.color-picker-button:hover {
    border-color: #1a365d;
    box-shadow: 0 0 0 1px #1a365d;
}

.color-picker-preview {
    width: 32px;
    height: 32px;
    border-radius: 8px;
    border: 2px solid #e2e8f0;
    flex-shrink: 0;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.875rem;
    font-weight: 600;
    color: #1a365d;
}

.color-picker-text {
    font-size: 1rem;
    color: #1a365d;
    font-weight: 500;
}

.form-group {
    margin-bottom: 1.5rem;
}

.form-group label {
    display: block;
    margin-bottom: 0.5rem;
    font-size: 1rem;
    color: #2d3748;
    font-weight: 600;
}

.form-input {
    width: 100%;
    height: 44px;
    border: 1px solid #b0b4b9;
    padding: 0.75rem 1rem;
    margin: 0.5rem 0 0 0;
    font-size: 1rem;
    border-radius: 12px;
    background: white;
    transition: all 0.2s ease;
    outline: none;
    color: #1a365d;
    font-family: inherit;
}

.form-input:focus {
    border-color: #1a365d;
    box-shadow: 0 0 0 1px #1a365d;
}

.form-input::placeholder {
    color: #b0b4b9;
    font-size: 0.9rem;
}

.form-input:disabled {
    background: #f1f5f9;
    border-color: #cbd5e1;
    cursor: not-allowed;
    color: #94a3b8;
}

.form-input[type="file"] {
    display: none;
}

.checkbox-wrapper {
    margin-top: 0.75rem;
}

.checkbox-wrapper .checkbox-title {
    display: block;
    padding-top: 0.5rem;
    margin-bottom: 0.5rem;
    font-size: 1rem;
    color: #2d3748;
    font-weight: 600;
    cursor: pointer;
}

.checkbox-wrapper .checkbox-row {
    display: flex;
    align-items: center;
    gap: 0.5rem;
}

.checkbox-wrapper input[type="checkbox"] {
    width: 20px;
    height: 20px;
    cursor: pointer;
    flex-shrink: 0;
}

.checkbox-wrapper .checkbox-description {
    font-size: 0.875rem;
    color: #718096;
    font-weight: 400;
}

.file-input-wrapper {
    position: relative;
    display: block;
    margin-top: 0.5rem;
    pointer-events: none;
}

.file-input-wrapper * {
    pointer-events: auto;
}

.file-input-label {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    padding: 0.75rem 1.5rem;
    background: #6366f1;
    color: white;
    border: none;
    border-radius: 12px;
    font-size: 1rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 4px 8px rgba(99, 102, 241, 0.2);
    height: 44px;
    text-align: center;
    width: auto;
    min-width: 200px;
}

.file-input-label:hover {
    background: #4f46e5;
    box-shadow: 0 6px 12px rgba(99, 102, 241, 0.3);
    transform: translateY(-1px);
}

.file-input-label:active {
    transform: translateY(0);
}

.file-input-label svg {
    width: 20px;
    height: 20px;
    flex-shrink: 0;
}

.file-input-name {
    margin-top: 0.5rem;
    font-size: 0.875rem;
    color: #64748b;
    font-style: italic;
}

.btn-primary {
    background: #6366f1;
    color: white;
    border: none;
    padding: 10px 24px;
    border-radius: 12px;
    font-size: 1rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 4px 8px rgba(99, 102, 241, 0.2);
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    min-height: 44px;
}

.btn-primary:hover:not(:disabled) {
    background: #4f46e5;
    box-shadow: 0 6px 12px rgba(99, 102, 241, 0.3);
    transform: translateY(-1px);
}


.form-note-text {
    margin-top: 0.25rem;
    margin-bottom: 0.5rem;
    font-size: 0.875rem;
    color: #64748b;
    font-style: italic;
}

.form-help-text {
    margin-top: 0.5rem;
    font-size: 0.875rem;
    color: #64748b;
    font-style: italic;
}

.minimum-precision-buttons {
    display: flex;
    gap: 0.75rem;
    margin-top: 0.5rem;
}

.precision-button {
    padding: 0.5rem 1rem;
    font-size: 0.875rem;
    font-weight: 500;
    color: #374151;
    background-color: #ffffff;
    border: 2px solid #d1d5db;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.2s ease;
}

.precision-button:hover {
    background-color: #f9fafb;
    border-color: #9ca3af;
}

.precision-button.active {
    background-color: #2563eb;
    color: #ffffff;
    border-color: #2563eb;
}

.precision-button.active:hover {
    background-color: #1d4ed8;
    border-color: #1d4ed8;
}

.tool-name {
    font-size: 1rem;
    color: #1a365d;
    font-weight: 500;
}

.tool-delete-btn {
    width: 36px;
    height: 36px;
    background: white;
    color: #6b7280;
    border: 2px solid #cbd5e1;
    border-radius: 8px;
    font-size: 1.5rem;
    font-weight: 700;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
    line-height: 1;
    padding: 0;
    min-width: 36px;
    min-height: 36px;
    max-width: 36px;
    max-height: 36px;
    border-color: #ef4444;
}

.tool-delete-btn svg {
    display: block;
}

.tool-delete-btn:hover {
    background: #fef2f2;
    border-color: #dc2626;
    color: #374151;
    transform: scale(1.1);
}

.no-tools {
    text-align: center;
    padding: 2rem;
    color: #94a3b8;
    font-size: 1rem;
    font-style: italic;
}

.admin-add-button {
    background: #3ece81;
    color: white;
    border: none;
    box-shadow: 0 4px 8px rgba(72, 187, 120, 0.2);
    border-radius: 12px;
    padding: 0;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    width: 52px;
    height: 52px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.admin-add-button svg {
    width: 20px;
    height: 20px;
}

.admin-add-button:hover {
    background: #3bc475;
    transform: translateY(-1px);
    box-shadow: 0 6px 12px rgba(72, 187, 120, 0.3);
}

.admin-add-button:disabled {
    background: #94a3b8;
}



/* Subscription counters */
.subscription-counters {
    display: flex;
    gap: 1.5rem;
    justify-content: left;
    align-items: center;
    padding: 0.75rem 1rem;
    font-size: 0.95rem;
}

.counter-item {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
}

.counter-label {
    font-weight: 600;
    color: #64748b;
}

.counter-value {
    font-weight: 700;
    color: #1a365d;
    transition: color 0.2s ease;
}

.counter-value.limit-reached {
    color: #ef4444;
    font-weight: 800;
}

/* Email list */
.email-list-container {
    margin-top: 1rem;
    max-height: 200px;
    overflow-y: auto;
    border: 2px solid #e2e8f0;
    border-radius: 16px;
    background: #f8fafc;
    padding: 0.5rem;
}

.email-list-item {
    display: flex;
    align-items: center;
    gap: 1rem;
    margin-bottom: 0.75rem;
    padding: 0.75rem 1rem;
    background: white;
    border-radius: 12px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    transition: all 0.2s ease;
}

.email-list-item:last-child {
    margin-bottom: 0;
}

.email-list-item:hover {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    transform: translateY(-1px);
}

.email-text {
    font-size: 1.1rem;
    color: #2d3748;
    font-weight: 500;
    flex: 1;
}

.email-role-select {
    padding: 0.5rem 0.75rem;
    border: 2px solid #e2e8f0;
    border-radius: 8px;
    background: white;
    color: #1a365d;
    font-size: 0.95rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
    outline: none;
    min-width: 120px;
}

.email-role-select:hover {
    border-color: #1a365d;
}

.email-role-select:focus {
    border-color: #1a365d;
    box-shadow: 0 0 0 3px rgba(26, 54, 93, 0.1);
}

.email-role-select:disabled {
    background: #f1f5f9;
    color: #64748b;
    cursor: not-allowed;
    border-color: #cbd5e1;
}

.email-role-select:disabled:hover {
    border-color: #cbd5e1;
}

.db-indicator {
    padding: 0.25rem 0.5rem;
    background: #10b981;
    color: white;
    border-radius: 6px;
    font-size: 0.75rem;
    font-weight: 700;
    letter-spacing: 0.5px;
}

.email-remove-btn {
    background: #ef4444;
    color: white;
    border: none;
    border-radius: 8px;
    width: 32px;
    height: 32px;
    font-size: 1.5rem;
    line-height: 1;
    cursor: pointer;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;
}

.email-remove-btn:hover {
    background: #dc2626;
    transform: scale(1.1);
}

.send-invitations-btn {
    width: 100%;
    padding: 1rem;
    margin-top: 1rem;
    background: #1a365d;
    color: white;
    border: none;
    border-radius: 12px;
    font-size: 1.1rem;
    font-weight: 700;
    cursor: pointer;
    transition: all 0.2s ease;
}

.send-invitations-btn:hover {
    background: #2d4a7c;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(26, 54, 93, 0.3);
}

.send-invitations-btn:disabled {
    background: #94a3b8;
}

/* Loading message */
.loading-message {
    text-align: center;
    padding: 2rem;
    font-size: 1.2rem;
    color: #6b7280;
}

/* Role badge */
.role-badge {
    text-align: center;
    margin-bottom: 2rem;
    padding: 1rem;
    border-radius: 12px;
    border: 2px solid;
}

.role-badge.user-role {
    background-color: #f0f9ff;
    border-color: #3b82f6;
}

.role-badge.editor-role {
    background-color: #f0fdf4;
    border-color: #10b981;
}

.role-text {
    font-size: 1.4rem;
    color: #1a365d;
    font-weight: 600;
    margin: 0;
}

/* File button relative positioning */
.file-btn-relative {
    position: relative;
}

/* File remove button */
.file-remove-btn {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    color: #9ca3af;
    font-size: 32px;
    cursor: pointer;
    transition: all 0.2s ease;
    opacity: 0.7;
}

.file-remove-btn:hover {
    color: #6b7280;
    opacity: 1;
}

/* Submit button styling */
.submit-button {
    background: #3ece81;
    color: white;
    border: none;
    box-shadow: 0 4px 8px rgba(72, 187, 120, 0.2);
    border-radius: 12px;
    padding: 12px 24px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    text-decoration: none;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    width: 100%;
    margin-top: 1rem;
    min-width: 120px;
    min-height: 48px;
}

.submit-button:hover:not(:disabled) {
    background: #3bc475;
    transform: translateY(-1px);
    box-shadow: 0 6px 12px rgba(72, 187, 120, 0.3);
}


/* Arrow animation */
.arrow {
    font-size: 1.4rem;
    transition: transform 0.3s ease;
}

.submit-button:hover:not(:disabled) .arrow {
    transform: translateX(5px);
}

/* Container modifications */
.container {
    padding-top: 4.8rem;
}

.form {
    text-align: left;
}

/* Home dashboard: white card + history (reports) icon top-right */
.home-form-card {
    position: relative;
    width: 100%;
    max-width: 560px;
    margin: 0 auto;
    background: #ffffff;
    border-radius: 12px;
    padding: 2rem;
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.08);
    border: 1px solid #e5e7eb;
    box-sizing: border-box;
}

.home-form-card .title {
    padding-left: 2.75rem;
    padding-right: 2.75rem;
}

.home-form-history-btn {
    position: absolute;
    top: 1rem;
    right: 1rem;
    width: 2.25rem;
    height: 2.25rem;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fff;
    border: 2px solid #e5e7eb;
    border-radius: 50%;
    color: #1a365d;
    cursor: pointer;
    z-index: 2;
    transition: border-color 0.2s ease, background 0.2s ease, transform 0.2s ease;
}

.home-form-history-btn:hover {
    border-color: #1a365d;
    background: #f8fafc;
    transform: scale(1.06);
}

.home-form-history-icon {
    width: 1.125rem;
    height: 1.125rem;
    display: block;
}

/* Home form main title (organization name / HME) */
.form .title {
    font-size: 3rem;
    font-weight: 800;
    text-align: center;
    margin-bottom: 2rem;
    color: #1a365d;
    max-width: 100%;
    word-break: break-word;
    overflow-wrap: anywhere;
}

/* Invitation Page Styles */
.invitation-container {
    max-width: 600px;
    margin: 0 auto;
    padding: 2rem;
    background: #ffffff;
    border-radius: 12px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.invitation-title {
    font-size: 2rem;
    color: #1a365d;
    margin-bottom: 2rem;
    text-align: center;
}

.invitation-details {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
}

.invitation-info-box {
    background: #f8fafc;
    padding: 2rem;
    border-radius: 8px;
    text-align: center;
}

.invitation-info-text {
    font-size: 1.1rem;
    color: #64748b;
    margin-bottom: 1rem;
}

.invitation-company-name {
    font-size: 1.8rem;
    color: #1a365d;
    margin: 1rem 0;
    font-weight: bold;
}

.invitation-role-text,
.invitation-email-text {
    font-size: 1rem;
    color: #475569;
    margin: 0.5rem 0;
}

.invitation-expired-warning {
    background: #fef2f2;
    color: #991b1b;
    padding: 1rem;
    border-radius: 8px;
    text-align: center;
    font-weight: 500;
    border: 1px solid #fecaca;
}

.invitation-actions {
    display: flex;
    gap: 1rem;
    justify-content: center;
    margin-top: 1rem;
}

.invitation-accept-button,
.invitation-reject-button {
    padding: 0.75rem 2rem;
    font-size: 1rem;
    font-weight: 600;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s ease;
}

.invitation-accept-button {
    background: #3b82f6;
    color: white;
}

.invitation-accept-button:hover:not(:disabled) {
    background: #2563eb;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
}

.invitation-reject-button {
    background: #e2e8f0;
    color: #475569;
}

.invitation-reject-button:hover:not(:disabled) {
    background: #cbd5e1;
    transform: translateY(-2px);
}

.invitation-accept-button:disabled,
.invitation-reject-button:disabled {
    opacity: 0.5;
}

.invitation-note {
    background: #e0f2fe;
    padding: 1rem;
    border-radius: 8px;
    text-align: center;
}

.invitation-note p {
    margin: 0;
    color: #0c4a6e;
    font-size: 0.95rem;
}

.invitation-error-container {
    max-width: 500px;
    margin: 4rem auto;
    padding: 2rem;
    background: #ffffff;
    border-radius: 12px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    text-align: center;
}

.invitation-error-title {
    font-size: 2rem;
    color: #991b1b;
    margin-bottom: 1rem;
}

.invitation-error-message {
    font-size: 1.1rem;
    color: #475569;
    margin-bottom: 2rem;
}

.invitation-error-message-inline {
    background: #fef2f2;
    color: #991b1b;
    padding: 1rem;
    border-radius: 8px;
    text-align: center;
    border: 1px solid #fecaca;
}

.invitation-back-button {
    padding: 0.75rem 2rem;
    font-size: 1rem;
    font-weight: 600;
    background: #3b82f6;
    color: white;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s ease;
}

.invitation-back-button:hover {
    background: #2563eb;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
}

/* Role selector styles */

/* Invitation info banner */
.invitation-info-banner {
    background: #e0f2fe;
    color: #0c4a6e;
    padding: 1rem;
    border-radius: 8px;
    margin-bottom: 1.5rem;
    text-align: center;
    font-size: 0.95rem;
    border: 1px solid #bae6fd;
}

/* =================================================================================
   INVITATIONS MODAL STYLES
   ================================================================================= */

/* Modal overlay */
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10000;
    padding: 20px;
}

.modal-container {
    background: white;
    border-radius: 12px;
    max-width: 600px;
    width: 100%;
    max-height: 90vh;
    display: flex;
    flex-direction: column;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
}

.invitation-modal {
    max-width: 700px;
}

.modal-header {
    padding: 24px;
    border-bottom: 1px solid #e2e8f0;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.modal-header h2 {
    margin: 0;
    color: #1a365d;
    font-size: 24px;
}

.modal-close-btn {
    background: none;
    border: none;
    font-size: 32px;
    color: #64748b;
    cursor: pointer;
    padding: 0;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    transition: all 0.2s;
}

.modal-close-btn:hover {
    background: #f8fafc;
    color: #1a365d;
}

.modal-body {
    padding: 24px;
    overflow-y: auto;
    flex: 1;
}

.password-modal-description {
    margin-bottom: 20px;
    color: #475569;
    font-size: 15px;
    line-height: 1.6;
    text-align: center;
}

.invitation-intro {
    margin-bottom: 24px;
    color: #475569;
    font-size: 15px;
    line-height: 1.6;
}

.invitations-list {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.invitation-card {
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    padding: 20px;
    background: #f8fafc;
    transition: all 0.2s;
}

.invitation-card:hover {
    border-color: #3b82f6;
    box-shadow: 0 4px 12px rgba(59, 130, 246, 0.1);
}

.invitation-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
}

.invitation-header h3 {
    margin: 0;
    color: #1a365d;
    font-size: 20px;
}

.invitation-role-badge {
    background: #3b82f6;
    color: white;
    padding: 4px 12px;
    border-radius: 12px;
    font-size: 13px;
    font-weight: 500;
}

.invitation-details {
    margin-bottom: 16px;
}

.invitation-details p {
    margin: 8px 0;
    color: #475569;
    font-size: 14px;
}

.invitation-details strong {
    color: #1e293b;
    font-weight: 600;
}

.invitation-actions {
    display: flex;
    gap: 12px;
    margin-top: 16px;
}

.btn-accept {
    flex: 1;
    background: #10b981;
    color: white;
    border: none;
    padding: 12px 24px;
    border-radius: 6px;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;
}

.btn-accept:hover:not(:disabled) {
    background: #059669;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);
}


.btn-reject {
    flex: 1;
    background: #ef4444;
    color: white;
    border: none;
    padding: 12px 24px;
    border-radius: 6px;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;
}

.btn-reject:hover:not(:disabled) {
    background: #dc2626;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(239, 68, 68, 0.3);
}


.modal-footer {
    padding: 20px 24px;
    border-top: 1px solid #e2e8f0;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 1rem;
}

/* Primary (OK / Apply / Save) on the right: list cancel/secondary first, then primary */
.modal-footer > :first-child:not(:only-child) {
    margin-right: auto;
}

.modal-footer .btn-active {
    width: auto;
    flex: 0 0 auto;
    margin-top: 0;
}

.modal-footer .btn-secondary {
    flex: 0 0 auto;
}

.modal-footer .btn-delete {
    flex: 0 0 auto;
}

.modal-footer .btn-primary {
    flex: 0 0 auto;
}

.btn-secondary {
    background: #f1f5f9;
    color: #475569;
    border: none;
    padding: 10px 24px;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s;
    height: 52px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
}

.btn-secondary:hover {
    background: #e2e8f0;
    color: #1e293b;
}

.btn-delete {
    background: #ef4444;
    color: white;
    border: none;
    padding: 10px 24px;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;
    margin-left: 12px;
    height: 52px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
}

.btn-delete:hover:not(:disabled) {
    background: #dc2626;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(239, 68, 68, 0.3);
}


.delete-modal {
    max-width: 480px;
}

.save-success-modal {
    max-width: 480px;
}

.local-server-save-error-detail {
    margin: 0;
    white-space: pre-wrap;
}

.save-success-modal .modal-header h2 {
    color: #059669;
}

.save-success-file-label,
.save-success-folder-label {
    color: #64748b;
    font-size: 14px;
    font-weight: 600;
    margin: 0 0 4px 0;
}

.save-success-file-row {
    display: flex;
    align-items: center;
    gap: 12px;
    margin: 0 0 16px 0;
    padding: 8px 12px;
    background: #f8fafc;
    border-radius: 8px;
    border: 1px solid #e2e8f0;
}

.save-success-file-row .save-success-file-value {
    flex: 1;
    min-width: 0;
    margin: 0;
    padding: 0;
    background: transparent;
    border: none;
}

.save-success-modal .save-success-file-row .save-success-open-pdf {
    flex-shrink: 0;
    white-space: nowrap;
    margin: 0;
    padding: 10px 20px;
    min-height: 44px;
    font-family: inherit;
    font-size: 0.9375rem;
    font-weight: 600;
    letter-spacing: 0.02em;
    color: #dc2626;
    background: transparent;
    border: 2px solid #dc2626;
    border-radius: 12px;
    cursor: pointer;
    transition: color 0.2s ease, border-color 0.2s ease;
}

.save-success-modal .save-success-file-row .save-success-open-pdf:hover:not(:disabled) {
    color: #b91c1c;
    border-color: #b91c1c;
}

.save-success-modal .save-success-file-row .save-success-open-pdf:focus-visible {
    outline: none;
    box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.35);
}

.save-success-file-value,
.save-success-folder-value {
    color: #1e293b;
    font-size: 15px;
    margin: 0 0 16px 0;
    padding: 8px 12px;
    background: #f8fafc;
    border-radius: 8px;
    border: 1px solid #e2e8f0;
    word-break: break-all;
}

.save-success-folder-value {
    margin-bottom: 0;
}

.delete-confirmation-text {
    color: #374151;
    font-size: 16px;
    line-height: 1.6;
    margin: 0 0 16px 0;
}

.delete-warning-text {
    color: #ef4444;
    font-size: 14px;
    font-weight: 500;
    margin: 0;
}

.delete-password-field {
    margin-top: 1.5rem;
}

.delete-password-label {
    display: block;
    margin-bottom: 0.5rem;
    font-size: 0.9rem;
    font-weight: 600;
    color: #6b7280;
}

.delete-password-input {
    width: 100%;
    padding: 0.75rem 1rem;
    font-size: 1rem;
    border: 2px solid #e5e7eb;
    border-radius: 8px;
    background-color: #f9fafb;
    color: #1a365d;
    outline: none;
    transition: all 0.2s;
}

.delete-password-input:focus {
    border-color: #1a365d;
    box-shadow: 0 0 0 3px rgba(26, 54, 93, 0.1);
}

.delete-password-input.error {
    border-color: #ef4444;
}

.delete-password-input:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.delete-password-error {
    color: #ef4444;
    font-size: 0.875rem;
    margin-top: 0.5rem;
    margin-bottom: 0;
}

@media (max-width: 768px) {
    .modal-container {
        max-width: 100%;
        max-height: 100vh;
        border-radius: 0;
    }

    .modal-header h2 {
        font-size: 20px;
    }

    .invitation-actions {
        flex-direction: column;
    }
}

/* Subscription Warning Styles */
.subscription-warning {
    display: flex;
    align-items: flex-start;
    gap: 1rem;
    padding: 1.25rem 1.5rem;
    margin-bottom: 1.5rem;
    background: #fef2f2;
    border: 2px solid #fecaca;
    border-radius: 12px;
    box-shadow: 0 4px 6px rgba(239, 68, 68, 0.1);
}

.warning-icon {
    font-size: 2rem;
    flex-shrink: 0;
    line-height: 1;
}

.warning-content {
    flex: 1;
}

.warning-content h3 {
    margin: 0 0 0.5rem 0;
    font-size: 1.25rem;
    font-weight: 700;
    color: #991b1b;
}

.warning-content p {
    margin: 0;
    font-size: 1rem;
    color: #7f1d1d;
    line-height: 1.5;
}

/* ============================================================
   Reports page (operator/editor history viewer)
   ============================================================ */
.reports-page {
    max-width: 1200px;
    margin: 0 auto;
    padding: 1.5rem;
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.reports-page-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    flex-wrap: wrap;
}

.reports-page-header .reports-secondary-title {
    margin: 0;
}

.reports-secondary-section {
    margin-top: 2.5rem;
    padding-top: 2rem;
    border-top: 1px solid #e5e7eb;
}

.reports-secondary-title {
    margin: 0 0 1rem;
    font-size: 1.25rem;
    font-weight: 700;
    color: #1f2937;
    text-align: left;
    align-self: flex-start;
}

.reports-filters {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
    align-items: stretch;
    background: #f9fafb;
    padding: 1rem;
    border: 1px solid #e5e7eb;
    border-radius: 10px;
}

.reports-search-bar {
    display: flex;
    align-items: stretch;
    gap: 0.5rem;
    width: 100%;
    min-width: 0;
}

.reports-search-input {
    flex: 1;
    min-width: 0;
    min-height: 2.75rem;
    font-size: 1rem;
}

.reports-search-icon-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 2.75rem;
    padding: 0.5rem;
    flex-shrink: 0;
}

.reports-search-icon {
    width: 1.35rem;
    height: 1.35rem;
    display: block;
}

.reports-empty {
    padding: 2rem;
    text-align: center;
    color: #6b7280;
    background: #f9fafb;
    border: 1px dashed #d1d5db;
    border-radius: 10px;
}

.reports-table-wrapper {
    overflow-x: auto;
    border: 1px solid #e5e7eb;
    border-radius: 10px;
    background: #ffffff;
}

.reports-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 0.875rem;
}

.reports-table th,
.reports-table td {
    padding: 0.75rem 1rem;
    text-align: left;
    border-bottom: 1px solid #f3f4f6;
    vertical-align: middle;
}

.reports-table th {
    background: #f9fafb;
    font-weight: 600;
    color: #374151;
    position: sticky;
    top: 0;
    z-index: 1;
}

.reports-table tbody tr:hover {
    background: #f9fafb;
}

.reports-table td .profile-secondary-btn {
    margin-right: 0.5rem;
    padding: 0.3rem 0.6rem;
    font-size: 0.8rem;
}

.reports-open-pdf-btn,
.reports-edit-settings-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 2.25rem;
    min-height: 2.25rem;
    padding: 0.35rem;
    margin-right: 0;
}

.reports-open-pdf-icon {
    width: 1.25rem;
    height: 1.25rem;
    display: block;
}

.reports-action-cell {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.35rem;
}

.reports-download-pdf-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 2.25rem;
    min-height: 2.25rem;
    padding: 0.35rem;
    margin-right: 0;
}

.reports-pagination {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1rem;
    padding: 0.5rem 0;
}

.reports-page-info {
    color: #4b5563;
    font-size: 0.875rem;
}

.reports-page-error {
    font-size: 0.875rem;
    color: #b91c1c;
    padding: 0.75rem 1rem;
    background: #fef2f2;
    border: 1px solid #fecaca;
    border-radius: 8px;
    -webkit-user-select: text;
    -moz-user-select: text;
    -ms-user-select: text;
    user-select: text;
    cursor: text;
    white-space: pre-wrap;
    word-break: break-word;
    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
    line-height: 1.5;
}
`, "",{"version":3,"sources":["webpack://./public/styles/main.css"],"names":[],"mappings":"CAAC,0BAA0B;AAC3B;IACI,SAAS;IACT,UAAU;IACV,sBAAsB;AAC1B;;AAEA;;;IAGI,WAAW;IACX,YAAY;IACZ,SAAS;IACT,UAAU;AACd;;AAEA;IACI,gJAAgJ;IAChJ,gBAAgB;IAChB,WAAW;IACX,6DAA6D;IAC7D,eAAe;IACf,yBAAyB;IACzB,sBAAsB;IACtB,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA,+EAA+E;AAC/E;;;;;;;;;;IAUI,yBAAyB;IACzB,sBAAsB;IACtB,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;;;;IAII,YAAY;AAChB;;AAEA,0BAA0B;AAC1B;IACI,WAAW;IACX,YAAY;IACZ,6DAA6D;IAC7D,aAAa;IACb,iBAAiB;IACjB,uBAAuB;IACvB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA,oBAAoB;AACpB;IACI,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,2CAA2C;IAC3C,mBAAmB;IACnB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,2CAA2C;IAC3C,eAAe;IACf,iBAAiB;AACrB;;AAEA,oFAAoF;AACpF;;;;IAII,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,aAAa;IACb,oBAAoB;IACpB,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,yBAAyB;IACzB,aAAa;IACb,cAAc;IACd,YAAY;IACZ,iBAAiB;AACrB;;AAEA;;;;IAII,6BAA6B;AACjC;;AAEA;;;;IAII,cAAc;IACd,iBAAiB;AACrB;;AAEA;;;;IAII,mBAAmB;IACnB,qBAAqB;IACrB,mBAAmB;IACnB,cAAc;AAClB;;AAEA,kBAAkB;AAClB;IACI,eAAe;IACf,yBAAyB;IACzB,eAAe;IACf,oBAAoB;AACxB;;AAEA;;IAEI,mBAAmB;IACnB,wCAAwC;IACxC,eAAe;IACf,YAAY;IACZ,mBAAmB;IACnB,cAAc;AAClB;;AAEA;;IAEI,UAAU;IACV,eAAe;IACf,wCAAwC;AAC5C;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,iBAAiB;IACjB,0BAA0B;IAC1B,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;IACzB,2CAA2C;IAC3C,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,qBAAqB;IACrB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;IAC9B,cAAc;IACd,yBAAyB;IACzB,2CAA2C;AAC/C;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;IACd,2BAA2B;IAC3B,4CAA4C;AAChD;;AAEA,sCAAsC;AACtC;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,uCAAuC;IACvC,6BAA6B;IAC7B,kBAAkB;IAClB,oCAAoC;AACxC;;AAEA,sBAAsB;AACtB;IACI,cAAc;IACd,qBAAqB;IACrB,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA,qBAAqB;AACrB;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,2CAA2C;IAC3C,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,gBAAgB;IAChB,sBAAsB;IACtB,uBAAuB;IACvB,2BAA2B;IAC3B,0CAA0C;IAC1C,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,6DAA6D;IAC7D,aAAa;IACb,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,oBAAoB;IACpB,2CAA2C;IAC3C,0CAA0C;IAC1C,iBAAiB;IACjB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,yBAAyB;IACzB,4CAA4C;AAChD;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;IAC3B,4CAA4C;AAChD;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,2BAA2B;IAC3B,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,6DAA6D;IAC7D,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,+CAA+C;AACnD;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA,0BAA0B;AAC1B;IACI,WAAW;IACX,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;AACnB;;AAEA,8BAA8B;AAC9B;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA,uBAAuB;AACvB;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,WAAW;IACX,mBAAmB;IACnB,iBAAiB;IACjB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb,yBAAyB;IACzB,sBAAsB;IACtB,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA,8BAA8B;AAC9B;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,eAAe;IACf,WAAW;IACX,YAAY;IACZ,oBAAoB;AACxB;;AAEA,qCAAqC;AACrC;IACI,kBAAkB;IAClB,SAAS;IACT,6BAA6B;IAC7B,YAAY;IACZ,2EAA2E;IAC3E,OAAO;IACP,QAAQ;IACR,aAAa;IACb,2BAA2B;IAC3B,uBAAuB;IACvB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;IACV,yBAAyB;AAC7B;;AAEA,iGAAiG;AACjG;IACI,4BAA4B;AAChC;;AAEA;IACI,SAAS;AACb;;AAEA,6EAA6E;AAC7E;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,6CAA6C;AACjD;;AAEA,+EAA+E;AAC/E;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,2CAA2C;IAC3C,mCAAmC;IACnC,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,QAAQ;IACR,cAAc;IACd,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,iBAAiB;IACjB,WAAW;IACX,uBAAuB;IACvB,6BAA6B;IAC7B,qBAAqB;IACrB,oBAAoB;AACxB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,WAAW;IACX,QAAQ;IACR,8HAA8H;IAC9H,+DAA+D;IAC/D,oBAAoB;IACpB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,oBAAoB;IACpB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,mBAAmB;IACnB,aAAa;IACb,8DAA8D;AAClE;;AAEA;IACI,MAAM;IACN,OAAO;IACP,yBAAyB;AAC7B;;AAEA;IACI,MAAM;IACN,QAAQ;IACR,yBAAyB;AAC7B;;AAEA;IACI,SAAS;IACT,OAAO;IACP,yBAAyB;AAC7B;;AAEA;IACI,SAAS;IACT,QAAQ;IACR,yBAAyB;AAC7B;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,gCAAgC;IAChC,UAAU;IACV,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,qBAAqB;IACrB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,8DAA8D;AAClE;;AAEA;IACI,SAAS;IACT,+BAA+B;AACnC;;AAEA;IACI,UAAU;IACV,+BAA+B;IAC/B,oEAAoE;AACxE;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sDAAsD;AAC1D;;AAEA;IACI,uDAAuD;AAC3D;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,SAAS;IACT,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,SAAS;IACT,YAAY;IACZ;;;;;;;;;;KAUC;IACD,0BAA0B;IAC1B,wDAAwD;IACxD,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,8DAA8D;IAC9D,8CAA8C;AAClD;;AAEA;;IAEI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,SAAS;IACT,2BAA2B;IAC3B,kCAAkC;IAClC,mCAAmC;AACvC;;AAEA;IACI,SAAS;IACT,gCAAgC;AACpC;;AAEA;IACI,YAAY;IACZ,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,+BAA+B;IAC/B,oBAAoB;IACpB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,0BAA0B;IAC1B,kBAAkB;IAClB,uDAAuD;AAC3D;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,gCAAgC;IAChC,wCAAwC;IACxC,+DAA+D;AACnE;;AAEA;;IAEI,WAAW;IACX,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,QAAQ;IACR,WAAW;IACX,UAAU;IACV,2BAA2B;AAC/B;;AAEA;IACI,QAAQ;IACR,SAAS;IACT,UAAU;IACV,WAAW;IACX,2BAA2B;AAC/B;;AAEA;IACI;;QAEI,QAAQ;QACR,aAAa;IACjB;IACA;QACI,QAAQ;QACR,aAAa;IACjB;AACJ;;AAEA;IACI;;QAEI,aAAa;IACjB;IACA;QACI,UAAU;IACd;AACJ;;AAEA;IACI;;QAEI,wBAAwB;IAC5B;IACA;QACI,2BAA2B;IAC/B;AACJ;;AAEA;IACI;;QAEI,wBAAwB;IAC5B;IACA;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,wBAAwB;IAC5B;IACA;QACI,2BAA2B;IAC/B;AACJ;;AAEA;IACI;;QAEI,QAAQ;IACZ;IACA;QACI,SAAS;IACb;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI;;QAEI,yCAAyC;QACzC,aAAa;IACjB;IACA;QACI,4CAA4C;QAC5C,UAAU;IACd;AACJ;;AAEA;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,eAAe;QACf,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA,kDAAkD;AAClD;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;IACzB,iBAAiB;IACjB,uDAAuD;IACvD,0BAA0B;AAC9B;;AAEA,4BAA4B;AAC5B;IACI,aAAa;IACb,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA,sCAAsC;AACtC;IACI,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,yCAAyC;IACzC,yBAAyB;IACzB,cAAc;AAClB;;AAEA,0BAA0B;AAC1B;IACI,aAAa;IACb,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;AAClB;;AAEA,mDAAmD;AACnD;IACI,kBAAkB;IAClB,SAAS;IACT,MAAM;IACN,2BAA2B;IAC3B,wBAAwB;IACxB,yBAAyB;IACzB,4BAA4B;IAC5B,6BAA6B;IAC7B,oBAAoB;IACpB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA,wBAAwB;AACxB;IACI,wBAAwB;IACxB,yBAAyB;IACzB,4BAA4B;IAC5B,6BAA6B;IAC7B,SAAS;IACT,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oBAAoB;IACpB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,oBAAoB;IACpB,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;IACrB,uCAAuC;AAC3C;;AAEA;IACI,qBAAqB;IACrB,yCAAyC;AAC7C;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,eAAe;IACf,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;AACA,uBAAuB;AACvB;IACI,cAAc;IACd,wBAAwB;IACxB,yBAAyB;IACzB,4BAA4B;IAC5B,6BAA6B;IAC7B,oBAAoB;IACpB,gBAAgB;IAChB,8BAA8B;IAC9B,0BAA0B;IAC1B,mCAAmC;IACnC,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA,yBAAyB;AACzB;IACI,wBAAwB;IACxB,yBAAyB;IACzB,4BAA4B;IAC5B,6BAA6B;AACjC;;AAEA,2BAA2B;AAC3B;IACI,wBAAwB;IACxB,yBAAyB;IACzB,4BAA4B;IAC5B,6BAA6B;IAC7B,0BAA0B;IAC1B,mBAAmB;IACnB,8BAA8B;IAC9B,yBAAyB;AAC7B;;AAEA;IACI,wBAAwB;IACxB,yBAAyB;IACzB,4BAA4B;IAC5B,6BAA6B;IAC7B,0BAA0B;IAC1B,mBAAmB;IACnB,8BAA8B;IAC9B,yBAAyB;AAC7B;;AAEA;IACI,wBAAwB;IACxB,yBAAyB;IACzB,4BAA4B;IAC5B,6BAA6B;IAC7B,0BAA0B;IAC1B,mBAAmB;IACnB,8BAA8B;IAC9B,yBAAyB;AAC7B;;AAEA,wBAAwB;AACxB;IACI,wBAAwB;IACxB,yBAAyB;IACzB,4BAA4B;IAC5B,6BAA6B;AACjC;;AAEA;IACI,wBAAwB;IACxB,yBAAyB;IACzB,4BAA4B;IAC5B,6BAA6B;AACjC;;AAEA;IACI,wBAAwB;IACxB,yBAAyB;IACzB,4BAA4B;IAC5B,6BAA6B;AACjC;;AAEA,0CAA0C;AAC1C;;IAEI;;;;;;QAMI,wBAAwB;QACxB,yBAAyB;QACzB,4BAA4B;QAC5B,6BAA6B;IACjC;;IAEA;QACI,aAAa;QACb,cAAc;QACd,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA,0BAA0B;IAC1B;;;;;;QAMI,wBAAwB;QACxB,yBAAyB;QACzB,4BAA4B;QAC5B,6BAA6B;IACjC;;IAEA;QACI,aAAa;QACb,cAAc;QACd,iBAAiB;QACjB,kBAAkB;IACtB;AACJ;;AAEA,oDAAoD;AACpD;;;;IAII;;;;;;QAMI,wBAAwB;QACxB,yBAAyB;QACzB,4BAA4B;QAC5B,6BAA6B;IACjC;;IAEA;QACI,aAAa;QACb,cAAc;QACd,iBAAiB;QACjB,kBAAkB;IACtB;AACJ;;AAEA,yEAAyE;AACzE;IACI,eAAe;IACf,OAAO;IACP,QAAQ;IACR,SAAS;IACT,uBAAuB;IACvB,4BAA4B;IAC5B,gBAAgB;IAChB,aAAa;IACb,aAAa;IACb,2BAA2B;IAC3B,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;IACpB,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;IACf,cAAc;IACd,oBAAoB;IACpB,eAAe;IACf,YAAY;IACZ,sBAAsB;IACtB,yGAAyG;IACzG,iFAAiF;AACrF;;AAEA;IACI,eAAe;IACf,yGAAyG;AAC7G;;;;AAIA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,4BAA4B;IAC5B,wEAAwE;AAC5E;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,2BAA2B;IAC3B,gBAAgB;IAChB,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,yCAAyC;AAC7C;;AAEA,wBAAwB;AACxB;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,wBAAwB;IACxB,kBAAkB;IAClB,aAAa;IACb,aAAa;IACb,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA,+CAA+C;AAC/C;IACI,UAAU;IACV,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;IACd,WAAW;IACX,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA,6EAA6E;AAC7E;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,YAAY;AAChB;;AAEA,yFAAyF;AACzF;IACI,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,2BAA2B;IAC3B,2BAA2B;IAC3B,mBAAmB;IACnB,cAAc;IACd,UAAU;IACV,8BAA8B;AAClC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,cAAc;AAClB;;AAEA,mEAAmE;AACnE;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,YAAY;IACZ,8BAA8B;AAClC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,SAAS;IACT,2BAA2B;IAC3B,aAAa;IACb,eAAe;IACf,QAAQ;IACR,YAAY;IACZ,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,0CAA0C;IAC1C,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,6BAA6B;IAC7B,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,YAAY;IACZ,gDAAgD;AACpD;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA,iEAAiE;AACjE;IACI,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,mGAAmG;IACnG,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,2BAA2B;IAC3B,4BAA4B;IAC5B,YAAY;IACZ,mBAAmB;IACnB,UAAU;IACV,8BAA8B;AAClC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,cAAc;IACd,gCAAgC;IAChC,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,WAAW;AACf;;AAEA;IACI,oBAAoB;IACpB,sBAAsB;IACtB,uBAAuB;IACvB,eAAe;IACf,iBAAiB;IACjB,WAAW;AACf;;AAEA;;IAEI,kCAAkC;AACtC;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,sBAAsB;IACtB,iBAAiB;IACjB,cAAc;IACd,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,sBAAsB;IACtB,iBAAiB;IACjB,cAAc;IACd,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,UAAU;IACV,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,kEAAkE;AACtE;;AAEA;IACI;;QAEI,UAAU;IACd;IACA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,sBAAsB;IACtB,iBAAiB;IACjB,cAAc;IACd,YAAY;IACZ,iBAAiB;AACrB;;AAEA,8FAA8F;AAC9F;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,UAAU;IACV,kBAAkB;IAClB,yBAAyB;IACzB,yBAAyB;IACzB,mDAAmD;IACnD,gBAAgB;IAChB,gBAAgB;IAChB,0BAA0B;IAC1B,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,UAAU;IACV,YAAY;IACZ,qBAAqB;IACrB,oCAAoC;IACpC,yBAAyB;IACzB,8CAA8C;AAClD;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;IACrB,aAAa;IACb,6BAA6B;AACjC;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,OAAO;IACP,kBAAkB;IAClB,uBAAuB;IACvB,gBAAgB;IAChB,2BAA2B;IAC3B,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,yCAAyC;AAC7C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,OAAO;AACX;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,2BAA2B;IAC3B,wCAAwC;AAC5C;;AAEA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,yCAAyC;IACzC,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,2BAA2B;IAC3B,wCAAwC;AAC5C;;AAEA;;IAEI,aAAa;IACb,qBAAqB;IACrB,6BAA6B;AACjC;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,eAAe;AACnB;;AAEA;;IAEI,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,yCAAyC;AAC7C;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,2BAA2B;IAC3B,wCAAwC;AAC5C;;;AAGA;IACI,cAAc;IACd,eAAe;IACf,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,uBAAuB;IACvB,cAAc;IACd,eAAe;IACf,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;;IAEI,aAAa;IACb,qBAAqB;IACrB,6BAA6B;AACjC;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,YAAY;AAChB;;AAEA;;IAEI,aAAa;IACb,qBAAqB;IACrB,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA,6BAA6B;AAC7B;IACI,kBAAkB;AACtB;;AAEA,4BAA4B;AAC5B;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,WAAW;IACX,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,uBAAuB;IACvB,gBAAgB;IAChB,2BAA2B;IAC3B,mBAAmB;AACvB;;;AAGA;IACI,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,eAAe;IACf,SAAS;IACT,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;AACZ;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,uBAAuB;IACvB,uBAAuB;IACvB,4BAA4B;IAC5B,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,OAAO;IACP,YAAY;AAChB;;AAEA;IACI,sBAAsB;IACtB,oBAAoB;IACpB,WAAW;AACf;;AAEA;;;IAGI,sBAAsB;IACtB,YAAY;IACZ,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,UAAU;IACV,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,kCAAkC;AACtC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI,UAAU;IACV,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,UAAU;IACV,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,kCAAkC;AACtC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,sFAAsF;AAC1F;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,0CAA0C;IAC1C,aAAa;IACb,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,sBAAsB;IACtB,qBAAqB;IACrB,iBAAiB;IACjB,eAAe;IACf,sFAAsF;IACtF,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;IACf,eAAe;IACf,yBAAyB;IACzB,cAAc;IACd,gBAAgB;IAChB,gJAAgJ;IAChJ,2BAA2B;IAC3B,mCAAmC;IACnC,gBAAgB;IAChB,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,uBAAuB;IACvB,qBAAqB;IACrB,iBAAiB;IACjB,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf,sBAAsB;IACtB,8BAA8B;IAC9B,8CAA8C;AAClD;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA,OAAO;AACP;;;;GAIG;;AAEH;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,uBAAuB;IACvB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,qBAAqB;IACrB,8BAA8B;IAC9B,SAAS;IACT,WAAW;AACf;;AAEA;IACI,OAAO;IACP,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,cAAc;IACd,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,QAAQ;IACR,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,6BAA6B;AACjC;;;AAGA,eAAe;AACf;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;;AAGA,6BAA6B;AAC7B;IACI,gBAAgB;IAChB,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;IAC3B,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,iDAAiD;AACrD;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,qBAAqB;IACrB,cAAc;IACd,WAAW;AACf;;AAEA,kCAAkC;AAClC;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,2BAA2B;IAC3B,4CAA4C;AAChD;;AAEA,mCAAmC;AACnC;IACI,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,YAAY;AAChB;;AAEA,0FAA0F;AAC1F;;IAEI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,UAAU;IACV,yBAAyB;IACzB,sBAAsB;IACtB,qBAAqB;IACrB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA,iCAAiC;AACjC;;;;;;IAMI,cAAc;AAClB;;AAEA,+BAA+B;AAC/B;IACI,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,QAAQ;AACZ;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;IACd,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;IACd,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,sBAAsB;IACtB,qBAAqB;IACrB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;IACd,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;IACd,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,sBAAsB;IACtB,qBAAqB;IACrB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,QAAQ;IACR,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,UAAU;IACV,yCAAyC;AAC7C;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,MAAM;IACN,kBAAkB;IAClB,WAAW;IACX,sBAAsB;AAC1B;;AAEA;;IAEI,cAAc;IACd,WAAW;IACX,aAAa;IACb,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,OAAO;IACP,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,2BAA2B;IAC3B,yCAAyC;IACzC,gBAAgB;IAChB,yCAAyC;IACzC,gBAAgB;IAChB,sBAAsB;IACtB;;;;;oDAKgD;AACpD;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,WAAW;IACX,eAAe;IACf,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;IACnB,6CAA6C;AACjD;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,mBAAmB;IACnB,oCAAoC;AACxC;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;IAC9B,QAAQ;IACR,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,MAAM;IACN,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB,aAAa;IACb;;;;+BAI2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,UAAU;IACV,aAAa;IACb,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;IAClB;;;;kCAI8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,WAAW;IACX,YAAY;IACZ,UAAU;IACV,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf;;;;;8BAK0B;AAC9B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,uEAAuE;AAC3E;;AAEA;IACI;;QAEI,8EAA8E;IAClF;IACA;QACI,+EAA+E;IACnF;AACJ;;AAEA;IACI,cAAc;IACd,6DAA6D;AACjE;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB;;;;mDAI+C;AACnD;;AAEA,qFAAqF;AACrF;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gBAAgB;IAChB,sBAAsB;IACtB,UAAU;IACV,SAAS;IACT,UAAU;IACV,SAAS;IACT,UAAU;IACV,eAAe;IACf,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,OAAO;AACX;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,sBAAsB;IACtB,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA,8EAA8E;AAC9E;IACI,YAAY;IACZ,yBAAyB;IACzB,sBAAsB;IACtB,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,MAAM;AACV;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,OAAO,uBAAuB,EAAE;IAChC,KAAK,yBAAyB,EAAE;AACpC;;AAEA;IACI,sCAAsC;AAC1C;;AAEA,wDAAwD;AACxD;;IAEI,OAAO;IACP,kBAAkB;AACtB;;AAEA,yCAAyC;AACzC;IACI,cAAc;AAClB;;AAEA,2BAA2B;AAC3B;IACI;QACI,eAAe;QACf,QAAQ;IACZ;;IAEA;QACI,SAAS;QACT,WAAW;QACX,kBAAkB;QAClB,kBAAkB;IACtB;;IAEA;QACI,iBAAiB;QACjB,2BAA2B;QAC3B,QAAQ;QACR,gBAAgB;QAChB,mBAAmB;QACnB,4BAA4B;IAChC;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,YAAY;QACZ,sBAAsB;IAC1B;;IAEA;QACI,gBAAgB;QAChB,gBAAgB;QAChB,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,eAAe;IACnB;AACJ;;AAEA,0DAA0D;;;AAG1D;IACI,mBAAmB;IACnB,cAAc;IACd,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,uBAAuB;IACvB,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,6CAA6C;IAC7C,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,2BAA2B;IAC3B,8CAA8C;AAClD;;AAEA;IACI,uBAAuB;IACvB,cAAc;IACd,qBAAqB;IACrB,4CAA4C;AAChD;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,2BAA2B;IAC3B,8CAA8C;AAClD;;AAEA;IACI,mCAAmC;IACnC,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA,uEAAuE;;AAEvE;IACI,iBAAiB;IACjB,+BAA+B;AACnC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,SAAS;IACT,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,cAAc;IACd,SAAS;IACT,QAAQ;IACR,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,8CAA8C;AAClD;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;;;AAIA,sCAAsC;AACtC;IACI,YAAY;IACZ,aAAa;IACb,qBAAqB;IACrB,gBAAgB;IAChB,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA,oCAAoC;AACpC;IACI,kBAAkB;IAClB,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,yBAAyB;IACzB,aAAa;IACb,cAAc;IACd,eAAe;IACf,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,OAAO;IACP,cAAc;AAClB;;AAEA;IACI,0BAA0B;IAC1B,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,+BAA+B;IAC/B,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,0CAA0C;IAC1C,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,mCAAmC;AACvC;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;;IAEA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI,aAAa;IACb,cAAc;IACd,eAAe;IACf,yBAAyB;IACzB,gCAAgC;IAChC,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA,yBAAyB;AACzB;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;IACX,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,yCAAyC;IACzC,yBAAyB;IACzB,yBAAyB;IACzB,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,2BAA2B;IAC3B,0CAA0C;IAC1C,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,6DAA6D;AACjE;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,gBAAgB;IAChB,OAAO;AACX;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,gCAAgC;IAChC,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,cAAc;IACd,yBAAyB;IACzB,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;AAC/B;;;AAGA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,0CAA0C;AAC9C;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;IAC3B,2CAA2C;AAC/C;;;AAGA;IACI;QACI,mBAAmB;QACnB,oBAAoB;QACpB,eAAe;QACf,uBAAuB;QACvB,SAAS;IACb;;IAEA;QACI,gBAAgB;QAChB,gBAAgB;QAChB,YAAY;QACZ,cAAc;IAClB;AACJ;;;;;;AAMA,sBAAsB;;AAEtB;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,aAAa;IACb,QAAQ;IACR,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,2BAA2B;AAC3B;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,aAAa;IACb,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,oBAAoB;IACpB,mBAAmB;IACnB,2CAA2C;IAC3C,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,0CAA0C;IAC1C,SAAS;IACT,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,qBAAqB;IACrB,2CAA2C;IAC3C,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;;IAEI,WAAW;IACX,yBAAyB;IACzB,aAAa;IACb,oBAAoB;IACpB,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,yBAAyB;IACzB,aAAa;IACb,cAAc;IACd,oBAAoB;AACxB;;AAEA;;IAEI,6BAA6B;AACjC;;AAEA;;IAEI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,gCAAgC;IAChC,wCAAwC;AAC5C;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,OAAO;IACP,mBAAmB;IACnB,YAAY;IACZ,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,2BAA2B;IAC3B,4CAA4C;AAChD;;;;AAIA;IACI;QACI,aAAa;QACb,iBAAiB;QACjB,oBAAoB;IACxB;;IAEA;QACI,aAAa;QACb,oBAAoB;QACpB,SAAS;IACb;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,sBAAsB;QACtB,SAAS;IACb;;IAEA;;QAEI,WAAW;IACf;AACJ;;AAEA,8BAA8B;AAC9B;IACI,WAAW;IACX,aAAa;IACb,6DAA6D;IAC7D,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,0CAA0C;IAC1C,0CAA0C;AAC9C;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,qDAAqD;AACzD;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,qBAAqB;IACrB,2CAA2C;AAC/C;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,8BAA8B;AAClC;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,OAAO;IACP,cAAc;IACd,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,6DAA6D;IAC7D,YAAY;IACZ,YAAY;IACZ,oBAAoB;IACpB,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,yBAAyB;IACzB,8CAA8C;IAC9C,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,2BAA2B;IAC3B,+CAA+C;IAC/C,6DAA6D;AACjE;;AAEA;IACI,wBAAwB;IACxB,8CAA8C;AAClD;;AAEA;IACI,6DAA6D;IAC7D,+CAA+C;AACnD;;AAEA;IACI,+CAA+C;IAC/C,6DAA6D;AACjE;;AAEA,6CAA6C;AAC7C;IACI;QACI,aAAa;IACjB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,oBAAoB;QACpB,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,oBAAoB;IACxB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,iBAAiB;IACrB;AACJ;;AAEA,oGAAoG;AACpG;IACI;QACI,uBAAuB;IAC3B;;IAEA;QACI,yBAAyB;IAC7B;AACJ;;AAEA,yBAAyB;AACzB;IACI,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,2CAA2C;IAC3C,mBAAmB;IACnB,eAAe;IACf,aAAa;IACb,WAAW;IACX,yBAAyB;IACzB,8BAA8B;IAC9B,YAAY;AAChB;;AAEA,iBAAiB;AACjB;IACI,eAAe;IACf,SAAS;IACT,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,gBAAgB;IAChB,sBAAsB;IACtB,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,yCAAyC;IACzC,aAAa;IACb,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,0CAA0C;IAC1C,qBAAqB;IACrB,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,6DAA6D;IAC7D,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,gBAAgB;AACpB;;AAEA,wBAAwB;AACxB;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,2CAA2C;IAC3C,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,MAAM;AACV;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yBAAyB;IACzB,2CAA2C;IAC3C,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,2BAA2B;IAC3B,4CAA4C;AAChD;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,2BAA2B;IAC3B,4CAA4C;AAChD;;AAEA,+EAA+E;AAC/E;IACI,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yBAAyB;IACzB,2CAA2C;IAC3C,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,2BAA2B;IAC3B,4CAA4C;AAChD;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,2BAA2B;IAC3B,4CAA4C;AAChD;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,oBAAoB;IACpB,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,qBAAqB;IACrB,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;IAC3B,4CAA4C;AAChD;;;AAGA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,qBAAqB;IACrB,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;IACzB,kCAAkC;IAClC,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;IACI,wBAAwB;AAC5B;;;AAGA;IACI,mBAAmB;IACnB,cAAc;IACd,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,gBAAgB;IAChB,eAAe;AACnB;;AAEA,kBAAkB;AAClB;IACI,eAAe;IACf,SAAS;IACT,UAAU;IACV,iBAAiB;IACjB,cAAc;IACd,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA,wBAAwB;AACxB;IACI,eAAe;IACf,SAAS;IACT,UAAU;IACV,iBAAiB;IACjB,cAAc;IACd,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,yBAAyB;IACzB,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,2BAA2B;IAC3B,yCAAyC;AAC7C;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA,wBAAwB;AACxB;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,2CAA2C;IAC3C,WAAW;IACX,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,OAAO;IACP,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,6BAA6B;AACjC;;AAEA;IACI,qBAAqB;IACrB,6BAA6B;AACjC;;AAEA;IACI,qBAAqB;IACrB,6BAA6B;AACjC;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA,mDAAmD;AACnD;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,OAAO;IACP,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,UAAU;IACV,YAAY;IACZ,SAAS;IACT,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,0BAA0B;IAC1B,yBAAyB;IACzB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,8DAA8D;IAC9D,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA,+CAA+C;AAC/C;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;;;IAGI,sBAAsB;IACtB,uBAAuB;IACvB,oBAAoB;IACpB,0BAA0B;IAC1B,qBAAqB;IACrB,6BAA6B;IAC7B,kCAAkC;IAClC,4BAA4B;IAC5B,oCAAoC;IACpC,2BAA2B;IAC3B,mCAAmC;IACnC,gCAAgC;IAChC,0BAA0B;IAC1B,iCAAiC;AACrC;;AAEA;;;IAGI,kCAAkC;IAClC,4BAA4B;IAC5B,gCAAgC;IAChC,6BAA6B;AACjC;;AAEA;;;IAGI,sBAAsB;IACtB,6BAA6B;IAC7B,oBAAoB;IACpB,mBAAmB;IACnB,qBAAqB;IACrB,uBAAuB;IACvB,gCAAgC;IAChC,oCAAoC;IACpC,yDAAyD;AAC7D;;AAEA,4BAA4B;AAC5B;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,qBAAqB;IACrB,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,OAAO;AACX;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,uBAAuB;IACvB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,yBAAyB;IACzB,iBAAiB;IACjB,iBAAiB;IACjB,+BAA+B;IAC/B,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,cAAc;IACd,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,cAAc;IACd,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,qBAAqB;IACrB,eAAe;IACf,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,yBAAyB;IACzB,6CAA6C;IAC7C,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;IAC3B,8CAA8C;AAClD;;;AAGA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,6CAA6C;IAC7C,mBAAmB;IACnB,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,8CAA8C;IAC9C,2BAA2B;AAC/B;;;AAGA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,8CAA8C;IAC9C,2BAA2B;AAC/B;;;AAGA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,kBAAkB;IAClB,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,0CAA0C;IAC1C,aAAa;IACb,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,qBAAqB;IACrB,eAAe;IACf,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,4DAA4D;IAC5D,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,0CAA0C;IAC1C,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,wCAAwC;AAC5C;;AAEA;IACI,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;IACtB,yCAAyC;AAC7C;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,SAAS;IACT,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,UAAU;IACV,6CAA6C;AACjD;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;IACvB,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,yBAAyB;IACzB,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,mBAAmB;IACnB,OAAO;IACP,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;IACvB,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,yBAAyB;IACzB,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,OAAO;IACP,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,0BAA0B;IAC1B,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,cAAc;IACd,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,0BAA0B;IAC1B,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,QAAQ;IACR,sBAAsB;IACtB,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,iFAAiF;IACjF,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,YAAY;IACZ,gCAAgC;IAChC,eAAe;IACf,kBAAkB;IAClB,uCAAuC;AAC3C;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI;QACI,4DAA4D;QAC5D,SAAS;IACb;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;QACjB,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,4DAA4D;QAC5D,YAAY;IAChB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;QAChB,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,oBAAoB;IACxB;AACJ;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,wCAAwC;AAC5C;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,SAAS;IACT,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,YAAY;IACZ,uBAAuB;IACvB,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,2BAA2B;AAC/B;;AAEA;IACI,qBAAqB;IACrB,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,wCAAwC;IACxC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,qBAAqB;IACrB,oBAAoB;IACpB,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,yBAAyB;IACzB,aAAa;IACb,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;IACrB,6BAA6B;AACjC;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,qBAAqB;IACrB,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,6CAA6C;IAC7C,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,8CAA8C;IAC9C,2BAA2B;AAC/B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,6CAA6C;IAC7C,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,8CAA8C;IAC9C,2BAA2B;AAC/B;;;AAGA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,mBAAmB;IACnB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,cAAc;IACd,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,cAAc;IACd,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,6CAA6C;IAC7C,mBAAmB;IACnB,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;IAC3B,8CAA8C;AAClD;;AAEA;IACI,mBAAmB;AACvB;;;;AAIA,0BAA0B;AAC1B;IACI,aAAa;IACb,WAAW;IACX,qBAAqB;IACrB,mBAAmB;IACnB,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,2BAA2B;AAC/B;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA,eAAe;AACf;IACI,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,sBAAsB;IACtB,qBAAqB;IACrB,iBAAiB;IACjB,mBAAmB;IACnB,yCAAyC;IACzC,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,wCAAwC;IACxC,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,OAAO;AACX;;AAEA;IACI,uBAAuB;IACvB,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,2CAA2C;AAC/C;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;IAC3B,4CAA4C;AAChD;;AAEA;IACI,mBAAmB;AACvB;;AAEA,oBAAoB;AACpB;IACI,kBAAkB;IAClB,aAAa;IACb,iBAAiB;IACjB,cAAc;AAClB;;AAEA,eAAe;AACf;IACI,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,SAAS;AACb;;AAEA,qCAAqC;AACrC;IACI,kBAAkB;AACtB;;AAEA,uBAAuB;AACvB;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,cAAc;IACd,eAAe;IACf,eAAe;IACf,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,UAAU;AACd;;AAEA,0BAA0B;AAC1B;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,6CAA6C;IAC7C,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,qBAAqB;IACrB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;IAC3B,8CAA8C;AAClD;;;AAGA,oBAAoB;AACpB;IACI,iBAAiB;IACjB,+BAA+B;AACnC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA,4BAA4B;AAC5B;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA,kEAAkE;AAClE;IACI,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,0CAA0C;IAC1C,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,cAAc;IACd,eAAe;IACf,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,UAAU;IACV,6EAA6E;AACjF;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA,mDAAmD;AACnD;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA,2BAA2B;AAC3B;IACI,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,wCAAwC;AAC5C;;AAEA;IACI,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,cAAc;IACd,iBAAiB;AACrB;;AAEA;;IAEI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,SAAS;IACT,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;;IAEI,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;IAC3B,8CAA8C;AAClD;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;;IAEI,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,wCAAwC;IACxC,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;IAC3B,8CAA8C;AAClD;;AAEA,yBAAyB;;AAEzB,2BAA2B;AAC3B;IACI,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,kBAAkB;IAClB,qBAAqB;IACrB,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;;sFAEsF;;AAEtF,kBAAkB;AAClB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,0CAA0C;AAC9C;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,gCAAgC;IAChC,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,cAAc;IACd,eAAe;IACf,UAAU;IACV,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,OAAO;AACX;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;IACrB,8CAA8C;AAClD;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,OAAO;IACP,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;IAC3B,8CAA8C;AAClD;;;AAGA;IACI,OAAO;IACP,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;IAC3B,6CAA6C;AACjD;;;AAGA;IACI,kBAAkB;IAClB,6BAA6B;IAC7B,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,SAAS;AACb;;AAEA,wFAAwF;AACxF;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,YAAY;IACZ,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,iBAAiB;IACjB,YAAY;IACZ,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;IAC3B,6CAA6C;AACjD;;;AAGA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,OAAO;IACP,YAAY;IACZ,SAAS;IACT,UAAU;IACV,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,oBAAoB;IACpB,gBAAgB;IAChB,sBAAsB;IACtB,cAAc;IACd,uBAAuB;IACvB,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,mDAAmD;AACvD;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,6CAA6C;AACjD;;AAEA;;IAEI,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;IACrB,2CAA2C;AAC/C;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI;QACI,eAAe;QACf,iBAAiB;QACjB,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,sBAAsB;IAC1B;AACJ;;AAEA,gCAAgC;AAChC;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,uBAAuB;IACvB,qBAAqB;IACrB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,4CAA4C;AAChD;;AAEA;IACI,eAAe;IACf,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;;iEAEiE;AACjE;IACI,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,oBAAoB;IACpB,mBAAmB;IACnB,aAAa;IACb,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,oBAAoB;IACpB,WAAW;IACX,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,OAAO;IACP,YAAY;IACZ,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;;IAEI,qBAAqB;IACrB,gBAAgB;IAChB,gCAAgC;IAChC,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,MAAM;IACN,UAAU;AACd;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;;IAEI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,qBAAqB;IACrB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;IACzB,sBAAsB;IACtB,qBAAqB;IACrB,iBAAiB;IACjB,YAAY;IACZ,qBAAqB;IACrB,sBAAsB;IACtB,6EAA6E;IAC7E,gBAAgB;AACpB","sourcesContent":[" /* Reset and base styles */\n* {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n}\n\nhtml,\nbody,\n#root {\n    width: 100%;\n    height: 100%;\n    margin: 0;\n    padding: 0;\n}\n\nbody {\n    font-family: 'Lato', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\n    line-height: 1.6;\n    color: #333;\n    background: linear-gradient(135deg, #f6f9fc 0%, #eef2f7 100%);\n    cursor: default;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n}\n\n/* Allow text selection and I-beam cursor only for actual content/input areas */\ninput,\ntextarea,\n[contenteditable=\"true\"],\n[contenteditable=\"\"],\n.selectable,\n.selectable *,\n.pdf-viewer-page,\n.pdf-viewer-page .react-pdf__Page,\n.pdf-viewer-page .react-pdf__Page__textContent,\n.pdf-viewer-page .react-pdf__Page__textContent * {\n    -webkit-user-select: text;\n    -moz-user-select: text;\n    -ms-user-select: text;\n    user-select: text;\n}\n\ninput,\ntextarea,\n[contenteditable=\"true\"],\n[contenteditable=\"\"] {\n    cursor: text;\n}\n\n/* Base container styles */\n.container {\n    width: 100%;\n    height: 100%;\n    background: linear-gradient(135deg, #f6f9fc 0%, #eef2f7 100%);\n    padding: 2rem;\n    padding-top: 4rem;\n    min-height: fit-content;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    position: relative;\n}\n\n/* Base typography */\nh1 {\n    text-align: left;\n    font-size: 1.4rem;\n    margin-bottom: 1rem;\n    color: #2c3e50;\n    cursor: default;\n    user-select: none;\n}\n\nh2 {\n    font-size: 2.5rem;\n    color: #1a365d;\n    font-weight: 900;\n    text-align: center;\n    margin: 0 0 2rem 0;\n    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);\n    letter-spacing: 2px;\n    cursor: default;\n    user-select: none;\n}\n\nh3 {\n    font-size: 3rem;\n    color: #1a365d;\n    margin-bottom: 2.5rem;\n    text-align: center;\n    font-weight: 800;\n    letter-spacing: 1px;\n    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1);\n    cursor: default;\n    user-select: none;\n}\n\n/* Base form elements - apply only to inputs in forms, exclude context menu inputs */\nform input:not(.context-menu-input):not(.tolerance-input):not(.tolerantsi-sisend),\n.container input:not(.context-menu-input):not(.tolerance-input):not(.tolerantsi-sisend),\n.form input:not(.context-menu-input):not(.tolerance-input):not(.tolerantsi-sisend),\n.contact-us-form input:not(.context-menu-input):not(.tolerance-input):not(.tolerantsi-sisend) {\n    width: 100%;\n    height: 52px;\n    border: 1px solid #b0b4b9;\n    padding: 1rem;\n    margin: 0.5rem 0 0 0;\n    font-size: 1rem;\n    border-radius: 1rem;\n    background: white;\n    transition: all 0.2s ease;\n    outline: none;\n    color: #1a365d;\n    cursor: text;\n    user-select: text;\n}\n\nform input:not(.context-menu-input):not(.tolerance-input):not(.tolerantsi-sisend):focus,\n.container input:not(.context-menu-input):not(.tolerance-input):not(.tolerantsi-sisend):focus,\n.form input:not(.context-menu-input):not(.tolerance-input):not(.tolerantsi-sisend):focus,\n.contact-us-form input:not(.context-menu-input):not(.tolerance-input):not(.tolerantsi-sisend):focus {\n    box-shadow: 0 0 0 1px #1a365d;\n}\n\nform input:not(.context-menu-input):not(.tolerance-input):not(.tolerantsi-sisend)::placeholder,\n.container input:not(.context-menu-input):not(.tolerance-input):not(.tolerantsi-sisend)::placeholder,\n.form input:not(.context-menu-input):not(.tolerance-input):not(.tolerantsi-sisend)::placeholder,\n.contact-us-form input:not(.context-menu-input):not(.tolerance-input):not(.tolerantsi-sisend)::placeholder {\n    color: #b0b4b9;\n    font-size: 0.9rem;\n}\n\nform input:not(.context-menu-input):not(.tolerance-input):not(.tolerantsi-sisend):disabled,\n.container input:not(.context-menu-input):not(.tolerance-input):not(.tolerantsi-sisend):disabled,\n.form input:not(.context-menu-input):not(.tolerance-input):not(.tolerantsi-sisend):disabled,\n.contact-us-form input:not(.context-menu-input):not(.tolerance-input):not(.tolerantsi-sisend):disabled {\n    background: #f1f5f9;\n    border-color: #cbd5e1;\n    cursor: not-allowed;\n    color: #94a3b8;\n}\n\n/* Button styles */\nbutton {\n    cursor: pointer;\n    transition: all 0.2s ease;\n    font-size: 1rem;\n    font-family: inherit;\n}\n\nbutton:disabled,\n.btn-disabled {\n    cursor: not-allowed;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    transform: none;\n    opacity: 0.6;\n    background: #cbd5e1;\n    color: #000000;\n}\n\nbutton:disabled:hover,\n.btn-disabled:hover {\n    opacity: 1;\n    transform: none;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.btn-underline {\n    height: 20px;\n    background: none;\n    border: none;\n    color: #1a365d;\n    font-size: 0.9rem;\n    text-decoration: underline;\n    margin-top: 0.2rem;\n    padding: 0;\n    text-align: left;\n    display: block;\n    width: fit-content;\n}\n\n.btn-active {\n    background: #75ee97;\n    color: #1a365d;\n    border: 2px solid #cad1dc;\n    box-shadow: 0 4px 8px rgba(26, 54, 93, 0.2);\n    border-radius: 12px;\n    padding: 12px 24px;\n    font-size: 16px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    text-decoration: none;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    width: 100%;\n    height: 52px;\n    margin-top: 1rem;\n    min-width: 120px;\n}\n\n.btn-active-disabled {\n    background: rgb(255, 255, 255);\n    color: #9ca3af;\n    border: 2px solid #cad1dc;\n    box-shadow: 0 4px 8px rgba(26, 54, 93, 0.2);\n}\n\n.btn-active:not(:disabled):hover {\n    background: #78f49b;\n    border: 2px solid #1a365d;\n    color: #1a365d;\n    transform: translateY(-1px);\n    box-shadow: 0 6px 12px rgba(37, 44, 40, 0.3);\n}\n\n/* Button loading state with spinner */\n.button-loading-content {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n}\n\n.button-spinner {\n    width: 16px;\n    height: 16px;\n    border: 2px solid rgba(26, 54, 93, 0.2);\n    border-top: 2px solid #1a365d;\n    border-radius: 50%;\n    animation: spin 0.8s linear infinite;\n}\n\n/* Base label styles */\nlabel {\n    display: block;\n    margin-bottom: 1.2rem;\n    font-size: 1rem;\n    color: #2d3748;\n    font-weight: 600;\n    cursor: default;\n    user-select: none;\n}\n\nlabel:focus-within {\n    color: #1a365d;\n}\n\n/* Base form styles */\nform:not(.contact-us-form) {\n    background: white;\n    padding: 4rem;\n    border-radius: 24px;\n    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08);\n    width: 100%;\n    max-width: 600px;\n    display: flex;\n    text-align: left;\n    flex-direction: column;\n    justify-content: center;\n    backdrop-filter: blur(10px);\n    border: 1px solid rgba(255, 255, 255, 0.2);\n    height: fit-content;\n    margin: 0 0 2rem 0;\n}\n\n.no-organization-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    height: 100vh;\n    background: linear-gradient(135deg, #f6f9fc 0%, #eef2f7 100%);\n    padding: 2rem;\n    gap: 1.5rem;\n}\n\n.no-organization-message {\n    max-width: 480px;\n    text-align: center;\n    background: #ffffff;\n    border-radius: 24px;\n    padding: 2.5rem 2rem;\n    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08);\n    border: 1px solid rgba(255, 255, 255, 0.6);\n    font-size: 1.1rem;\n    color: #1f2937;\n    position: relative;\n}\n\n.back-button {\n    padding: 0.75rem 2rem;\n    font-size: 1rem;\n    font-weight: 600;\n    background: #1a365d;\n    color: white;\n    border: none;\n    border-radius: 12px;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    box-shadow: 0 4px 12px rgba(26, 54, 93, 0.2);\n}\n\n.back-button:hover {\n    background: #2d4a7c;\n    transform: translateY(-2px);\n    box-shadow: 0 6px 16px rgba(26, 54, 93, 0.3);\n}\n\n.no-organization-message::before {\n    content: '!';\n    position: absolute;\n    top: -26px;\n    left: 50%;\n    transform: translateX(-50%);\n    width: 52px;\n    height: 52px;\n    border-radius: 50%;\n    background: linear-gradient(135deg, #f97373 0%, #ef4444 100%);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #ffffff;\n    font-weight: 800;\n    font-size: 1.4rem;\n    box-shadow: 0 10px 20px rgba(239, 68, 68, 0.35);\n}\n\n.row-container {\n    display: flex;\n    flex-direction: column;\n}\n\n/* PDF viewer route root */\n.pdf-viewer-page {\n    width: 100%;\n    height: 100vh;\n    display: flex;\n    flex-direction: column;\n    background: #fff;\n    overflow: hidden;\n    cursor: default;\n}\n\n/* Main PDF viewer container */\n.pdf-viewer-page .pdf-viewer {\n    position: relative;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    background: #fff;\n    overflow: hidden;\n    transition: all 0.3s ease;\n}\n\n/* Top navigation bar */\n.pdf-viewer-page .pdf-info-bar {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    width: 100%;\n    background: #f0f0f0;\n    padding: 6px 12px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    z-index: 1000;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n}\n\n/* Drag hint for editor role */\n.pdf-viewer-page .pdf-drag-hint {\n    position: absolute;\n    top: 60px;\n    left: 12px;\n    font-size: 12px;\n    color: #666;\n    z-index: 999;\n    pointer-events: none;\n}\n\n/* Main content area with scrolling */\n.pdf-viewer-page .pdf-canvas-centerer {\n    position: absolute;\n    top: 60px;\n    /* высота верхнего инфобара */\n    bottom: 65px;\n    /* высота нижней панели с легендой + запас для горизонтального скроллбара */\n    left: 0;\n    right: 0;\n    display: flex;\n    justify-content: flex-start;\n    align-items: flex-start;\n    width: 100%;\n    background: #fff;\n    overflow-x: auto;\n    overflow-y: auto;\n    padding: 0;\n    transition: all 0.3s ease;\n}\n\n/* Portrait: center the PDF/Konva stack on wide viewports; safe avoids odd overflow when zoomed */\n.pdf-viewer-page .pdf-canvas-centerer:not(.landscape) {\n    justify-content: safe center;\n}\n\n.pdf-viewer-page.no-legend .pdf-canvas-centerer {\n    bottom: 0;\n}\n\n/* PDF zoom wrapper - provides correct dimensions for scrolling when zoomed */\n.pdf-viewer-page .pdf-zoom-wrapper {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    transition: width 0.1s ease, height 0.1s ease;\n}\n\n/* App-wide engineering loading overlay (frosted glass + technical animation) */\n.app-engineering-loading-overlay {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    pointer-events: all;\n    background-color: rgba(248, 250, 252, 0.38);\n    -webkit-backdrop-filter: blur(10px);\n    backdrop-filter: blur(10px);\n}\n\n.app-engineering-loading-overlay--fullscreen {\n    position: fixed;\n    inset: 0;\n    z-index: 10000;\n    min-height: 100vh;\n    width: 100%;\n}\n\n.app-engineering-loading-overlay--contained {\n    position: absolute;\n    inset: 0;\n    z-index: 2000;\n}\n\n.app-engineering-loading-overlay--compact {\n    position: relative;\n    inset: auto;\n    min-height: 200px;\n    width: 100%;\n    background: transparent;\n    -webkit-backdrop-filter: none;\n    backdrop-filter: none;\n    pointer-events: none;\n}\n\n.app-engineering-loading-overlay--compact .pdf-save-engineering-loader {\n    transform: scale(0.88);\n}\n\n.app-engineering-loading-overlay .pdf-save-engineering-loader {\n    position: relative;\n    width: min(380px, 92vw);\n    height: 220px;\n    box-sizing: border-box;\n}\n\n.app-engineering-loading-overlay .pdf-save-eng-scanline {\n    position: absolute;\n    left: -4%;\n    right: -4%;\n    height: 2px;\n    top: 18%;\n    background: linear-gradient(90deg, transparent 0%, rgba(71, 85, 105, 0.45) 45%, rgba(71, 85, 105, 0.45) 55%, transparent 100%);\n    animation: pdf-save-eng-scan-vertical 2.6s ease-in-out infinite;\n    pointer-events: none;\n    z-index: 2;\n}\n\n.app-engineering-loading-overlay .pdf-save-eng-frame {\n    position: absolute;\n    inset: 0;\n    pointer-events: none;\n    z-index: 1;\n}\n\n.app-engineering-loading-overlay .pdf-save-eng-corner {\n    position: absolute;\n    width: 22px;\n    height: 22px;\n    border-color: #475569;\n    border-style: solid;\n    opacity: 0.85;\n    animation: pdf-save-eng-corner-pulse 3.2s ease-in-out infinite;\n}\n\n.app-engineering-loading-overlay .pdf-save-eng-corner--tl {\n    top: 0;\n    left: 0;\n    border-width: 2px 0 0 2px;\n}\n\n.app-engineering-loading-overlay .pdf-save-eng-corner--tr {\n    top: 0;\n    right: 0;\n    border-width: 2px 2px 0 0;\n}\n\n.app-engineering-loading-overlay .pdf-save-eng-corner--bl {\n    bottom: 0;\n    left: 0;\n    border-width: 0 0 2px 2px;\n}\n\n.app-engineering-loading-overlay .pdf-save-eng-corner--br {\n    bottom: 0;\n    right: 0;\n    border-width: 0 2px 2px 0;\n}\n\n.app-engineering-loading-overlay .pdf-save-eng-corner--tr,\n.app-engineering-loading-overlay .pdf-save-eng-corner--bl {\n    animation-delay: 0.4s;\n}\n\n.app-engineering-loading-overlay .pdf-save-eng-stage {\n    position: absolute;\n    left: 50%;\n    top: 52%;\n    transform: translate(-50%, -50%);\n    width: 88%;\n    max-width: 320px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 18px;\n    z-index: 3;\n}\n\n.app-engineering-loading-overlay .pdf-save-eng-caliper {\n    position: relative;\n    width: 100%;\n    height: 36px;\n    display: flex;\n    align-items: flex-end;\n    justify-content: center;\n}\n\n.app-engineering-loading-overlay .pdf-save-eng-caliper-bar {\n    position: absolute;\n    left: 12%;\n    right: 12%;\n    bottom: 10px;\n    height: 4px;\n    background: #64748b;\n    border-radius: 1px;\n}\n\n.app-engineering-loading-overlay .pdf-save-eng-caliper-jaw {\n    position: absolute;\n    bottom: 0;\n    width: 5px;\n    height: 28px;\n    background: #334155;\n    border-radius: 1px;\n    animation: pdf-save-eng-caliper-open 1.9s ease-in-out infinite;\n}\n\n.app-engineering-loading-overlay .pdf-save-eng-caliper-jaw--left {\n    left: 22%;\n    transform-origin: center bottom;\n}\n\n.app-engineering-loading-overlay .pdf-save-eng-caliper-jaw--right {\n    right: 22%;\n    transform-origin: center bottom;\n    animation: pdf-save-eng-caliper-open-right 1.9s ease-in-out infinite;\n}\n\n.app-engineering-loading-overlay .pdf-save-eng-gears {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n}\n\n.app-engineering-loading-overlay .pdf-save-eng-gear-svg {\n    width: 52px;\n    height: 52px;\n    color: #334155;\n    overflow: visible;\n}\n\n.app-engineering-loading-overlay .pdf-save-eng-gear-svg--secondary {\n    width: 40px;\n    height: 40px;\n    margin-top: 6px;\n}\n\n.app-engineering-loading-overlay .pdf-save-eng-gear-hub {\n    fill: #f1f5f9;\n    stroke: #334155;\n    stroke-width: 2;\n}\n\n.app-engineering-loading-overlay .pdf-save-eng-gear-spokes {\n    stroke: #334155;\n    stroke-width: 3.2;\n}\n\n.app-engineering-loading-overlay .pdf-save-eng-gear-spokes--six {\n    stroke-width: 3;\n}\n\n.app-engineering-loading-overlay .pdf-save-eng-gear-spin {\n    transform-origin: 28px 28px;\n}\n\n.app-engineering-loading-overlay .pdf-save-eng-gear-spin--cw {\n    animation: pdf-save-eng-rotate-cw 2.8s linear infinite;\n}\n\n.app-engineering-loading-overlay .pdf-save-eng-gear-spin--ccw {\n    animation: pdf-save-eng-rotate-ccw 3.6s linear infinite;\n}\n\n.app-engineering-loading-overlay .pdf-save-eng-scale {\n    position: relative;\n    width: 100%;\n    height: 22px;\n}\n\n.app-engineering-loading-overlay .pdf-save-eng-scale-track {\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 10px;\n    height: 2px;\n    background: #94a3b8;\n}\n\n.app-engineering-loading-overlay .pdf-save-eng-scale-track::before {\n    content: '';\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: -8px;\n    height: 10px;\n    background-image: repeating-linear-gradient(\n        90deg,\n        #475569 0,\n        #475569 1px,\n        transparent 1px,\n        transparent 5px,\n        #64748b 5px,\n        #64748b 6px,\n        transparent 6px,\n        transparent 14px\n    );\n    background-size: 28px 10px;\n    animation: pdf-save-eng-ticks-slide 1.4s linear infinite;\n    opacity: 0.9;\n}\n\n.app-engineering-loading-overlay .pdf-save-eng-scale-cursor {\n    position: absolute;\n    top: 2px;\n    width: 2px;\n    height: 18px;\n    background: #0f172a;\n    left: 8%;\n    margin-left: -1px;\n    animation: pdf-save-eng-cursor-sweep 2.2s ease-in-out infinite;\n    box-shadow: 0 0 0 1px rgba(248, 250, 252, 0.9);\n}\n\n.app-engineering-loading-overlay .pdf-save-eng-scale-cursor::before,\n.app-engineering-loading-overlay .pdf-save-eng-scale-cursor::after {\n    content: '';\n    position: absolute;\n    width: 0;\n    height: 0;\n    left: 50%;\n    transform: translateX(-50%);\n    border-left: 5px solid transparent;\n    border-right: 5px solid transparent;\n}\n\n.app-engineering-loading-overlay .pdf-save-eng-scale-cursor::before {\n    top: -5px;\n    border-bottom: 5px solid #0f172a;\n}\n\n.app-engineering-loading-overlay .pdf-save-eng-scale-cursor::after {\n    bottom: -5px;\n    border-top: 5px solid #0f172a;\n}\n\n.app-engineering-loading-overlay .pdf-save-eng-reticle {\n    position: absolute;\n    right: 10%;\n    top: 22%;\n    width: 48px;\n    height: 48px;\n    transform: translate(50%, -50%);\n    pointer-events: none;\n    z-index: 2;\n}\n\n.app-engineering-loading-overlay .pdf-save-eng-reticle-ring {\n    position: absolute;\n    inset: 0;\n    border: 1px dashed #64748b;\n    border-radius: 50%;\n    animation: pdf-save-eng-reticle-spin 5s linear infinite;\n}\n\n.app-engineering-loading-overlay .pdf-save-eng-reticle-cross {\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    width: 22px;\n    height: 22px;\n    transform: translate(-50%, -50%);\n    border: 1px solid rgba(51, 65, 85, 0.65);\n    animation: pdf-save-eng-cross-breathe 1.6s ease-in-out infinite;\n}\n\n.app-engineering-loading-overlay .pdf-save-eng-reticle-cross::before,\n.app-engineering-loading-overlay .pdf-save-eng-reticle-cross::after {\n    content: '';\n    position: absolute;\n    background: #475569;\n}\n\n.app-engineering-loading-overlay .pdf-save-eng-reticle-cross::before {\n    left: 50%;\n    top: 2px;\n    bottom: 2px;\n    width: 1px;\n    transform: translateX(-50%);\n}\n\n.app-engineering-loading-overlay .pdf-save-eng-reticle-cross::after {\n    top: 50%;\n    left: 2px;\n    right: 2px;\n    height: 1px;\n    transform: translateY(-50%);\n}\n\n@keyframes pdf-save-eng-scan-vertical {\n    0%,\n    100% {\n        top: 14%;\n        opacity: 0.35;\n    }\n    50% {\n        top: 78%;\n        opacity: 0.85;\n    }\n}\n\n@keyframes pdf-save-eng-corner-pulse {\n    0%,\n    100% {\n        opacity: 0.55;\n    }\n    50% {\n        opacity: 1;\n    }\n}\n\n@keyframes pdf-save-eng-caliper-open {\n    0%,\n    100% {\n        transform: translateX(0);\n    }\n    50% {\n        transform: translateX(-6px);\n    }\n}\n\n@keyframes pdf-save-eng-caliper-open-right {\n    0%,\n    100% {\n        transform: translateX(0);\n    }\n    50% {\n        transform: translateX(6px);\n    }\n}\n\n@keyframes pdf-save-eng-rotate-cw {\n    to {\n        transform: rotate(360deg);\n    }\n}\n\n@keyframes pdf-save-eng-rotate-ccw {\n    to {\n        transform: rotate(-360deg);\n    }\n}\n\n@keyframes pdf-save-eng-ticks-slide {\n    0% {\n        background-position: 0 0;\n    }\n    100% {\n        background-position: 28px 0;\n    }\n}\n\n@keyframes pdf-save-eng-cursor-sweep {\n    0%,\n    100% {\n        left: 8%;\n    }\n    50% {\n        left: 88%;\n    }\n}\n\n@keyframes pdf-save-eng-reticle-spin {\n    to {\n        transform: rotate(-360deg);\n    }\n}\n\n@keyframes pdf-save-eng-cross-breathe {\n    0%,\n    100% {\n        transform: translate(-50%, -50%) scale(1);\n        opacity: 0.85;\n    }\n    50% {\n        transform: translate(-50%, -50%) scale(1.12);\n        opacity: 1;\n    }\n}\n\n@media (prefers-reduced-motion: reduce) {\n    .app-engineering-loading-overlay .pdf-save-eng-scanline {\n        animation-duration: 5s;\n    }\n\n    .app-engineering-loading-overlay .pdf-save-eng-corner {\n        animation: none;\n        opacity: 0.85;\n    }\n\n    .app-engineering-loading-overlay .pdf-save-eng-caliper-jaw {\n        animation: none;\n    }\n\n    .app-engineering-loading-overlay .pdf-save-eng-gear-spin--cw {\n        animation-duration: 10s;\n    }\n\n    .app-engineering-loading-overlay .pdf-save-eng-gear-spin--ccw {\n        animation-duration: 12s;\n    }\n\n    .app-engineering-loading-overlay .pdf-save-eng-scale-track::before {\n        animation: none;\n    }\n\n    .app-engineering-loading-overlay .pdf-save-eng-scale-cursor {\n        animation-duration: 4s;\n    }\n\n    .app-engineering-loading-overlay .pdf-save-eng-reticle-ring {\n        animation-duration: 20s;\n    }\n\n    .app-engineering-loading-overlay .pdf-save-eng-reticle-cross {\n        animation: none;\n    }\n}\n\n/* PDF and Konva container with fixed dimensions */\n.pdf-viewer-page .pdf-konva-container {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    background: transparent;\n    width: 1400px;\n    height: 1600px;\n    min-width: 1400px;\n    min-height: 1200px;\n    transition: all 0.3s ease;\n    overflow: visible;\n    /* Improve tap vs scroll on tablets (Konva over PDF). */\n    touch-action: manipulation;\n}\n\n/* Landscape PDF container */\n.pdf-viewer-page .pdf-konva-container.landscape {\n    width: 2000px;\n    height: 1600px;\n    min-width: 2000px;\n    min-height: 1600px;\n    align-items: center;\n    overflow: visible;\n}\n\n/* PDF wrapper with fixed dimensions */\n.pdf-viewer-page .pdf-canvas-wrapper {\n    position: relative;\n    display: block;\n    background: #fff;\n    border: none;\n    border-radius: 8px;\n    width: 1400px;\n    height: 1600px;\n    min-width: 1400px;\n    min-height: 1200px;\n    overflow: visible;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n    transition: all 0.3s ease;\n    margin: 0 auto;\n}\n\n/* Landscape PDF wrapper */\n.pdf-viewer-page .pdf-canvas-wrapper.landscape {\n    width: 2000px;\n    height: 1600px;\n    min-width: 2000px;\n    min-height: 1600px;\n    margin: 0 auto;\n}\n\n/* Konva Stage with absolute positioning over PDF */\n.pdf-viewer-page .stage-absolute {\n    position: absolute;\n    left: 50%;\n    top: 0;\n    transform: translateX(-50%);\n    width: 1400px !important;\n    height: 1600px !important;\n    min-width: 1400px !important;\n    min-height: 1200px !important;\n    pointer-events: auto;\n    z-index: 10;\n    border: none;\n    border-radius: 6px;\n    transition: all 0.3s ease;\n    touch-action: manipulation;\n}\n\n/* Landscape PDF stage */\n.pdf-viewer-page .stage-absolute.landscape {\n    width: 2000px !important;\n    height: 1600px !important;\n    min-width: 2000px !important;\n    min-height: 1600px !important;\n    left: 50%;\n    transform: translateX(-50%);\n}\n\n.pdf-viewer-page .ocr-markers-html-overlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    pointer-events: none;\n    z-index: 5;\n}\n\n.pdf-viewer-page .ocr-marker-item {\n    position: absolute;\n    left: var(--ocr-x);\n    top: var(--ocr-y);\n    width: var(--ocr-w);\n    height: var(--ocr-h);\n    border: 2px solid;\n    border-radius: 2px;\n    box-sizing: border-box;\n}\n\n.pdf-viewer-page .ocr-marker-item.ocr-marker-pdfjs {\n    border-color: #00b450;\n    background-color: rgba(0, 180, 80, 0.3);\n}\n\n.pdf-viewer-page .ocr-marker-item.ocr-marker-gemini {\n    border-color: #3c82f6;\n    background-color: rgba(60, 130, 246, 0.3);\n}\n\n.pdf-viewer-page .ocr-marker-text {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    margin-top: 2px;\n    white-space: nowrap;\n    font-size: 10px;\n}\n\n.pdf-viewer-page .ocr-marker-item.ocr-marker-pdfjs .ocr-marker-text {\n    color: #00b450;\n}\n\n.pdf-viewer-page .ocr-marker-item.ocr-marker-gemini .ocr-marker-text {\n    color: #3c82f6;\n}\n/* PDF canvas styling */\n.pdf-viewer-page .pdf-canvas-wrapper canvas {\n    display: block;\n    width: 1400px !important;\n    height: 1600px !important;\n    min-width: 1400px !important;\n    min-height: 1200px !important;\n    margin: 0 !important;\n    background: #fff;\n    object-fit: contain !important;\n    transform: none !important;\n    transform-origin: center !important;\n    scale: 1 !important;\n    transition: all 0.3s ease;\n}\n\n/* Landscape PDF canvas */\n.pdf-viewer-page .pdf-canvas-wrapper.landscape canvas {\n    width: 2000px !important;\n    height: 1600px !important;\n    min-width: 2000px !important;\n    min-height: 1600px !important;\n}\n\n/* React PDF page styling */\n.pdf-viewer-page .react-pdf__Page {\n    width: 1400px !important;\n    height: 1600px !important;\n    min-width: 1400px !important;\n    min-height: 1200px !important;\n    transform: none !important;\n    scale: 1 !important;\n    object-fit: contain !important;\n    transition: all 0.3s ease;\n}\n\n.pdf-viewer-page .react-pdf__Page__canvas {\n    width: 1400px !important;\n    height: 1600px !important;\n    min-width: 1400px !important;\n    min-height: 1200px !important;\n    transform: none !important;\n    scale: 1 !important;\n    object-fit: contain !important;\n    transition: all 0.3s ease;\n}\n\n.pdf-viewer-page .react-pdf__Page__svg {\n    width: 1400px !important;\n    height: 1600px !important;\n    min-width: 1400px !important;\n    min-height: 1200px !important;\n    transform: none !important;\n    scale: 1 !important;\n    object-fit: contain !important;\n    transition: all 0.3s ease;\n}\n\n/* Landscape PDF pages */\n.pdf-viewer-page .react-pdf__Page.landscape {\n    width: 2000px !important;\n    height: 1600px !important;\n    min-width: 2000px !important;\n    min-height: 1600px !important;\n}\n\n.pdf-viewer-page .react-pdf__Page__canvas.landscape {\n    width: 2000px !important;\n    height: 1600px !important;\n    min-width: 2000px !important;\n    min-height: 1600px !important;\n}\n\n.pdf-viewer-page .react-pdf__Page__svg.landscape {\n    width: 2000px !important;\n    height: 1600px !important;\n    min-width: 2000px !important;\n    min-height: 1600px !important;\n}\n\n/* Responsive scaling for PDF components */\n@media (max-width: 1200px) {\n\n    .pdf-viewer-page .pdf-canvas-wrapper,\n    .pdf-viewer-page .stage-absolute,\n    .pdf-viewer-page .pdf-canvas-wrapper canvas,\n    .pdf-viewer-page .react-pdf__Page,\n    .pdf-viewer-page .react-pdf__Page__canvas,\n    .pdf-viewer-page .react-pdf__Page__svg {\n        width: 1400px !important;\n        height: 1600px !important;\n        min-width: 1400px !important;\n        min-height: 1200px !important;\n    }\n\n    .pdf-viewer-page .pdf-konva-container {\n        width: 1400px;\n        height: 1600px;\n        min-width: 1400px;\n        min-height: 1200px;\n    }\n\n    /* Landscape orientation */\n    .pdf-viewer-page .pdf-canvas-wrapper.landscape,\n    .pdf-viewer-page .stage-absolute.landscape,\n    .pdf-viewer-page .pdf-canvas-wrapper.landscape canvas,\n    .pdf-viewer-page .react-pdf__Page.landscape,\n    .pdf-viewer-page .react-pdf__Page__canvas.landscape,\n    .pdf-viewer-page .react-pdf__Page__svg.landscape {\n        width: 2000px !important;\n        height: 1600px !important;\n        min-width: 2000px !important;\n        min-height: 1600px !important;\n    }\n\n    .pdf-viewer-page .pdf-konva-container.landscape {\n        width: 2000px;\n        height: 1600px;\n        min-width: 2000px;\n        min-height: 1600px;\n    }\n}\n\n/* All smaller breakpoints use same PDF dimensions */\n@media (max-width: 1000px),\n(max-width: 800px),\n(max-width: 600px) {\n\n    .pdf-viewer-page .pdf-canvas-wrapper,\n    .pdf-viewer-page .stage-absolute,\n    .pdf-viewer-page .pdf-canvas-wrapper canvas,\n    .pdf-viewer-page .react-pdf__Page,\n    .pdf-viewer-page .react-pdf__Page__canvas,\n    .pdf-viewer-page .react-pdf__Page__svg {\n        width: 1400px !important;\n        height: 1600px !important;\n        min-width: 1400px !important;\n        min-height: 1200px !important;\n    }\n\n    .pdf-viewer-page .pdf-konva-container {\n        width: 1400px;\n        height: 1600px;\n        min-width: 1400px;\n        min-height: 1200px;\n    }\n}\n\n/* Bottom measurement legend bar — всегда внизу экрана, над скроллбаром */\n.pdf-viewer-page .measurement-legend-bar {\n    position: fixed;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: transparent;\n    padding: 62px 12px 16px 12px;\n    box-shadow: none;\n    z-index: 1000;\n    display: flex;\n    justify-content: flex-start;\n    gap: 14px;\n    font-size: 15px;\n    overflow-x: auto;\n    overflow-y: visible;\n    flex-wrap: nowrap;\n    pointer-events: none;\n    min-width: 0;\n    align-items: flex-end;\n}\n\n.pdf-viewer-page .measurement-legend-item {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 6px 10px;\n    background: #f0efef;\n    border-radius: 6px;\n    border: 1px solid #000000;\n    font-size: 15px;\n    flex-shrink: 0;\n    pointer-events: auto;\n    cursor: inherit;\n    height: 62px;\n    box-sizing: border-box;\n    transition: box-shadow 0.3s ease, border-color 0.3s ease, background-color 0.3s ease, transform 0.3s ease;\n    box-shadow: 0 2px 16px rgba(44, 62, 80, 0.12), 0 1.5px 6px rgba(44, 62, 80, 0.12);\n}\n\n.pdf-viewer-page .measurement-legend-item-clickable {\n    cursor: pointer;\n    transition: box-shadow 0.3s ease, border-color 0.3s ease, background-color 0.3s ease, transform 0.3s ease;\n}\n\n\n\n.pdf-viewer-page .measurement-legend-item-selected {\n    border-color: #383838;\n    border-width: 2px;\n    z-index: 1001;\n    position: relative;\n    background: #ffffff;\n    transform: translateY(-25px);\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15), 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.pdf-viewer-page .measurement-legend-number,\n.pdf-viewer-page .pdf-info-bar .legend-number {\n    width: 38px;\n    height: 38px;\n    border-radius: 5px;\n    position: relative;\n    overflow: hidden;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-weight: bold;\n    font-size: 16px;\n}\n\n.pdf-viewer-page .measurement-legend-img {\n    max-height: 50px !important;\n    max-width: 150px;\n    width: 150px;\n    height: 50px !important;\n    object-fit: contain;\n    margin-left: 0px;\n    margin-right: 0px;\n}\n\n.pdf-viewer-page .measurement-legend-img-placeholder {\n    width: 50px;\n    height: 50px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: #153472;\n    border-radius: 5px;\n    font-weight: bold;\n    font-size: 20px;\n    color: #ffffff;\n}\n\n.measurement-legend-number.legend-1 {\n    background-color: rgba(37, 99, 235, 0.53);\n}\n\n.measurement-legend-number.legend-2 {\n    background-color: rgba(220, 38, 38, 0.53);\n}\n\n.measurement-legend-number.legend-3 {\n    background-color: rgba(22, 163, 74, 0.53);\n}\n\n.measurement-legend-number.legend-4 {\n    background-color: rgba(124, 58, 237, 0.53);\n}\n\n.measurement-legend-number.legend-5 {\n    background-color: rgba(234, 88, 12, 0.53);\n}\n\n.measurement-legend-number.legend-6 {\n    background-color: rgba(234, 179, 8, 0.53);\n}\n\n/* Context menu styles */\n.pdf-viewer-page .context-menu {\n    position: fixed;\n    width: fit-content;\n    min-width: 170px;\n    background: white;\n    box-shadow: 0 0 5px grey;\n    border-radius: 8px;\n    z-index: 9999;\n    padding: 16px;\n    cursor: default;\n    user-select: none;\n}\n\n.pdf-viewer-page .context-menu-editor {\n    min-width: 170px;\n}\n\n/* ===== User context menu (role: user) ===== */\n.pdf-viewer-page .context-menu.context-menu-user {\n    padding: 0;\n    width: fit-content;\n    min-width: fit-content;\n}\n\n.pdf-viewer-page .context-menu-user .context-menu-user-sequence-number {\n    flex-shrink: 0;\n    align-self: flex-start;\n    font-weight: normal;\n    font-size: 1.125rem;\n    line-height: 1;\n    color: #000;\n    min-width: 1.25em;\n    text-align: left;\n}\n\n.pdf-viewer-page .context-menu-user .context-menu-user-submitted-with-sequence {\n    display: flex;\n    align-items: flex-start;\n    gap: 12px;\n    padding: 8px;\n    flex-wrap: wrap;\n}\n\n.pdf-viewer-page .context-menu-user .context-menu-user-submitted-with-sequence .context-menu-submitted-value {\n    margin-bottom: 0;\n}\n\n/* --- Non-measurement tools: ok/no buttons | image | submit in one row --- */\n.pdf-viewer-page .context-menu-user .context-menu-non-measurement-row {\n    display: flex;\n    align-items: center;\n    gap: 24px;\n    padding: 8px;\n}\n\n/* Match measurement row: vertically centered sequence number and spacing to tool image */\n.pdf-viewer-page .context-menu-user .context-menu-non-measurement-row .context-menu-user-sequence-number {\n    align-self: center;\n    margin-left: 10px;\n    margin-right: -16px;\n}\n\n.pdf-viewer-page .context-menu-non-measurement-row .ok-no-buttons-group {\n    display: flex;\n    gap: 6px;\n    flex-shrink: 0;\n}\n\n.pdf-viewer-page .context-menu-non-measurement-row .context-menu-tool-image-row {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-shrink: 0;\n    width: fit-content;\n    min-height: 0;\n    padding: 0 10px;\n}\n\n.pdf-viewer-page .context-menu-non-measurement-row .measurement-legend-img {\n    width: auto !important;\n    height: 50px !important;\n    max-width: 150px !important;\n    max-height: 50px !important;\n    object-fit: contain;\n    display: block;\n    opacity: 0;\n    transition: opacity 0.15s ease;\n}\n\n.pdf-viewer-page .context-menu-non-measurement-row .measurement-legend-img.measurement-legend-img-loaded {\n    opacity: 1;\n}\n\n.pdf-viewer-page .context-menu-non-measurement-row .measurement-legend-img-placeholder {\n    width: 60px;\n    height: 60px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.pdf-viewer-page .context-menu-non-measurement-row .context-menu-btn-done {\n    flex-shrink: 0;\n    margin: 0 10px;\n}\n\n/* --- Exam mode: image-based tool dropdown & result feedback --- */\n.pdf-viewer-page .exam-tool-dropdown {\n    position: relative;\n    flex-shrink: 0;\n}\n\n.pdf-viewer-page .exam-tool-dropdown-trigger {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 52px;\n    height: 52px;\n    border: 2px solid #d1d5db;\n    border-radius: 8px;\n    background: #f9fafb;\n    cursor: pointer;\n    padding: 3px;\n    transition: border-color 0.15s;\n}\n\n.pdf-viewer-page .exam-tool-dropdown-trigger:hover {\n    border-color: #6366f1;\n}\n\n.pdf-viewer-page .exam-tool-dropdown-img {\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n    border-radius: 4px;\n}\n\n.pdf-viewer-page .exam-tool-dropdown-placeholder {\n    font-size: 11px;\n    color: #9ca3af;\n    text-align: center;\n    line-height: 1.2;\n}\n\n.pdf-viewer-page .exam-tool-dropdown-placeholder-letter {\n    font-size: 20px;\n    font-weight: 600;\n    color: #6b7280;\n}\n\n.pdf-viewer-page .exam-tool-dropdown-panel {\n    position: absolute;\n    top: calc(100% + 6px);\n    left: 50%;\n    transform: translateX(-50%);\n    display: flex;\n    flex-wrap: wrap;\n    gap: 6px;\n    padding: 8px;\n    background: #fff;\n    border: 1px solid #d1d5db;\n    border-radius: 10px;\n    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);\n    z-index: 100;\n    max-width: 280px;\n}\n\n.pdf-viewer-page .exam-tool-dropdown-item {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 56px;\n    height: 56px;\n    border: 2px solid transparent;\n    border-radius: 8px;\n    background: #f3f4f6;\n    cursor: pointer;\n    padding: 3px;\n    transition: border-color 0.15s, background 0.15s;\n}\n\n.pdf-viewer-page .exam-tool-dropdown-item:hover {\n    border-color: #6366f1;\n    background: #eef2ff;\n}\n\n.pdf-viewer-page .exam-tool-dropdown-item-selected {\n    border-color: #4f46e5;\n    background: #e0e7ff;\n}\n\n.pdf-viewer-page .exam-tool-dropdown-item-img {\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n    border-radius: 4px;\n}\n\n.pdf-viewer-page .exam-tool-dropdown-item-placeholder {\n    font-size: 18px;\n    font-weight: 600;\n    color: #6b7280;\n}\n\n.pdf-viewer-page .exam-tool-result {\n    font-size: 13px;\n    padding: 4px 10px;\n    border-radius: 4px;\n    white-space: nowrap;\n}\n\n.pdf-viewer-page .exam-tool-correct {\n    color: #065f46;\n    background-color: #d1fae5;\n}\n\n.pdf-viewer-page .exam-tool-incorrect {\n    color: #991b1b;\n    background-color: #fee2e2;\n}\n\n/* --- Measurement tools: image | input | submit in one row --- */\n.pdf-viewer-page .context-menu-user .tolerance-input-group {\n    flex-shrink: 0;\n    padding: 8px;\n}\n\n.pdf-viewer-page .context-menu-user .context-menu-user-image-input-row {\n    display: flex;\n    align-items: center;\n    gap: 24px;\n    width: 100%;\n}\n\n.pdf-viewer-page .context-menu-user .context-menu-user-image-input-row .context-menu-user-sequence-number {\n    align-self: center;\n    margin-left: 10px;\n    /* Negative right margin cancels parent gap (24px) so visual distance to image equals left indent */\n    margin-right: -16px;\n}\n\n.pdf-viewer-page .context-menu-user .context-menu-user-image-input-row .context-menu-tool-image-row {\n    flex-shrink: 0;\n    width: fit-content;\n    padding: 0 10px;\n}\n\n.pdf-viewer-page .context-menu-user .context-menu-user-image-input-row .measurement-legend-img {\n    width: auto !important;\n    max-width: 150px !important;\n    max-height: 150px !important;\n    height: auto;\n    object-fit: contain;\n    opacity: 0;\n    transition: opacity 0.15s ease;\n}\n\n.pdf-viewer-page .context-menu-user .context-menu-user-image-input-row .measurement-legend-img.measurement-legend-img-loaded {\n    opacity: 1;\n}\n\n.pdf-viewer-page .context-menu-user .context-menu-user-image-input-row .measurement-legend-img-placeholder {\n    width: 60px;\n    height: 60px;\n    font-size: 48px;\n}\n\n.pdf-viewer-page .context-menu-user .context-menu-user-image-input-row .context-menu-user-dimension-info {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    flex-shrink: 0;\n    font-family: 'Arial', sans-serif;\n    white-space: nowrap;\n    user-select: none;\n}\n\n.pdf-viewer-page .context-menu-user .context-menu-user-image-input-row .context-menu-user-dimension-nominal {\n    font-size: 22px;\n    font-weight: 600;\n    line-height: 1;\n    color: #222;\n}\n\n.pdf-viewer-page .context-menu-user .context-menu-user-image-input-row .context-menu-user-dimension-tolerances {\n    display: inline-flex;\n    flex-direction: column;\n    justify-content: center;\n    font-size: 13px;\n    line-height: 1.15;\n    color: #555;\n}\n\n.pdf-viewer-page .context-menu-user .context-menu-user-image-input-row .context-menu-user-dimension-tolerance-plus,\n.pdf-viewer-page .context-menu-user .context-menu-user-image-input-row .context-menu-user-dimension-tolerance-minus {\n    font-variant-numeric: tabular-nums;\n}\n\n.pdf-viewer-page .context-menu-user .context-menu-user-image-input-row .user-measurement-input {\n    width: 90px;\n    padding: 0 10px;\n}\n\n.pdf-viewer-page .context-menu-user .context-menu-user-image-input-row .context-menu-btn-done {\n    margin: 0 10px;\n}\n\n.pdf-viewer-page .context-menu:has(.context-menu-submitted-value) {\n    padding: 0px;\n    min-width: auto;\n    min-height: auto;\n    width: fit-content;\n    height: auto;\n    display: flex;\n    flex-direction: column;\n    flex-wrap: nowrap;\n}\n\n.pdf-viewer-page .context-menu-input {\n    height: 35px;\n    padding: 0px;\n    padding-left: 8px;\n    border: 1px solid #ccc;\n    border-radius: 6px;\n    margin-top: 0px;\n    margin-bottom: 0px;\n    font-size: 14px;\n    box-sizing: border-box;\n    background: white;\n    color: #1a365d;\n    cursor: text;\n    user-select: text;\n}\n\n.pdf-viewer-page .user-measurement-input {\n    width: 90px;\n    max-width: 90px;\n    min-width: 0;\n    cursor: text;\n    user-select: text;\n}\n\n.pdf-viewer-page .context-menu input[type=\"text\"]:not(.user-measurement-input) {\n    width: 50px;\n    height: 35px;\n    padding: 0px;\n    padding-left: 8px;\n    box-sizing: border-box;\n    background: white;\n    color: #1a365d;\n    cursor: text;\n    user-select: text;\n}\n\n.pdf-viewer-page .tolerance-input-row-1 input {\n    width: 70px;\n}\n\n.pdf-viewer-page .tolerance-input-row-tool-block {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n}\n\n.pdf-viewer-page .tolerance-input-row-tool-with-recognition {\n    display: flex;\n    flex-direction: row;\n    align-items: flex-start;\n    flex-wrap: nowrap;\n    gap: 8px;\n}\n\n.pdf-viewer-page .tolerance-input-tool-and-recognized {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n}\n\n.pdf-viewer-page .tolerance-input-tool-row-with-ocr {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 6px;\n    flex-wrap: nowrap;\n}\n\n.pdf-viewer-page .context-menu-region-ocr-btn {\n    width: 40px;\n    height: 40px;\n    min-width: 40px;\n    padding: 0;\n    border: 1px solid #e5e7eb;\n    border-radius: 4px;\n    background-color: #ffffff;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n    color: #1a365d;\n}\n\n.pdf-viewer-page .context-menu-region-ocr-btn:hover:not(:disabled) {\n    background-color: #f3f4f6;\n}\n\n.pdf-viewer-page .context-menu-region-ocr-btn-icon {\n    width: 22px;\n    height: 22px;\n    display: block;\n}\n\n.pdf-viewer-page .context-menu-region-ocr-btn--loading .context-menu-region-ocr-btn-icon {\n    animation: context-menu-region-ocr-pulse 0.9s ease-in-out infinite;\n}\n\n@keyframes context-menu-region-ocr-pulse {\n    0%,\n    100% {\n        opacity: 1;\n    }\n    50% {\n        opacity: 0.35;\n    }\n}\n\n.pdf-viewer-page .tolerance-input-container .context-menu-recognized-value {\n    font-size: 20px;\n    color: #000000;\n    font-weight: 600;\n    max-width: 120px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.pdf-viewer-page .context-menu .tolerance-input-wrapper input[type=\"text\"] {\n    width: 70px;\n    height: 35px;\n    padding: 0px;\n    padding-left: 8px;\n    box-sizing: border-box;\n    background: white;\n    color: #1a365d;\n    cursor: text;\n    user-select: text;\n}\n\n/* PDF context menu checkbox: сбрасываем глобальные стили input, оставляем дефолтный чекбокс */\n.pdf-viewer-page .context-menu input[type=\"checkbox\"] {\n    width: 30px;\n    height: 30px;\n    margin: 0 4px 0 4px;\n    padding: 0;\n    border-radius: 4px;\n    border: 2px solid #d1d5db;\n    background-color: #ffffff;\n    /* same as context menu background when unchecked */\n    box-shadow: none;\n    appearance: none;\n    /* fully custom checkbox */\n    cursor: pointer;\n    position: relative;\n}\n\n.pdf-viewer-page .context-menu input[type=\"checkbox\"]:checked {\n    background-color: #ffffff;\n    border-color: #6b7280;\n}\n\n.pdf-viewer-page .context-menu input[type=\"checkbox\"]:checked::after {\n    content: \"\";\n    position: absolute;\n    left: 50%;\n    top: 45%;\n    width: 5px;\n    height: 10px;\n    border: solid #d12626;\n    /* dark gray tick visible on white */\n    border-width: 0 2px 2px 0;\n    transform: translate(-50%, -50%) rotate(45deg);\n}\n\n.pdf-viewer-page .context-menu-input.input-error {\n    border-color: #DC2626;\n    background-color: #FEF2F2;\n}\n\n.pdf-viewer-page .context-menu-input.input-error:focus {\n    border-color: #DC2626;\n    outline-color: #DC2626;\n}\n\n.pdf-viewer-page .settings-file-error {\n    padding: 10px;\n    background-color: #fee;\n    color: #c33;\n    margin: 10px;\n    border-radius: 4px;\n    text-align: center;\n}\n\n.pdf-viewer-page .tool-input-error {\n    color: #DC2626;\n    font-size: 0.75rem;\n    margin-top: 0.25rem;\n    padding-left: 0.5rem;\n}\n\n.pdf-viewer-page .context-menu-input:focus {\n    border-color: #a5b4fc;\n    outline: none;\n    box-shadow: 0 0 0 2px #e0e7ff;\n}\n\n.pdf-viewer-page .context-menu-submitted-value {\n    padding: 8px 16px;\n    border: 1px solid #d1d5db;\n    border-radius: 6px;\n    background-color: #f9fafb;\n    color: #80736b;\n    font-size: 24px;\n    width: auto;\n    height: auto;\n    min-width: auto;\n    min-height: auto;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 0px;\n    font-weight: 500;\n    white-space: nowrap;\n    flex-shrink: 0;\n}\n\n.pdf-viewer-page .context-menu-btn-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-top: 12px;\n}\n\n.pdf-viewer-page .context-menu-btn-row .measurement-legend-img {\n    flex: 1;\n    width: fit-content;\n    height: 50px !important;\n    max-width: 150px;\n    max-height: 50px !important;\n    margin-right: 12px;\n    object-fit: cover;\n}\n\n.pdf-viewer-page .context-menu-btn-delete {\n    width: 48px;\n    height: 48px;\n    background: #fee2e2;\n    border: 2px solid #fecaca;\n    padding: 12px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 8px;\n    transition: all 0.2s ease;\n    color: #414040;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.pdf-viewer-page .context-menu-btn-delete-small {\n    width: 32px;\n    height: 32px;\n    padding: 6px;\n    flex-shrink: 0;\n}\n\n.pdf-viewer-page .tool-input-row {\n    display: flex;\n    flex-direction: row;\n    align-items: flex-end;\n    gap: 8px;\n}\n\n.pdf-viewer-page .tool-input-wrapper {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    flex: 1;\n}\n\n.pdf-viewer-page .tool-display-row {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    margin-bottom: 8px;\n}\n\n.pdf-viewer-page .selected-tool-display {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 8px 12px;\n    background: #f3f4f6;\n    border-radius: 6px;\n    border: 1px solid #e5e7eb;\n}\n\n.pdf-viewer-page .selected-tool-number {\n    width: 32px;\n    height: 32px;\n    border-radius: 4px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-weight: bold;\n    font-size: 14px;\n    flex-shrink: 0;\n}\n\n.pdf-viewer-page .selected-tool-name {\n    font-size: 14px;\n    color: #374151;\n}\n\n.pdf-viewer-page .no-tool-selected-message {\n    padding: 8px 12px;\n    background: #fef3c7;\n    border-radius: 6px;\n    border: 1px solid #f59e0b;\n    font-size: 13px;\n    color: #92400e;\n}\n\n.pdf-viewer-page .context-menu-btn-delete:hover {\n    background: #fecaca;\n    border-color: #f31717;\n    transform: translateY(-1px);\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.pdf-viewer-page .context-menu-btn-done {\n    /* step 2 */\n    width: 45px;\n    height: 45px;\n    background: #d1fae5;\n    border: 2px solid #a7f3d0;\n    padding: 6px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 6px;\n    transition: all 0.2s ease;\n    color: #414040;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n    flex-shrink: 0;\n}\n\n.pdf-viewer-page .context-menu-btn-done:hover {\n    background: #b4f0d4;\n    border-color: #00f794;\n    transform: translateY(-1px);\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.pdf-viewer-page .context-menu-btn-done:focus,\n.pdf-viewer-page .context-menu-btn-done:focus-visible {\n    outline: none;\n    border-color: #00f794;\n    box-shadow: 0 0 0 1px #566677;\n}\n\n.pdf-viewer-page .context-menu-btn-done:disabled,\n.pdf-viewer-page .context-menu-btn-done.btn-disabled {\n    width: 38px;\n    height: 38px;\n    padding: 5px;\n    cursor: not-allowed;\n    opacity: 0.6;\n    background: #cbd5e1;\n    border: 2px solid #cbd5e1;\n    transform: none;\n}\n\n.pdf-viewer-page .context-menu-btn-done:disabled:hover,\n.pdf-viewer-page .context-menu-btn-done.btn-disabled:hover {\n    border: 2px solid #cbd5e1;\n    opacity: 0.6;\n    transform: none;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.pdf-viewer-page .context-menu-btn-done.btn-enabled {\n    background: #d1fae5;\n    border: 2px solid #a7f3d0;\n    color: #414040;\n    cursor: pointer;\n    opacity: 1;\n}\n\n.pdf-viewer-page .context-menu-btn-done.btn-enabled:hover {\n    background: #b4f0d4;\n    border-color: #00f794;\n    transform: translateY(-1px);\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n\n.pdf-viewer-page .context-menu-btn-ok-no {\n    flex: 0 0 auto;\n    padding: 0.5rem;\n    min-width: 40px;\n    height: 40px;\n    font-size: 1.2rem;\n    font-weight: bold;\n    border: 2px solid #d1d5db;\n    border-radius: 8px;\n    background-color: white;\n    color: #374151;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.pdf-viewer-page .context-menu-btn-ok-no:hover {\n    border-color: #1a365d;\n    background-color: #f3f4f6;\n}\n\n.pdf-viewer-page .context-menu-btn-ok-no:focus,\n.pdf-viewer-page .context-menu-btn-ok-no:focus-visible {\n    outline: none;\n    border-color: #1a365d;\n    box-shadow: 0 0 0 1px #566677;\n}\n\n.pdf-viewer-page .context-menu-btn-ok-no.selected {\n    border-color: #1a365d;\n    background-color: #1a365d;\n    color: white;\n}\n\n.pdf-viewer-page .context-menu-btn-ok-no.selected:focus,\n.pdf-viewer-page .context-menu-btn-ok-no.selected:focus-visible {\n    outline: none;\n    border-color: #1a365d;\n    box-shadow: 0 0 0 1px #566677;\n}\n\n.pdf-viewer-page .context-menu-btn-done-full-width {\n    width: 100%;\n    margin-top: 0.5rem;\n}\n\n/* Context menu positioning */\n.pdf-viewer-page .context-menu-positioned {\n    position: absolute;\n}\n\n/* Tolerance input styling */\n.pdf-viewer-page .tolerance-input-group {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 8px;\n    margin-bottom: 0px;\n    width: 100%;\n    padding-top: 16px;\n    padding-bottom: 16px;\n}\n\n.pdf-viewer-page .tolerance-input-group .measurement-legend-img {\n    width: 35px;\n    height: 35px;\n    object-fit: contain;\n    flex-shrink: 0;\n}\n\n.pdf-viewer-page .context-menu-tool-image-row {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-top: 8px;\n}\n\n.pdf-viewer-page .context-menu-tool-image-row .measurement-legend-img {\n    width: 100%;\n    height: 50px !important;\n    max-width: 250px;\n    max-height: 50px !important;\n    object-fit: contain;\n}\n\n\n.pdf-viewer-page .tolerance-input-group:has(.context-menu-submitted-value) {\n    padding: 0px;\n    margin-bottom: 0px;\n    flex-direction: column;\n    height: auto;\n    min-height: auto;\n}\n\n.pdf-viewer-page .tolerance-label {\n    font-size: 14px;\n    color: #374151;\n    cursor: pointer;\n    margin: 0;\n    user-select: none;\n    display: flex;\n    align-items: center;\n    line-height: 1;\n}\n\n.pdf-viewer-page .tolerance-input-container {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    margin-bottom: 16px;\n}\n\n.pdf-viewer-page .tolerance-input-row-1 {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 4px;\n}\n\n.pdf-viewer-page .tolerance-input-row-1 input {\n    width: 70px;\n}\n\n.pdf-viewer-page .tolerance-input-row-1 #nominal-dimension {\n    width: 70px;\n}\n\n.pdf-viewer-page .tolerance-input-row-full-width .nominal-input-with-buttons {\n    width: 100%;\n}\n\n.pdf-viewer-page .tolerance-input-row-full-width .nominal-input-with-buttons input {\n    width: auto;\n}\n\n.pdf-viewer-page .tolerance-input-row-2 {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 4px;\n}\n\n.pdf-viewer-page .tolerance-input-row-3 {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 12px;\n    flex-wrap: wrap;\n}\n\n.pdf-viewer-page .tolerance-input-wrapper {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n}\n\n.pdf-viewer-page .tolerance-input-wrapper input {\n    height: 35px !important;\n    padding: 0px !important;\n    padding-left: 8px !important;\n    cursor: text;\n    user-select: text;\n}\n\n.pdf-viewer-page .tolerance-input-label {\n    font-weight: 500;\n    font-size: 14px;\n    color: #374151;\n}\n\n.pdf-viewer-page .tolerance-type-label {\n    font-weight: 500;\n    font-size: 14px;\n    color: #374151;\n    white-space: nowrap;\n    margin: 0;\n}\n\n.pdf-viewer-page .nominal-input-with-buttons {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 8px;\n}\n\n.pdf-viewer-page .nominal-input-with-buttons input {\n    flex: 1;\n    min-width: 0;\n}\n\n.pdf-viewer-page .nominal-input-with-buttons-stacked {\n    flex-direction: column;\n    align-items: stretch;\n    width: 100%;\n}\n\n.pdf-viewer-page .nominal-input-with-buttons-stacked input,\n.pdf-viewer-page .tolerance-input-row-full-width .nominal-input-with-buttons-stacked input,\n.pdf-viewer-page .nominal-input-with-buttons-stacked #nominal-dimension {\n    width: 100% !important;\n    min-width: 0;\n    box-sizing: border-box;\n    height: 35px;\n    min-height: 35px;\n}\n\n.pdf-viewer-page .nominal-symbol-buttons {\n    display: flex;\n    gap: 6px;\n    flex-shrink: 0;\n}\n\n.pdf-viewer-page .nominal-symbol-btn {\n    width: 40px;\n    height: 40px;\n    padding: 0;\n    border: 1px solid #e5e7eb;\n    border-radius: 4px;\n    background-color: #ffffff;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    overflow: hidden;\n    transition: background-color 0.15s;\n}\n\n.pdf-viewer-page .nominal-symbol-btn:hover {\n    background-color: #f3f4f6;\n}\n\n.pdf-viewer-page .nominal-symbol-btn.selected {\n    border-color: #6b7280;\n    border-width: 2px;\n    box-shadow: 0 0 0 1px #6b7280;\n}\n\n.pdf-viewer-page .nominal-symbol-btn img {\n    width: 70%;\n    height: 70%;\n    object-fit: contain;\n}\n\n.pdf-viewer-page .nominal-hole-shaft-wrapper {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    margin-top: 6px;\n}\n\n.pdf-viewer-page .nominal-hole-shaft-buttons {\n    display: flex;\n    gap: 6px;\n}\n\n.pdf-viewer-page .hole-shaft-error {\n    font-size: 11px;\n    color: #dc2626;\n}\n\n.pdf-viewer-page .context-menu-hole-shaft-btn {\n    width: 40px;\n    height: 40px;\n    padding: 0;\n    border: 1px solid #e5e7eb;\n    border-radius: 4px;\n    background-color: #ffffff;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    overflow: hidden;\n    transition: background-color 0.15s;\n}\n\n.pdf-viewer-page .context-menu-hole-shaft-btn:hover {\n    background-color: #f3f4f6;\n}\n\n.pdf-viewer-page .context-menu-hole-shaft-btn.selected {\n    border-color: #6b7280;\n    border-width: 2px;\n    box-shadow: 0 0 0 1px #6b7280;\n}\n\n.pdf-viewer-page .context-menu-hole-shaft-btn.m-mode-active {\n    border-color: #ea580c;\n    border-width: 2px;\n    box-shadow: 0 0 0 1px #ea580c;\n}\n\n.pdf-viewer-page .context-menu-hole-shaft-btn img {\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n}\n\n.pdf-viewer-page .hole-shaft-m-btn-wrapper {\n    position: relative;\n}\n\n.pdf-viewer-page .context-menu-m-btn {\n    font-size: 16px;\n    font-weight: 700;\n    font-family: 'Lato', -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif;\n}\n\n.pdf-viewer-page .context-menu-m-btn.m-open {\n    background-color: #f97316;\n    border-color: #ea580c;\n    color: #ffffff;\n}\n\n.pdf-viewer-page .context-menu-m-btn.m-open:hover {\n    background-color: #ea580c;\n}\n\n.pdf-viewer-page .context-menu-m-btn.m-has-designation {\n    min-width: 52px;\n    font-size: 11px;\n    padding: 0 4px;\n}\n\n.pdf-viewer-page .hole-shaft-m-dropdown {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    margin-top: 4px;\n    max-height: 280px;\n    overflow-y: auto;\n    background-color: #ffffff;\n    border: 1px solid #e5e7eb;\n    border-radius: 4px;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n    z-index: 1000;\n    min-width: 120px;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n}\n\n.pdf-viewer-page .hole-shaft-m-dropdown-item {\n    display: block;\n    width: 100%;\n    padding: 6px 12px;\n    text-align: left;\n    border: none;\n    background: none;\n    cursor: pointer;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    font-size: 13px;\n    font-family: 'Lato', -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif;\n    color: #374151;\n}\n\n.pdf-viewer-page .hole-shaft-m-dropdown-item:hover {\n    background-color: #f3f4f6;\n}\n\n.pdf-viewer-page .nominal-dimension-buttons {\n    display: flex;\n    gap: 8px;\n    justify-content: flex-start;\n    align-items: center;\n}\n\n.pdf-viewer-page .nominal-btn {\n    padding: 0px 12px;\n    width: 25px;\n    border: 2px solid #d1d5db;\n    border-radius: 4px;\n    background-color: #ffffff;\n    cursor: pointer;\n    font-size: 18px;\n    transition: all 0.1s ease;\n    color: #374151;\n    font-weight: 600;\n    font-family: 'Lato', -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n    background-clip: border-box;\n    -webkit-background-clip: border-box;\n    box-shadow: none;\n    vertical-align: middle;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n}\n\n.pdf-viewer-page .nominal-btn:hover {\n    background-color: #ffffff;\n    border-color: #9ca3af;\n}\n\n.pdf-viewer-page .nominal-btn.selected {\n    background-color: #EFEAEA;\n    color: rgba(0, 0, 0, 1);\n    border-color: #6b7280;\n    border-width: 2px;\n    box-shadow: 0 0 0 1px #6b7280;\n    font-weight: 900;\n    font-size: 20px;\n    background-clip: unset;\n    -webkit-background-clip: unset;\n    font-family: 'Lato', -apple-system, sans-serif;\n}\n\n.pdf-viewer-page .nominal-btn-small {\n    height: auto;\n    min-height: 40px;\n}\n\n/* b- */\n/* .nominal-btn.btn-disabled {\n    opacity: 0.5;=\n\n    cursor: not-allowed;\n} */\n\n.pdf-viewer-page .tolerance-inputs-row {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    align-items: flex-start;\n}\n\n.pdf-viewer-page .tolerance-inputs-row-left {\n    flex-shrink: 0;\n    margin-right: 12px;\n}\n\n.pdf-viewer-page .tolerance-input-row-4 {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    align-items: flex-start;\n    margin-left: 0;\n    padding-left: 0;\n}\n\n.pdf-viewer-page .tolerance-input-row-4.iso2768-tolerance-row-with-actions {\n    flex-direction: row;\n    flex-wrap: nowrap;\n    align-items: flex-end;\n    justify-content: space-between;\n    gap: 10px;\n    width: 100%;\n}\n\n.pdf-viewer-page .iso2768-tolerance-inputs-stack {\n    flex: 1;\n    min-width: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n}\n\n.pdf-viewer-page .iso2768-rc-buttons {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n    flex-shrink: 0;\n    align-self: flex-end;\n    padding-bottom: 2px;\n}\n\n.pdf-viewer-page .iso2768-rc-btn.iso2768-rc-btn {\n    min-width: 36px;\n    min-height: 32px;\n    font-weight: 700;\n    font-size: 15px;\n    line-height: 1;\n    padding: 4px 8px;\n    user-select: none;\n    -webkit-user-select: none;\n}\n\n.pdf-viewer-page .tolerance-inputs-row-compact .tolerance-input-rida {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    gap: 2px;\n    margin-left: 0;\n    padding-left: 0;\n}\n\n.pdf-viewer-page .tolerance-inputs-row-compact .tolerantsi-silt {\n    min-width: 16px;\n    padding-right: 0;\n    margin: 0;\n    width: auto;\n}\n\n.pdf-viewer-page .tolerance-input-rida {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    gap: 8px;\n    text-align: center;\n}\n\n.pdf-viewer-page .tolerantsi-silt {\n    min-width: 50px;\n    font-weight: normal;\n    text-align: right;\n    padding-right: 2px;\n    line-height: 35px;\n    font-size: 18px;\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    align-self: center;\n    margin-bottom: 0px !important;\n}\n\n\n/* Pagination */\n.pdf-viewer-page .pdf-pagination {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 16px;\n    padding: 16px;\n    background: #f8fafc;\n    border-top: 1px solid #e2e8f0;\n}\n\n.pdf-viewer-page .pdf-pagination button {\n    padding: 8px 16px;\n    border: 1px solid #d1d5db;\n    border-radius: 6px;\n    background: white;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.pdf-viewer-page .pdf-pagination button:hover:not(:disabled) {\n    background: #f3f4f6;\n    border-color: #9ca3af;\n}\n\n\n/* Specific button variants */\n.pdf-viewer-page .pdf-back-btn {\n    background: none;\n    border: 2px solid #aeb2b0;\n    padding: 12px;\n    border-radius: 12px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 48px;\n    height: 48px;\n    flex-shrink: 0;\n    color: #000000;\n}\n\n.pdf-viewer-page .pdf-back-btn:hover {\n    background: #EFEAEA;\n    transform: translateY(-1px);\n    box-shadow: 0 6px 12px #cfcbcb;\n}\n\n.pdf-viewer-page .pdf-role-switch {\n    display: flex;\n    border: 2px solid #aeb2b0;\n    border-radius: 12px;\n    overflow: hidden;\n    flex-shrink: 0;\n    margin-left: 12px;\n}\n\n.pdf-viewer-page .pdf-role-switch-option {\n    width: 36px;\n    height: 48px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 16px;\n    font-weight: 700;\n    background: none;\n    border: none;\n    color: #000000;\n    cursor: pointer;\n    transition: background 0.2s ease, color 0.2s ease;\n}\n\n.pdf-viewer-page .pdf-role-switch-option:first-child {\n    border-right: 1px solid #aeb2b0;\n}\n\n.pdf-viewer-page .pdf-role-switch-option.pdf-role-switch-active {\n    background: #a4f4ba;\n    color: #393939;\n    border-color: #BBECCB;\n}\n\n.pdf-viewer-page .pdf-role-switch-option:not(.pdf-role-switch-active):hover {\n    background: #EFEAEA;\n}\n\n.pdf-viewer-page .pdf-save-btn {\n    background: none;\n    color: #000000;\n    border: 2px solid #aeb2b0;\n    border-radius: 12px;\n    padding: 12px;\n    font-size: 16px;\n    font-weight: 600;\n    min-width: 48px;\n    min-height: 48px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    text-decoration: none;\n    flex: 0 0 auto;\n    width: auto;\n}\n\n/* PDF save button enabled state */\n.pdf-viewer-page .pdf-save-btn:not(.btn-disabled) {\n    background: #a4f4ba;\n    color: #393939;\n    border: 2px solid #BBECCB;\n}\n\n.pdf-viewer-page .pdf-save-btn:not(.btn-disabled):hover {\n    background: #78f49b;\n    color: #000000;\n    transform: translateY(-1px);\n    box-shadow: 0 6px 12px rgba(37, 44, 40, 0.3);\n}\n\n/* PDF save button disabled state */\n.pdf-viewer-page .pdf-save-btn.btn-disabled {\n    background: none;\n    color: #000000;\n    border: 2px solid #aeb2b0;\n    opacity: 0.5;\n}\n\n/* Info items (read-only labels; override .pdf-viewer-page user-select:text — no I-beam) */\n.pdf-viewer-page .info-item,\n.pdf-viewer-page .info-center {\n    font-size: 14px;\n    color: #374151;\n    font-weight: 500;\n    padding: 0;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    cursor: default;\n}\n\n.pdf-viewer-page .info-center {\n    text-align: center;\n}\n\n/* Ensure buttons stay in place */\n.pdf-viewer-page .pdf-back-btn,\n.pdf-viewer-page .pdf-role-switch,\n.pdf-viewer-page .pdf-save-btn,\n.pdf-viewer-page .pdf-detect-btn,\n.pdf-viewer-page .pdf-g-btn,\n.pdf-viewer-page .pdf-help-btn {\n    flex-shrink: 0;\n}\n\n/* Detect measurements button */\n.pdf-viewer-page .pdf-detect-btn {\n    position: relative;\n    margin-left: 12px;\n    background: none;\n    color: #000000;\n    border: 2px solid #aeb2b0;\n    padding: 12px;\n    border-radius: 8px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: all 0.2s ease;\n    gap: 4px;\n}\n\n.pdf-viewer-page .pdf-detect-btn:not(.btn-disabled):hover {\n    background: #e0e7ff;\n    border-color: #6366f1;\n    color: #4338ca;\n    transform: translateY(-1px);\n    box-shadow: 0 4px 8px rgba(99, 102, 241, 0.2);\n}\n\n.pdf-viewer-page .pdf-detect-btn-active {\n    background: #e0e7ff;\n    border-color: #6366f1;\n    color: #4338ca;\n}\n\n.pdf-viewer-page .pdf-detect-btn.btn-disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n}\n\n.pdf-viewer-page .pdf-detect-btn.btn-disabled:hover {\n    transform: none;\n    box-shadow: none;\n    background: none;\n}\n\n.pdf-viewer-page .pdf-g-btn {\n    position: relative;\n    background: none;\n    color: #000000;\n    border: 2px solid #aeb2b0;\n    padding: 12px;\n    border-radius: 8px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    min-width: 48px;\n    min-height: 48px;\n    font-size: 18px;\n    font-weight: 700;\n    transition: all 0.2s ease;\n}\n\n.pdf-viewer-page .pdf-g-btn:not(.btn-disabled):hover {\n    background: #e0e7ff;\n    border-color: #6366f1;\n    color: #4338ca;\n    transform: translateY(-1px);\n    box-shadow: 0 4px 8px rgba(99, 102, 241, 0.2);\n}\n\n.pdf-viewer-page .pdf-g-btn-active {\n    background: #e0e7ff;\n    border-color: #6366f1;\n    color: #4338ca;\n}\n\n.pdf-viewer-page .pdf-g-btn.btn-disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n}\n\n.pdf-viewer-page .pdf-g-btn.btn-disabled:hover {\n    transform: none;\n    box-shadow: none;\n    background: none;\n}\n\n.pdf-viewer-page .pdf-save-pdf-btn {\n    position: relative;\n    margin-left: 12px;\n    background: none;\n    color: #000000;\n    border: 2px solid #aeb2b0;\n    padding: 8px 12px;\n    border-radius: 8px;\n    cursor: pointer;\n    font-size: 12px;\n    font-weight: 600;\n    transition: all 0.2s ease;\n}\n\n.pdf-viewer-page .pdf-save-pdf-btn:not(.btn-disabled):hover {\n    background: #e0e7ff;\n    border-color: #6366f1;\n    color: #4338ca;\n}\n\n.pdf-viewer-page .pdf-save-pdf-btn.btn-disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n}\n\n.pdf-viewer-page .pdf-help-btn {\n    position: relative;\n    margin-left: 12px;\n    background: none;\n    color: #000000;\n    border: 2px solid #aeb2b0;\n    padding: 12px;\n    border-radius: 8px;\n    cursor: pointer;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    min-width: 48px;\n    min-height: 48px;\n    font-size: 18px;\n    font-weight: 700;\n    transition: all 0.2s ease;\n}\n\n.pdf-viewer-page .pdf-help-btn:hover {\n    background: #e0e7ff;\n    border-color: #6366f1;\n    color: #4338ca;\n    transform: translateY(-1px);\n    box-shadow: 0 4px 8px rgba(99, 102, 241, 0.2);\n}\n\n.pdf-viewer-page .pdf-settings-btn {\n    position: relative;\n    margin-left: 12px;\n    background: none;\n    color: #000000;\n    border: 2px solid #aeb2b0;\n    padding: 12px;\n    border-radius: 8px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    min-width: 48px;\n    min-height: 48px;\n    font-size: 18px;\n    font-weight: 700;\n    transition: all 0.2s ease;\n}\n\n.pdf-viewer-page .pdf-settings-btn:hover {\n    background: #e0e7ff;\n    border-color: #6366f1;\n    color: #4338ca;\n    transform: translateY(-1px);\n    box-shadow: 0 4px 8px rgba(99, 102, 241, 0.2);\n}\n\n.pdf-viewer-page .pdf-settings-btn-icon {\n    display: block;\n}\n\n.pdf-viewer-page .pdf-help-btn-icon {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    cursor: pointer;\n}\n\n.pdf-viewer-page .help-menu-overlay {\n    position: fixed;\n    inset: 0;\n    background: rgba(0, 0, 0, 0.4);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 10000;\n}\n\n.pdf-viewer-page .help-menu {\n    background: #ffffff;\n    border-radius: 12px;\n    padding: 24px;\n    max-width: 420px;\n    width: 90%;\n    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);\n}\n\n.pdf-viewer-page .help-menu-title {\n    font-size: 1.25rem;\n    font-weight: 700;\n    margin-bottom: 20px;\n    color: #1a365d;\n}\n\n.pdf-viewer-page .help-menu-list {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    margin-bottom: 20px;\n}\n\n.pdf-viewer-page .help-menu-row {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n}\n\n.pdf-viewer-page .help-menu-row kbd {\n    flex-shrink: 0;\n    min-width: 60px;\n    padding: 4px 8px;\n    background: #f1f5f9;\n    border: 1px solid #cbd5e1;\n    border-radius: 6px;\n    font-family: inherit;\n    font-size: 0.9rem;\n}\n\n.pdf-viewer-page .help-menu-close {\n    width: 100%;\n    padding: 10px 16px;\n    background: #6366f1;\n    color: white;\n    border: none;\n    border-radius: 8px;\n    font-size: 1rem;\n    font-weight: 600;\n    cursor: pointer;\n}\n\n.pdf-viewer-page .help-menu-close:hover {\n    background: #4f46e5;\n}\n\n.pdf-viewer-page .settings-menu-overlay {\n    z-index: 10001;\n}\n\n.pdf-viewer-page .settings-menu {\n    max-width: 480px;\n}\n\n.pdf-viewer-page .settings-menu.settings-menu--dialog-footer {\n    padding: 0;\n    display: flex;\n    flex-direction: column;\n}\n\n.pdf-viewer-page .settings-menu.settings-menu--dialog-footer .settings-menu-dialog-body {\n    padding: 24px;\n}\n\n.pdf-viewer-page .settings-menu.settings-menu--dialog-footer .modal-footer {\n    margin-top: 0;\n    gap: 0;\n    padding: 14px 16px;\n    width: 100%;\n    box-sizing: border-box;\n}\n\n.pdf-viewer-page .settings-menu.settings-menu--dialog-footer .modal-footer .btn-secondary,\n.pdf-viewer-page .settings-menu.settings-menu--dialog-footer .modal-footer .btn-primary {\n    flex: 0 0 auto;\n    width: auto;\n    min-height: 0;\n    height: auto;\n    padding: 8px 16px;\n    font-size: 14px;\n    line-height: 1.25;\n    border-radius: 8px;\n}\n\n.pdf-viewer-page .settings-menu.settings-menu--dialog-footer .modal-footer .btn-secondary {\n    font-weight: 500;\n}\n\n.pdf-viewer-page .settings-menu.settings-menu--dialog-footer .modal-footer .btn-primary {\n    font-weight: 600;\n    box-shadow: none;\n    min-height: 0;\n}\n\n.pdf-viewer-page .settings-menu.settings-menu--dialog-footer .modal-footer .btn-primary:hover:not(:disabled) {\n    transform: none;\n}\n\n.pdf-viewer-page .settings-menu-list {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n}\n\n.pdf-viewer-page .settings-menu-checkboxes-row {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.pdf-viewer-page .settings-menu-checkbox {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    font-size: 14px;\n    cursor: pointer;\n    user-select: none;\n}\n\n.pdf-viewer-page .settings-menu-checkbox input {\n    width: 18px;\n    height: 18px;\n    cursor: pointer;\n}\n\n.pdf-viewer-page .settings-menu-row {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.pdf-viewer-page .settings-menu-label {\n    font-size: 14px;\n    font-weight: 600;\n    color: #1a365d;\n}\n\n.pdf-viewer-page .settings-menu-path-row {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n}\n\n.pdf-viewer-page .settings-menu-path-value {\n    flex: 1;\n    font-size: 13px;\n    color: #6b7280;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.pdf-viewer-page .settings-menu-choose-btn {\n    flex-shrink: 0;\n    padding: 8px 16px;\n    background: #6366f1;\n    color: white;\n    border: none;\n    border-radius: 8px;\n    font-size: 14px;\n    font-weight: 600;\n    cursor: pointer;\n}\n\n.pdf-viewer-page .settings-menu-choose-btn:hover {\n    background: #4f46e5;\n}\n\n.pdf-viewer-page .settings-menu-clear-btn {\n    flex-shrink: 0;\n    padding: 8px 16px;\n    background: #f1f5f9;\n    color: #475569;\n    border: none;\n    border-radius: 8px;\n    font-size: 14px;\n    font-weight: 600;\n    cursor: pointer;\n}\n\n.pdf-viewer-page .settings-menu-clear-btn:hover {\n    background: #e2e8f0;\n    color: #1e293b;\n}\n\n.pdf-viewer-page .editor-standard-menu {\n    position: absolute;\n    top: 52px;\n    left: 12px;\n    z-index: 999;\n    background: #fff;\n    border: 1px solid #e5e7eb;\n    border-radius: 8px;\n    margin-top: 20px;\n    padding: 8px 16px 12px 16px;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n    min-width: 220px;\n    max-width: min(420px, calc(100vw - 24px));\n    overflow: hidden;\n    box-sizing: border-box;\n    transition:\n        max-width 0.45s cubic-bezier(0.4, 0, 0.2, 1),\n        padding 0.45s cubic-bezier(0.4, 0, 0.2, 1),\n        border-radius 0.35s ease,\n        box-shadow 0.45s ease,\n        min-width 0.45s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.pdf-viewer-page .editor-standard-menu--collapsed {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    min-width: 0;\n    width: 44px;\n    max-width: 44px;\n    padding: 6px;\n    box-sizing: border-box;\n    border-radius: 10px;\n    box-shadow: 0 3px 14px rgba(26, 54, 93, 0.12);\n}\n\n.pdf-viewer-page .editor-standard-menu-header {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    margin-bottom: 10px;\n    transition: margin-bottom 0.35s ease;\n}\n\n.pdf-viewer-page .editor-standard-menu--collapsed .editor-standard-menu-header {\n    margin-bottom: 0;\n    width: 100%;\n    align-items: center;\n}\n\n.pdf-viewer-page .editor-standard-menu-header-top {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    gap: 8px;\n    width: 100%;\n}\n\n.pdf-viewer-page .editor-standard-menu--collapsed .editor-standard-menu-header-top {\n    position: relative;\n    justify-content: center;\n    gap: 0;\n    width: auto;\n    min-width: 0;\n}\n\n.pdf-viewer-page .editor-standard-menu-expandable {\n    max-height: 2000px;\n    opacity: 1;\n    overflow: hidden;\n    margin-top: 0;\n    transition:\n        max-height 0.48s cubic-bezier(0.4, 0, 0.2, 1),\n        opacity 0.32s ease,\n        margin-top 0.35s ease,\n        visibility 0s linear 0s;\n    visibility: visible;\n}\n\n.pdf-viewer-page .editor-standard-menu-expandable--collapsed {\n    max-height: 0;\n    opacity: 0;\n    margin-top: 0;\n    margin-bottom: 0;\n    pointer-events: none;\n    visibility: hidden;\n    transition:\n        max-height 0.42s cubic-bezier(0.4, 0, 0.2, 1),\n        opacity 0.28s ease,\n        margin-top 0.3s ease,\n        visibility 0s linear 0.42s;\n}\n\n.pdf-viewer-page .editor-standard-menu-collapse-btn {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n    width: 32px;\n    height: 32px;\n    padding: 0;\n    border: 1px solid #e5e7eb;\n    border-radius: 6px;\n    background-color: #ffffff;\n    color: #1a365d;\n    cursor: pointer;\n    transition:\n        transform 0.28s cubic-bezier(0.34, 1.56, 0.64, 1),\n        border-radius 0.35s ease,\n        box-shadow 0.35s ease,\n        background-color 0.2s ease,\n        border-color 0.2s ease;\n}\n\n.pdf-viewer-page .editor-standard-menu-collapse-btn:hover {\n    background-color: #f3f4f6;\n}\n\n.pdf-viewer-page .editor-standard-menu-collapse-btn:active {\n    transform: scale(0.92);\n}\n\n.pdf-viewer-page .editor-standard-menu--collapsed .editor-standard-menu-collapse-btn--collapsed-only {\n    border-radius: 8px;\n    animation: editor-standard-collapse-btn-float 2.8s ease-in-out infinite;\n}\n\n@keyframes editor-standard-collapse-btn-float {\n    0%,\n    100% {\n        box-shadow: 0 0 0 1px rgba(26, 54, 93, 0.06), 0 2px 10px rgba(26, 54, 93, 0.1);\n    }\n    50% {\n        box-shadow: 0 0 0 1px rgba(26, 54, 93, 0.08), 0 3px 14px rgba(26, 54, 93, 0.14);\n    }\n}\n\n.pdf-viewer-page .editor-standard-menu-collapse-btn-icon {\n    display: block;\n    transition: transform 0.35s cubic-bezier(0.34, 1.56, 0.64, 1);\n}\n\n.pdf-viewer-page .editor-standard-menu-collapse-btn:hover .editor-standard-menu-collapse-btn-icon {\n    transform: scale(1.12);\n}\n\n.pdf-viewer-page .editor-standard-menu--collapsed .editor-standard-menu-collapse-btn:hover .editor-standard-menu-collapse-btn-icon {\n    transform: scale(1.15) translateY(1px);\n}\n\n.pdf-viewer-page .editor-standard-label {\n    flex: 1 1 auto;\n    min-width: 0;\n    font-size: 12px;\n    color: #6b7280;\n    font-weight: 600;\n    cursor: default;\n    user-select: none;\n    transition:\n        opacity 0.3s ease,\n        max-width 0.4s cubic-bezier(0.4, 0, 0.2, 1),\n        margin 0.35s ease,\n        transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n/* Label out of flex flow when collapsed so gap:8px does not offset the lone button */\n.pdf-viewer-page .editor-standard-menu--collapsed .editor-standard-label {\n    position: absolute;\n    width: 0;\n    height: 0;\n    overflow: hidden;\n    clip: rect(0, 0, 0, 0);\n    opacity: 0;\n    margin: 0;\n    padding: 0;\n    border: 0;\n    flex: none;\n    transform: none;\n    pointer-events: none;\n    white-space: nowrap;\n}\n\n.pdf-viewer-page .editor-standard-value {\n    font-size: 14px;\n    color: #166534;\n    font-weight: 600;\n}\n\n.pdf-viewer-page .editor-standard-value.editor-standard-error {\n    color: #b91c1c;\n}\n\n.pdf-viewer-page .editor-standard-sentences {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n}\n\n.pdf-viewer-page .editor-standard-sentence {\n    font-size: 13px;\n    color: #166534;\n    font-weight: 500;\n}\n\n.pdf-viewer-page .editor-standard-checkbox {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-size: 14px;\n    cursor: pointer;\n    margin-bottom: 8px;\n}\n\n.pdf-viewer-page .editor-standard-checkbox input {\n    width: 18px;\n    height: 18px;\n    cursor: pointer;\n}\n\n.pdf-viewer-page .editor-standard-row {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    margin-bottom: 10px;\n}\n\n.pdf-viewer-page .editor-standard-row:last-child {\n    margin-bottom: 0;\n}\n\n.pdf-viewer-page .editor-standard-row-hole-shaft {\n    display: flex;\n    flex-direction: row;\n    gap: 16px;\n}\n\n.pdf-viewer-page .editor-standard-row-hole-shaft .editor-standard-row-item {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    flex: 1;\n}\n\n.pdf-viewer-page .editor-standard-sublabel {\n    font-size: 12px;\n    color: #6b7280;\n    font-weight: 600;\n    cursor: default;\n    user-select: none;\n}\n\n.pdf-viewer-page .editor-standard-dropdown {\n    width: 100%;\n    padding: 8px 12px;\n    font-size: 14px;\n    border: 1px solid #d1d5db;\n    border-radius: 6px;\n    background: #fff;\n    cursor: pointer;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n}\n\n/* Text inputs in the same block keep I-beam (class order: dropdown + input) */\n.pdf-viewer-page .editor-standard-input {\n    cursor: text;\n    -webkit-user-select: text;\n    -moz-user-select: text;\n    -ms-user-select: text;\n    user-select: text;\n}\n\n.pdf-viewer-page .editor-standard-iso22081-inputs {\n    display: flex;\n    flex-direction: column;\n    gap: 0;\n}\n\n.pdf-viewer-page .ocr-badge {\n    position: absolute;\n    top: -6px;\n    right: -6px;\n    background: #6366f1;\n    color: #ffffff;\n    font-size: 11px;\n    font-weight: 700;\n    min-width: 20px;\n    height: 20px;\n    border-radius: 10px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0 5px;\n    line-height: 1;\n}\n\n@keyframes ocr-spin {\n    from { transform: rotate(0deg); }\n    to { transform: rotate(360deg); }\n}\n\n.pdf-viewer-page .ocr-spinner {\n    animation: ocr-spin 1s linear infinite;\n}\n\n/* Make all info elements flex items with even spacing */\n.pdf-viewer-page .info-item,\n.pdf-viewer-page .info-center {\n    flex: 1;\n    text-align: center;\n}\n\n/* Purple color for measurement numbers */\n.pdf-viewer-page .measurement-number {\n    color: #3c2eb4;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n    .pdf-viewer-page .pdf-info-bar {\n        flex-wrap: wrap;\n        gap: 8px;\n    }\n\n    .pdf-viewer-page .info-center {\n        order: -1;\n        width: 100%;\n        text-align: center;\n        margin-bottom: 8px;\n    }\n\n    .pdf-viewer-page .measurement-legend-bar {\n        flex-wrap: nowrap;\n        justify-content: flex-start;\n        gap: 8px;\n        overflow-x: auto;\n        overflow-y: visible;\n        padding: 62px 12px 16px 12px;\n    }\n\n    .pdf-viewer-page .measurement-legend-item {\n        font-size: 12px;\n        padding: 2px 6px;\n        height: 40px;\n        box-sizing: border-box;\n    }\n\n    .pdf-viewer-page .measurement-legend-img {\n        max-height: 32px;\n        max-width: 150px;\n        width: auto;\n        height: auto;\n    }\n\n    .pdf-viewer-page .measurement-legend-img-placeholder {\n        width: 32px;\n        height: 32px;\n        font-size: 14px;\n    }\n\n    .pdf-viewer-page .measurement-legend-number {\n        width: 24px;\n        height: 24px;\n        font-size: 12px;\n    }\n}\n\n/* Specific form variants inherit from base styles above */\n\n\n.input-disabled {\n    background: #f1f5f9;\n    color: #94a3b8;\n    cursor: not-allowed;\n    border-color: #cbd5e1;\n}\n\n.input-disabled:focus {\n    border-color: #cbd5e1;\n    box-shadow: none;\n    background: #f1f5f9;\n}\n\n.file-row {\n    display: flex;\n    flex-direction: column;\n    gap: 1.5rem;\n    margin-bottom: 2rem;\n}\n\n.file-row>div {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.5rem;\n}\n\n.file-btn {\n    background: transparent;\n    color: #4299e1;\n    border: 2px solid #4299e1;\n    padding: 1rem 2rem;\n    border-radius: 16px;\n    cursor: pointer;\n    font-size: 1.2rem;\n    font-weight: 600;\n    transition: all 0.3s ease;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0.8rem;\n    box-shadow: 0 4px 6px rgba(66, 153, 225, 0.1);\n    width: 100%;\n    min-height: 48px;\n}\n\n.file-btn:hover {\n    background: #4299e1;\n    color: white;\n    transform: translateY(-1px);\n    box-shadow: 0 6px 12px rgba(66, 153, 225, 0.2);\n}\n\n.file-btn-error {\n    background: transparent;\n    color: #e53e3e;\n    border-color: #e53e3e;\n    box-shadow: 0 4px 6px rgba(229, 62, 62, 0.1);\n}\n\n.file-btn-error:hover {\n    background: #e53e3e;\n    color: white;\n    transform: translateY(-1px);\n    box-shadow: 0 6px 12px rgba(229, 62, 62, 0.2);\n}\n\n.file-btn-selected {\n    background: #4299e1;\n    color: white;\n    border-color: #4299e1;\n    box-shadow: 0 4px 6px rgba(66, 153, 225, 0.2);\n}\n\n.file-btn-selected:hover {\n    background: #3182ce;\n    border-color: #3182ce;\n    transform: translateY(-1px);\n    box-shadow: 0 6px 12px rgba(66, 153, 225, 0.3);\n}\n\n.pdf-icon {\n    background: rgba(66, 153, 225, 0.1);\n    padding: 0.4rem 0.7rem;\n    border-radius: 8px;\n    font-size: 1.1rem;\n    font-weight: 700;\n    transition: all 0.3s ease;\n}\n\n.file-btn:hover .pdf-icon {\n    background: rgba(255, 255, 255, 0.2);\n}\n\n.file-btn-selected .pdf-icon {\n    background: rgba(255, 255, 255, 0.2);\n}\n\n.file-name {\n    color: #2d3748;\n    font-size: 1.3rem;\n    display: flex;\n    align-items: center;\n    gap: 0.8rem;\n    font-weight: 500;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    width: 100%;\n    padding-left: 0.5rem;\n}\n\n.file-img {\n    font-size: 1.5rem;\n}\n\n.file-error {\n    color: #e53e3e;\n    font-size: 1rem;\n    margin-top: 0.5rem;\n    font-weight: 500;\n    text-align: center;\n}\n\n.request-error {\n    position: absolute;\n    text-align: center;\n    color: #e53e3e;\n    font-size: 0.8rem;\n    font-weight: 500;\n}\n\n/* Submit button inherits from .save-btn, .submit-button styles above */\n\n.arrow {\n    font-size: 1.4rem;\n    transition: transform 0.3s ease;\n}\n\n.submit-btn:hover:not(:disabled) .arrow {\n    transform: translateX(5px);\n}\n\n.checkbox-group {\n    display: flex;\n    justify-content: center;\n    gap: 2rem;\n    margin-bottom: 2rem;\n}\n\n.checkbox-label {\n    position: relative;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    cursor: pointer;\n    font-size: 1.2rem;\n    color: #6B7280;\n    font-weight: 500;\n    padding: 0.5rem;\n    border-radius: 8px;\n    transition: all 0.2s ease;\n}\n\n.checkbox-label:hover {\n    color: #1a365d;\n}\n\n.checkbox-label input[type=\"checkbox\"] {\n    position: absolute;\n    opacity: 0;\n    cursor: pointer;\n    height: 0;\n    width: 0;\n}\n\n.checkbox-label .checkmark {\n    position: relative;\n    display: inline-block;\n    width: 18px;\n    height: 18px;\n    background: white;\n    border: 2px solid #D1D5DB;\n    border-radius: 4px;\n    transition: all 0.2s ease;\n}\n\n.checkbox-label:hover .checkmark {\n    border-color: #1a365d;\n}\n\n.checkbox-label input[type=\"checkbox\"]:checked~.checkmark {\n    background: #1a365d;\n    border-color: #1a365d;\n}\n\n.checkbox-label input[type=\"checkbox\"]:checked~.checkmark:after {\n    content: \"\";\n    position: absolute;\n    display: block;\n    left: 50%;\n    top: 45%;\n    width: 5px;\n    height: 10px;\n    border: solid white;\n    border-width: 0 2px 2px 0;\n    transform: translate(-50%, -50%) rotate(45deg);\n}\n\n.checkbox-label.active {\n    color: #1a365d;\n    font-weight: 600;\n}\n\n.hidden {\n    display: none;\n}\n\n\n\n/* Registration page specific styles */\n.btn-back {\n    height: 52px;\n    display: flex;\n    justify-content: left;\n    margin-top: 1rem;\n    padding-top: 0.5rem;\n    border-top: 1px solid #e2e8f0;\n}\n\n/* Material Design Dropdown Styles */\n.material-dropdown {\n    position: relative;\n    width: 100%;\n    margin: 0.5rem 0 0 0;\n}\n\n.dropdown-button {\n    width: 100%;\n    border: 1px solid #b0b4b9;\n    padding: 1rem;\n    font-size: 1rem;\n    border-radius: 1rem;\n    background: white;\n    transition: all 0.2s ease;\n    outline: none;\n    color: #1a365d;\n    cursor: pointer;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    text-align: left;\n    font-family: inherit;\n    min-height: 56px;\n}\n\n.dropdown-button.dropdown-open {\n    border-color: #1a365d;\n    box-shadow: 0 0 0 1px #1a365d;\n}\n\n.dropdown-button.dropdown-disabled {\n    background: #f1f5f9;\n    color: #94a3b8;\n    cursor: not-allowed;\n    border-color: #cbd5e1;\n}\n\n.dropdown-text {\n    font-size: 1rem;\n    flex: 1;\n    color: inherit;\n}\n\n.dropdown-text:empty::before {\n    content: attr(placeholder);\n    color: #b0b4b9;\n}\n\n.dropdown-arrow {\n    color: #b0b4b9;\n    font-size: 0.8rem;\n    transition: transform 0.2s ease;\n    margin-left: 0.5rem;\n}\n\n.dropdown-arrow-open {\n    transform: rotate(180deg);\n    color: #1a365d;\n}\n\n.dropdown-menu {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    right: 0;\n    background: white;\n    border: 1px solid #b0b4b9;\n    border-radius: 1rem;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n    z-index: 1000;\n    margin-top: 0.25rem;\n    max-height: 200px;\n    overflow-y: auto;\n    animation: dropdownFadeIn 0.2s ease;\n}\n\n@keyframes dropdownFadeIn {\n    from {\n        opacity: 0;\n        transform: translateY(-8px);\n    }\n\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n.dropdown-option {\n    padding: 1rem;\n    color: #1a365d;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    border-bottom: 1px solid #f1f5f9;\n    font-size: 1rem;\n}\n\n.dropdown-option:last-child {\n    border-bottom: none;\n}\n\n.dropdown-option-focused {\n    background: #e2e8f0;\n    color: #1a365d;\n}\n\n.dropdown-option-selected {\n    background: #1a365d;\n    color: white;\n    font-weight: 600;\n}\n\n.dropdown-option-selected:hover {\n    background: #1a365d;\n    color: white;\n}\n\n/* Pricing plans styles */\n.pricing-plans-container {\n    display: flex;\n    flex-direction: row;\n    margin-bottom: 2rem;\n    gap: 1.5rem;\n    justify-content: center;\n}\n\n.pricing-card {\n    background: white;\n    border-radius: 1rem;\n    padding: 2rem;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n    border: 2px solid #e2e8f0;\n    transition: all 0.3s ease;\n    min-width: 280px;\n    max-width: 320px;\n    width: 300px;\n    flex: 0 0 auto;\n    position: relative;\n    display: flex;\n    flex-direction: column;\n}\n\n.pricing-card:hover {\n    transform: translateY(-4px);\n    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);\n    border-color: #1a365d;\n}\n\n.pricing-card.selected {\n    border-color: #1a365d;\n    background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);\n}\n\n.pricing-card-header {\n    text-align: center;\n    margin-bottom: 1.5rem;\n}\n\n.pricing-card-title {\n    font-size: 1.5rem;\n    font-weight: 700;\n    color: #1a365d;\n    margin-bottom: 0.5rem;\n}\n\n.pricing-card-price {\n    font-size: 2.5rem;\n    font-weight: 900;\n    color: #1a365d;\n    margin-bottom: 0.25rem;\n}\n\n.pricing-card-period {\n    font-size: 1rem;\n    color: #64748b;\n    font-weight: 500;\n}\n\n.pricing-card-features {\n    list-style: none;\n    padding: 0;\n    margin: 1.5rem 0;\n    flex: 1;\n}\n\n.pricing-card-feature {\n    display: flex;\n    align-items: center;\n    padding: 0.75rem 0;\n    border-bottom: 1px solid #f1f5f9;\n    font-size: 0.95rem;\n    color: #475569;\n}\n\n.pricing-card-feature:last-child {\n    border-bottom: none;\n}\n\n.pricing-card-feature-icon {\n    width: 20px;\n    height: 20px;\n    margin-right: 0.75rem;\n    color: #10b981;\n    font-weight: bold;\n}\n\n.pricing-card-feature-text {\n    flex: 1;\n}\n\n.pricing-card-feature-highlight {\n    font-weight: 600;\n    color: #1a365d;\n}\n\n.pricing-card-feature-comment {\n    font-size: 0.9rem;\n    color: #969da8;\n    font-weight: 500;\n    text-align: center;\n}\n\n.pricing-card-button {\n    width: 100%;\n    height: 52px;\n    padding: 1rem;\n    background: #1a365d;\n    color: white;\n    border: none;\n    border-radius: 0.75rem;\n    font-size: 1rem;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    margin-top: auto;\n}\n\n.pricing-card-button-contact {\n    width: 100%;\n    height: 52px;\n    padding: 1rem;\n    background: white;\n    color: #1a365d;\n    border: 2px solid #1a365d;\n    border-radius: 0.75rem;\n    font-size: 1rem;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    margin-top: auto;\n}\n\n.pricing-card-button-contact:hover {\n    background: #1a365d;\n    color: white;\n    transform: translateY(-1px);\n}\n\n.pricing-card-button:hover {\n    background: #2d4a6b;\n    transform: translateY(-1px);\n}\n\n\n.pricing-card.selected .pricing-card-button {\n    background: #10b981;\n}\n\n.pricing-card.selected .pricing-card-button:hover {\n    background: #059669;\n}\n\n.remove-tools-section {\n    margin-top: 2rem;\n    display: flex;\n    justify-content: center;\n}\n\n.remove-tools-card {\n    background: white;\n    border: 2px solid #e2e8f0;\n    border-radius: 1rem;\n    padding: 1.5rem;\n    max-width: 300px;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    transition: all 0.2s ease;\n}\n\n.remove-tools-card:hover {\n    border-color: #cbd5e1;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n}\n\n.remove-tools-header {\n    text-align: center;\n    margin-bottom: 1rem;\n}\n\n.remove-tools-title {\n    font-size: 1rem;\n    font-weight: 600;\n    color: #1a365d;\n    margin-bottom: 0.5rem;\n}\n\n.remove-tools-price {\n    font-size: 1.5rem;\n    font-weight: 700;\n    color: #1a365d;\n    line-height: 1.2;\n}\n\n.remove-tools-period {\n    font-size: 0.875rem;\n    color: #64748b;\n    margin-top: 0.25rem;\n}\n\n.remove-tools-description {\n    font-size: 0.875rem;\n    color: #64748b;\n    text-align: center;\n    margin-bottom: 1rem;\n    line-height: 1.4;\n}\n\n.remove-tools-button {\n    width: 100%;\n    height: 44px;\n    padding: 0.75rem;\n    background: #1a365d;\n    color: white;\n    border: none;\n    border-radius: 0.75rem;\n    font-size: 0.9rem;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    margin-top: auto;\n}\n\n.remove-tools-button:hover:not(:disabled) {\n    background: #2d4a6b;\n    transform: translateY(-1px);\n    box-shadow: 0 4px 8px rgba(26, 54, 93, 0.2);\n}\n\n\n@media (max-width: 768px) {\n    .pricing-plans-container {\n        flex-direction: row;\n        align-items: stretch;\n        flex-wrap: wrap;\n        justify-content: center;\n        gap: 1rem;\n    }\n\n    .pricing-card {\n        min-width: 250px;\n        max-width: 280px;\n        width: 250px;\n        flex: 0 0 auto;\n    }\n}\n\n\n\n\n\n/* Language switcher */\n\n.language-switcher {\n    position: absolute;\n    top: 20px;\n    right: 20px;\n    display: flex;\n    gap: 4px;\n    z-index: 1000;\n}\n\n.lang-btn {\n    padding: 8px 12px;\n    background: #f3f4f6;\n    border: 1px solid #d1d5db;\n    border-radius: 6px;\n    cursor: pointer;\n    font-size: 12px;\n    font-weight: 500;\n    color: #6b7280;\n    transition: all 0.2s ease;\n    min-width: 50px;\n}\n\n.lang-btn:hover {\n    background: #e5e7eb;\n    border-color: #9ca3af;\n}\n\n.lang-btn.active {\n    background: #1a365d;\n    border-color: #1a365d;\n    color: white;\n}\n\n.lang-btn.active:hover {\n    background: #1a365d;\n}\n\n/* Contact Us page styles */\n.contact-form-wrapper {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    min-height: 100vh;\n    padding: 2rem;\n    padding-top: 4rem;\n    padding-bottom: 4rem;\n}\n\n.contact-us-form {\n    background: white;\n    padding: 4rem;\n    padding-bottom: 4rem;\n    border-radius: 24px;\n    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08);\n    width: 100%;\n    max-width: 700px;\n    display: flex;\n    flex-direction: column;\n    backdrop-filter: blur(10px);\n    border: 1px solid rgba(255, 255, 255, 0.2);\n    margin: 0;\n    min-height: fit-content;\n    position: relative;\n}\n\n.contact-us-header {\n    text-align: center;\n    margin-bottom: 1.5rem;\n}\n\n.contact-us-header h2 {\n    font-size: 2.5rem;\n    color: #1a365d;\n    font-weight: 900;\n    margin-bottom: 0.5rem;\n    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);\n    letter-spacing: 2px;\n}\n\n.contact-us-header h3 {\n    font-size: 1.5rem;\n    color: #64748b;\n    font-weight: 600;\n    margin-bottom: 1rem;\n}\n\n.contact-us-description {\n    font-size: 1.1rem;\n    color: #64748b;\n    line-height: 1.6;\n    max-width: 500px;\n    margin: 0 auto;\n}\n\n.character-counter {\n    text-align: right;\n    font-size: 0.875rem;\n    color: #64748b;\n    margin-top: 0.25rem;\n    font-weight: 500;\n}\n\n.form-row {\n    margin-bottom: 1.5rem;\n}\n\n.form-row label {\n    display: block;\n    margin-bottom: 0.5rem;\n    font-size: 1rem;\n    color: #2d3748;\n    font-weight: 600;\n}\n\n.form-row input,\n.form-row textarea {\n    width: 100%;\n    border: 1px solid #b0b4b9;\n    padding: 1rem;\n    margin: 0.5rem 0 0 0;\n    font-size: 1rem;\n    border-radius: 1rem;\n    background: white;\n    transition: all 0.2s ease;\n    outline: none;\n    color: #1a365d;\n    font-family: inherit;\n}\n\n.form-row input:focus,\n.form-row textarea:focus {\n    box-shadow: 0 0 0 1px #1a365d;\n}\n\n.form-row input::placeholder,\n.form-row textarea::placeholder {\n    color: #b0b4b9;\n    font-size: 0.9rem;\n}\n\n.form-row textarea {\n    resize: vertical;\n    min-height: 120px;\n}\n\n.input-error {\n    border-color: #e53e3e !important;\n    box-shadow: 0 0 0 1px #e53e3e !important;\n}\n\n.error-message {\n    color: #e53e3e;\n    font-size: 0.9rem;\n    margin-top: 0.1rem;\n    display: block;\n    font-weight: 500;\n}\n\n.success-message {\n    background: #d1fae5;\n    color: #065f46;\n    padding: 1rem;\n    border-radius: 0.75rem;\n    margin-bottom: 1.5rem;\n    border: 1px solid #a7f3d0;\n    font-weight: 500;\n    text-align: center;\n}\n\n.form-actions {\n    display: flex;\n    gap: 1rem;\n    align-items: center;\n    padding-top: 1.5rem;\n    border-top: 1px solid #e2e8f0;\n}\n\n.form-actions .btn-back {\n    background: none;\n    color: #64748b;\n    border: 2px solid #cbd5e1;\n    padding: 1rem 2rem;\n    border-radius: 0.75rem;\n    font-size: 1rem;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    text-decoration: none;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    min-width: 120px;\n    min-height: 48px;\n}\n\n.form-actions .btn-back:hover {\n    background: #f1f5f9;\n    border-color: #94a3b8;\n    color: #475569;\n}\n\n.form-actions .btn-active {\n    flex: 1;\n    background: #1a365d;\n    color: white;\n    border: 2px solid #1a365d;\n    border-radius: 0.75rem;\n    padding: 1rem 2rem;\n    font-size: 1rem;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    min-height: 48px;\n}\n\n.form-actions .btn-active:hover:not(:disabled) {\n    background: #2d4a6b;\n    border-color: #2d4a6b;\n    transform: translateY(-1px);\n    box-shadow: 0 4px 12px rgba(26, 54, 93, 0.3);\n}\n\n\n\n@media (max-width: 768px) {\n    .contact-form-wrapper {\n        padding: 1rem;\n        padding-top: 2rem;\n        padding-bottom: 2rem;\n    }\n\n    .contact-us-form {\n        padding: 2rem;\n        padding-bottom: 2rem;\n        margin: 0;\n    }\n\n    .contact-us-header h2 {\n        font-size: 2rem;\n    }\n\n    .contact-us-header h3 {\n        font-size: 1.25rem;\n    }\n\n    .form-actions {\n        flex-direction: column;\n        gap: 1rem;\n    }\n\n    .form-actions .btn-back,\n    .form-actions .btn-active {\n        width: 100%;\n    }\n}\n\n/* No Connection Page Styles */\n.no-connection-page {\n    width: 100%;\n    height: 100vh;\n    background: linear-gradient(135deg, #f6f9fc 0%, #eef2f7 100%);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 2rem;\n}\n\n.no-connection-container {\n    max-width: 600px;\n    width: 100%;\n    text-align: center;\n    background: white;\n    border-radius: 20px;\n    padding: 3rem 2rem;\n    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);\n    border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.no-connection-icon {\n    margin-bottom: 2rem;\n    color: #e74c3c;\n    display: flex;\n    justify-content: center;\n}\n\n.no-connection-icon svg {\n    filter: drop-shadow(0 4px 8px rgba(231, 76, 60, 0.3));\n}\n\n.no-connection-title {\n    font-size: 2.5rem;\n    font-weight: 900;\n    color: #2c3e50;\n    margin-bottom: 1.5rem;\n    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.no-connection-description {\n    font-size: 1.2rem;\n    color: #5a6c7d;\n    line-height: 1.6;\n    margin-bottom: 2rem;\n    max-width: 500px;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.no-connection-tips {\n    background: #f8f9fa;\n    border-radius: 15px;\n    padding: 2rem;\n    margin-bottom: 2rem;\n    text-align: left;\n    border-left: 4px solid #3498db;\n}\n\n.no-connection-tips h3 {\n    font-size: 1.3rem;\n    color: #2c3e50;\n    margin-bottom: 1rem;\n    text-align: center;\n}\n\n.no-connection-tips ul {\n    list-style: none;\n    padding: 0;\n}\n\n.no-connection-tips li {\n    padding: 0.5rem 0;\n    color: #5a6c7d;\n    position: relative;\n    padding-left: 2rem;\n}\n\n.no-connection-tips li::before {\n    content: \"✓\";\n    position: absolute;\n    left: 0;\n    color: #27ae60;\n    font-weight: bold;\n    font-size: 1.1rem;\n}\n\n.retry-button {\n    background: linear-gradient(135deg, #3498db 0%, #2980b9 100%);\n    color: white;\n    border: none;\n    padding: 1rem 2.5rem;\n    font-size: 1.1rem;\n    font-weight: 600;\n    border-radius: 50px;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    box-shadow: 0 8px 20px rgba(52, 152, 219, 0.3);\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n}\n\n.retry-button:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 12px 25px rgba(52, 152, 219, 0.4);\n    background: linear-gradient(135deg, #2980b9 0%, #1f5f8b 100%);\n}\n\n.retry-button:active {\n    transform: translateY(0);\n    box-shadow: 0 6px 15px rgba(52, 152, 219, 0.3);\n}\n\n.retry-button:disabled {\n    background: linear-gradient(135deg, #bdc3c7 0%, #95a5a6 100%);\n    box-shadow: 0 4px 10px rgba(149, 165, 166, 0.3);\n}\n\n.retry-button:disabled:hover {\n    box-shadow: 0 4px 10px rgba(149, 165, 166, 0.3);\n    background: linear-gradient(135deg, #bdc3c7 0%, #95a5a6 100%);\n}\n\n/* Responsive design for no connection page */\n@media (max-width: 768px) {\n    .no-connection-page {\n        padding: 1rem;\n    }\n\n    .no-connection-container {\n        padding: 2rem 1.5rem;\n    }\n\n    .no-connection-title {\n        font-size: 2rem;\n    }\n\n    .no-connection-description {\n        font-size: 1.1rem;\n    }\n\n    .no-connection-tips {\n        padding: 1.5rem;\n    }\n\n    .retry-button {\n        padding: 0.8rem 2rem;\n        font-size: 1rem;\n    }\n}\n\n@media (max-width: 480px) {\n    .no-connection-container {\n        padding: 1.5rem 1rem;\n    }\n\n    .no-connection-title {\n        font-size: 1.8rem;\n    }\n\n    .no-connection-description {\n        font-size: 1rem;\n    }\n\n    .no-connection-tips {\n        padding: 1rem;\n    }\n\n    .no-connection-tips h3 {\n        font-size: 1.1rem;\n    }\n}\n\n/* Legacy spinner keyframes (e.g. inline buttons); full-page loading uses EngineeringLoadingScreen */\n@keyframes spin {\n    0% {\n        transform: rotate(0deg);\n    }\n\n    100% {\n        transform: rotate(360deg);\n    }\n}\n\n/* Dashboard main title */\n.dashboard-main-title {\n    font-size: 1.3rem;\n    color: #1a365d;\n    font-weight: 300;\n    text-align: center;\n    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);\n    letter-spacing: 2px;\n    position: fixed;\n    bottom: 12rem;\n    right: 0rem;\n    transform: rotate(-90deg);\n    transform-origin: right bottom;\n    z-index: 900;\n}\n\n/* User Profile */\n.user-profile {\n    position: fixed;\n    top: 1rem;\n    right: 1.5rem;\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    height: 2.875rem;\n    padding: 0 16px 0 20px;\n    background: white;\n    border: 2px solid #e5e7eb;\n    border-radius: 50px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n    z-index: 1000;\n    transition: all 0.2s ease;\n    cursor: pointer;\n}\n\n.user-profile:hover {\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);\n    border-color: #1a365d;\n    transform: translateY(-1px);\n}\n\n.user-profile-name {\n    font-size: 14px;\n    font-weight: 400;\n    color: #1a365d;\n}\n\n.user-profile-avatar {\n    width: 2rem;\n    height: 2rem;\n    border-radius: 50%;\n    overflow: hidden;\n    flex-shrink: 0;\n}\n\n.user-avatar-img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n.user-avatar-placeholder {\n    width: 100%;\n    height: 100%;\n    background: linear-gradient(135deg, #3ece81 0%, #2eb872 100%);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: white;\n    font-size: 14px;\n    font-weight: 700;\n}\n\n/* Profile Page Styles */\n.profile-container {\n    background: white;\n    padding: 3rem;\n    border-radius: 24px;\n    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08);\n    width: 100%;\n    max-width: 700px;\n    margin-top: 0;\n    margin-bottom: 2rem;\n}\n\n.profile-title {\n    font-size: 2rem;\n    color: #1a365d;\n    margin-bottom: 2rem;\n    text-align: center;\n    font-weight: 700;\n}\n\n.profile-content {\n    margin-bottom: 2rem;\n}\n\n.profile-section {\n    display: flex;\n    flex-direction: column;\n    gap: 1.5rem;\n}\n\n.profile-field {\n    display: flex;\n    flex-direction: column;\n    gap: 0;\n}\n\n.language-buttons {\n    display: flex;\n    gap: 0.75rem;\n    margin-top: 0.5rem;\n    flex-wrap: wrap;\n}\n\n.language-flag-btn {\n    background: white;\n    color: #1a365d;\n    border: 2px solid #cad1dc;\n    box-shadow: 0 4px 8px rgba(26, 54, 93, 0.1);\n    border-radius: 12px;\n    padding: 8px 16px;\n    font-size: 14px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    min-width: 45px;\n    height: 40px;\n    line-height: 1;\n}\n\n.language-flag-btn:hover {\n    background: #f9fafb;\n    border-color: #1a365d;\n    transform: translateY(-2px);\n    box-shadow: 0 6px 12px rgba(26, 54, 93, 0.2);\n}\n\n.language-flag-btn-active {\n    background: #1a365d;\n    color: #ffffff;\n    border-color: #1a365d;\n    box-shadow: 0 4px 12px rgba(26, 54, 93, 0.25);\n}\n\n.language-flag-btn-active:hover {\n    background: #2c5282;\n    border-color: #2c5282;\n    transform: translateY(-2px);\n    box-shadow: 0 6px 14px rgba(26, 54, 93, 0.3);\n}\n\n/* Profile: PDF workflow mode toggle (segmented control, navy selected state) */\n.profile-segment-buttons {\n    display: flex;\n    gap: 0.75rem;\n    margin-top: 0.5rem;\n    flex-wrap: wrap;\n}\n\n.profile-segment-btn {\n    background: white;\n    color: #1a365d;\n    border: 2px solid #cad1dc;\n    box-shadow: 0 4px 8px rgba(26, 54, 93, 0.1);\n    border-radius: 12px;\n    padding: 8px 16px;\n    font-size: 14px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    min-height: 40px;\n    line-height: 1;\n}\n\n.profile-segment-btn:hover:not(:disabled) {\n    background: #f9fafb;\n    border-color: #1a365d;\n    transform: translateY(-2px);\n    box-shadow: 0 6px 12px rgba(26, 54, 93, 0.2);\n}\n\n.profile-segment-btn:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n    transform: none;\n}\n\n.profile-segment-btn-active {\n    background: #1a365d;\n    color: #ffffff;\n    border-color: #1a365d;\n    box-shadow: 0 4px 12px rgba(26, 54, 93, 0.25);\n}\n\n.profile-segment-btn-active:hover:not(:disabled) {\n    background: #2c5282;\n    border-color: #2c5282;\n    transform: translateY(-2px);\n    box-shadow: 0 6px 14px rgba(26, 54, 93, 0.3);\n}\n\n.profile-pdf-workflow-hint {\n    margin: 0.5rem 0 0;\n    padding: 0;\n    font-size: 0.8125rem;\n    line-height: 1.45;\n    color: #6b7280;\n    font-weight: 400;\n    background: transparent;\n    border: none;\n}\n\n.profile-pdf-workflow-hint--success {\n    color: #059669;\n}\n\n.profile-label {\n    font-size: 0.9rem;\n    font-weight: 600;\n    color: #6b7280;\n    letter-spacing: 0.5px;\n    margin-bottom: 0px;\n}\n\n.profile-value {\n    font-size: 1.1rem;\n    color: #1a365d;\n    font-weight: 400;\n    padding: 0.75rem 1rem;\n    background: #f9fafb;\n    border-radius: 8px;\n    border: 1px solid #e5e7eb;\n}\n\n.profile-field-input-group {\n    display: flex;\n    gap: 0.75rem;\n    align-items: flex-start;\n}\n\n.profile-logo-row {\n    display: flex;\n    gap: 1rem;\n    align-items: center;\n    flex-wrap: wrap;\n}\n\n.profile-logo-preview {\n    width: 80px;\n    height: 80px;\n    object-fit: contain;\n    background: #ffffff;\n    border: 1px solid #e5e7eb;\n    border-radius: 8px;\n    padding: 0.5rem;\n}\n\n.profile-logo-actions {\n    display: flex;\n    gap: 0.75rem;\n    align-items: center;\n    flex-wrap: wrap;\n}\n\n.profile-secondary-btn {\n    padding: 0.75rem 1.5rem;\n    font-size: 0.95rem;\n    font-weight: 600;\n    color: #1a365d;\n    background: #ffffff;\n    border: 1px solid #d1d5db;\n    border-radius: 8px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    white-space: nowrap;\n}\n\n.profile-secondary-btn:hover:not(:disabled) {\n    background: #f9fafb;\n    transform: translateY(-1px);\n    box-shadow: 0 4px 6px rgba(17, 24, 39, 0.08);\n}\n\n\n.profile-logo-modal-preview {\n    width: 140px;\n    height: 140px;\n    object-fit: contain;\n    background: #ffffff;\n    border: 1px solid #e5e7eb;\n    border-radius: 12px;\n    padding: 0.75rem;\n}\n\n.profile-logo-modal-controls {\n    display: flex;\n    flex-direction: column;\n    gap: 0.75rem;\n}\n\n.profile-file-input {\n    width: 100%;\n}\n\n.profile-checkbox-row {\n    display: flex;\n    gap: 0.5rem;\n    align-items: center;\n}\n\n.profile-input {\n    width: 100%;\n    font-size: 1.1rem;\n    color: #1a365d;\n    font-weight: 500;\n    padding: 0.75rem 1rem;\n    background: #ffffff;\n    border-radius: 8px;\n    border: 1px solid #e5e7eb;\n    transition: border-color 0.2s ease;\n    margin-top: 0px !important;\n}\n\n.profile-input:focus {\n    outline: none;\n    border-color: #3b82f6;\n    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.profile-input:disabled {\n    background: #f9fafb;\n    cursor: not-allowed;\n    opacity: 0.6;\n}\n\n.profile-save-btn {\n    padding: 0.75rem 1.5rem;\n    font-size: 0.95rem;\n    font-weight: 600;\n    color: #ffffff;\n    background: #3b82f6;\n    border: none;\n    border-radius: 8px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    white-space: nowrap;\n}\n\n.profile-save-btn:hover:not(:disabled) {\n    background: #2563eb;\n    transform: translateY(-1px);\n    box-shadow: 0 4px 6px rgba(59, 130, 246, 0.2);\n}\n\n.profile-save-btn:active:not(:disabled) {\n    transform: translateY(0);\n}\n\n\n.profile-error-message {\n    font-size: 0.875rem;\n    color: #ef4444;\n    margin-top: 0.25rem;\n    padding-left: 0.25rem;\n}\n\n.profile-actions {\n    display: flex;\n    justify-content: center;\n    gap: 1rem;\n    margin-top: 2rem;\n    flex-wrap: wrap;\n}\n\n/* Logout button */\n.logout-btn {\n    position: fixed;\n    top: 1rem;\n    left: 1rem;\n    background: white;\n    color: #6b7280;\n    border: 2px solid #e5e7eb;\n    border-radius: 12px;\n    height: 2.875rem;\n    padding: 0 24px;\n    font-size: 14px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    z-index: 1000;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.logout-btn:hover {\n    background: #f3f4f6;\n    border-color: #9ca3af;\n}\n\n/* Profile back button */\n.profile-back-btn {\n    position: fixed;\n    top: 1rem;\n    left: 1rem;\n    background: white;\n    color: #6b7280;\n    border: 2px solid #e5e7eb;\n    border-radius: 12px;\n    padding: 12px;\n    width: 48px;\n    height: 48px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    z-index: 1000;\n}\n\n.profile-back-btn:hover {\n    background: #f3f4f6;\n    border-color: #9ca3af;\n    transform: translateY(-1px);\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.profile-back-btn svg {\n    width: 24px;\n    height: 24px;\n}\n\n/* Admin/Manager Panel */\n.admin-panel {\n    background: white;\n    padding: 4rem;\n    border-radius: 24px;\n    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08);\n    width: 100%;\n    max-width: 800px;\n    text-align: center;\n}\n\n.admin-panel-header {\n    margin-bottom: 3rem;\n}\n\n.admin-panel-header .title {\n    font-size: 3rem;\n    color: #1a365d;\n    margin-bottom: 1.5rem;\n    font-weight: 800;\n    text-align: center;\n}\n\n.admin-role-badge {\n    text-align: center;\n    padding: 1rem;\n    border-radius: 12px;\n    font-size: 1.4rem;\n    color: #1a365d;\n    font-weight: 600;\n}\n\n.admin-role-badge.admin-badge {\n    background-color: #fee2e2;\n    border: 2px solid #ef4444;\n}\n\n.admin-role-badge.manager-badge {\n    background-color: #fef3c7;\n    border: 2px solid #f59e0b;\n}\n\n.company-name-above-search {\n    font-size: 2.5rem;\n    color: #1a365d;\n    font-weight: 700;\n    text-align: center;\n    margin-bottom: 1.5rem;\n}\n\n.admin-search-container {\n    display: flex;\n    gap: 1rem;\n    align-items: center;\n    justify-content: center;\n}\n\n.admin-search-input {\n    flex: 1;\n    width: 100%;\n    height: 52px;\n    border: 2px solid #e2e8f0;\n    padding: 1.2rem;\n    font-size: 1.4rem;\n    border-radius: 16px;\n    background: #f8fafc;\n    transition: all 0.3s ease;\n    color: #2d3748;\n}\n\n.admin-search-input:focus {\n    outline: none;\n    border-color: #1a365d;\n    box-shadow: 0 0 0 1px #1a365d;\n}\n\n.admin-search-input.input-error {\n    border-color: #ef4444;\n    box-shadow: 0 0 0 1px #ef4444;\n}\n\n.admin-search-input.input-error:focus {\n    border-color: #ef4444;\n    box-shadow: 0 0 0 2px #ef4444;\n}\n\n.email-error-message {\n    color: #ef4444;\n    font-size: 0.95rem;\n    margin-top: 0.75rem;\n    text-align: center;\n    font-weight: 500;\n}\n\n.email-success-message {\n    color: #10b981;\n    font-size: 0.95rem;\n    margin-top: 0.75rem;\n    text-align: center;\n    font-weight: 500;\n}\n\n/* Organization logo preview on registration form */\n.organization-logo-row {\n    margin-top: 0.5rem;\n    display: flex;\n    align-items: flex-start;\n    gap: 1rem;\n}\n\n.organization-logo-label {\n    flex: 0 0 50%;\n    max-width: 50%;\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n}\n\n.organization-logo-input-wrapper {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n}\n\n.organization-logo-header-row {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n    width: 100%;\n    justify-content: center;\n}\n\n.organization-logo-title-text {\n    font-size: 1rem;\n    font-weight: 600;\n    color: #2d3748;\n}\n\n.organization-logo-or-text {\n    flex: 1;\n    text-align: center;\n    font-size: 0.9rem;\n    color: #4b5563;\n}\n\n.organization-logo-preview {\n    flex: 0 0 50%;\n    max-width: 50%;\n    display: flex;\n    justify-content: center;\n}\n\n.organization-logo-preview img {\n    max-width: 100%;\n    max-height: 120px;\n    border-radius: 8px;\n    border: 1px solid #e2e8f0;\n    object-fit: contain;\n    background-color: #f8fafc;\n}\n\n.organization-logo-input-hidden {\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    padding: 0;\n    margin: -1px;\n    border: 0;\n    clip: rect(0, 0, 0, 0);\n    overflow: hidden;\n}\n\n.organization-logo-icon-button {\n    width: 100%;\n    min-height: 48px;\n    border-radius: 8px;\n    border: 2px dashed #cbd5e1;\n    background-color: #f8fafc;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: border-color 0.2s ease, background-color 0.2s ease;\n    font-size: 1rem;\n    color: #1f2933;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.organization-logo-icon-button i {\n    font-size: 1.6rem;\n}\n\n.organization-logo-icon-button:hover {\n    border-color: #94a3b8;\n    background-color: #e2e8f0;\n}\n\n/* Default logo checkbox on registration form */\n.organization-logo-default-row {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    font-size: 0.9rem;\n    margin-left: auto;\n}\n\n.organization-logo-default-row label {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n}\n\n.container .organization-logo-header-row .organization-logo-default-row input[type=\"checkbox\"],\nform .organization-logo-header-row .organization-logo-default-row input[type=\"checkbox\"],\n.organization-logo-header-row .organization-logo-default-row input[type=\"checkbox\"] {\n    width: 20px !important;\n    height: 20px !important;\n    margin: 0 !important;\n    margin-top: 0px !important;\n    padding: 0 !important;\n    border-radius: 3px !important;\n    background-color: white !important;\n    background: white !important;\n    border: 1px solid #b0b4b9 !important;\n    appearance: none !important;\n    -webkit-appearance: none !important;\n    -moz-appearance: none !important;\n    cursor: pointer !important;\n    box-sizing: border-box !important;\n}\n\n.container .organization-logo-header-row .organization-logo-default-row input[type=\"checkbox\"]:checked,\nform .organization-logo-header-row .organization-logo-default-row input[type=\"checkbox\"]:checked,\n.organization-logo-header-row .organization-logo-default-row input[type=\"checkbox\"]:checked {\n    background-color: white !important;\n    background: white !important;\n    border-color: #1a365d !important;\n    position: relative !important;\n}\n\n.container .organization-logo-header-row .organization-logo-default-row input[type=\"checkbox\"]:checked::after,\nform .organization-logo-header-row .organization-logo-default-row input[type=\"checkbox\"]:checked::after,\n.organization-logo-header-row .organization-logo-default-row input[type=\"checkbox\"]:checked::after {\n    content: \"\" !important;\n    position: absolute !important;\n    left: 50% !important;\n    top: 45% !important;\n    width: 5px !important;\n    height: 10px !important;\n    border: solid #d12626 !important;\n    border-width: 0 2px 2px 0 !important;\n    transform: translate(-50%, -50%) rotate(45deg) !important;\n}\n\n/* Company Members Section */\n.company-members-section {\n    padding-top: 2rem;\n}\n\n.members-title {\n    font-size: 1.5rem;\n    font-weight: 700;\n    color: #1a365d;\n    margin-bottom: 1.5rem;\n    text-align: left;\n}\n\n.loading-members {\n    text-align: center;\n    padding: 2rem;\n    color: #64748b;\n    font-size: 1rem;\n}\n\n.members-list {\n    display: flex;\n    flex-direction: column;\n    gap: 0.75rem;\n}\n\n.member-item {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 1rem 1.25rem;\n    background: white;\n    border: 2px solid #e2e8f0;\n    border-radius: 12px;\n    transition: all 0.2s ease;\n}\n\n.member-item:hover {\n    border-color: #cbd5e1;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n}\n\n.member-info {\n    display: flex;\n    align-items: center;\n    flex: 1;\n}\n\n.member-email {\n    font-size: 1rem;\n    color: #1a365d;\n    font-weight: 500;\n}\n\n.member-actions {\n    display: flex;\n    align-items: center;\n    gap: 1.5rem;\n}\n\n.member-role-selector {\n    display: flex;\n    gap: 1rem;\n    align-items: center;\n}\n\n.member-action-buttons {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n}\n\n.role-box {\n    padding: 0.5rem 1.25rem;\n    border: 2px solid #cbd5e1;\n    border-radius: 8px;\n    cursor: pointer;\n    font-size: 0.95rem;\n    color: #64748b;\n    font-weight: 600;\n    transition: all 0.3s ease;\n    user-select: none;\n    background: white;\n    box-shadow: 0 0 0 0 transparent;\n    height: 36px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.role-box:hover {\n    border-color: #94a3b8;\n}\n\n.role-box.selected {\n    border-color: #475569;\n    color: white;\n    background: #475569;\n}\n\n.role-box.from-db {\n    border-color: #475569;\n    color: white;\n    background: #475569;\n}\n\n.member-action-btn {\n    width: 36px;\n    height: 36px;\n    background: white;\n    color: #6b7280;\n    border: 2px solid #cbd5e1;\n    border-radius: 8px;\n    font-size: 1.5rem;\n    font-weight: 700;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: all 0.2s ease;\n    line-height: 1;\n    padding: 0;\n    min-width: 36px;\n    min-height: 36px;\n    max-width: 36px;\n    max-height: 36px;\n}\n\n.member-action-btn svg {\n    display: block;\n}\n\n.save-btn {\n    border-color: #10b981;\n}\n\n.save-btn:hover:not(:disabled) {\n    background: #d1fae5;\n    border-color: #059669;\n    color: #374151;\n    transform: scale(1.1);\n}\n\n.save-btn:disabled {\n    border-color: #cbd5e1;\n    opacity: 0.5;\n}\n\n.delete-btn {\n    border-color: #ef4444;\n}\n\n.delete-btn:hover {\n    background: #fef2f2;\n    border-color: #dc2626;\n    color: #374151;\n    transform: scale(1.1);\n}\n\n.member-action-btn:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n    transform: none;\n}\n\n.no-members {\n    text-align: center;\n    padding: 2rem;\n    color: #94a3b8;\n    font-size: 1rem;\n    font-style: italic;\n}\n\n.company-tools-section {\n    padding-top: 4rem;\n}\n\n.tools-section-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 1.5rem;\n    flex-wrap: wrap;\n    gap: 1rem;\n}\n\n.save-all-colors-btn {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 44px;\n    height: 44px;\n    background: #3ece81;\n    color: white;\n    border: none;\n    border-radius: 12px;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    box-shadow: 0 4px 8px rgba(72, 187, 120, 0.2);\n    padding: 0;\n}\n\n.save-all-colors-btn:hover:not(:disabled) {\n    background: #2db86a;\n    transform: translateY(-1px);\n    box-shadow: 0 6px 12px rgba(72, 187, 120, 0.3);\n}\n\n\n.save-all-colors-btn svg {\n    width: 20px;\n    height: 20px;\n    flex-shrink: 0;\n}\n\n.tools-title-wrapper {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n}\n\n.tools-title {\n    font-size: 1.5rem;\n    font-weight: 700;\n    color: #1a365d;\n    margin: 0;\n}\n\n.tools-add-container {\n    position: relative;\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    flex-wrap: wrap;\n}\n\n.tool-error-message {\n    color: #ef4444;\n    font-size: 0.9rem;\n    margin-right: 0.5rem;\n    white-space: nowrap;\n}\n\n.add-tool-button {\n    background: #3ece81;\n    color: white;\n    border: none;\n    box-shadow: 0 4px 8px rgba(72, 187, 120, 0.2);\n    border-radius: 12px;\n    padding: 0;\n    font-size: 1rem;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 44px;\n    height: 44px;\n}\n\n.add-tool-button:hover:not(:disabled) {\n    background: #2db86a;\n    box-shadow: 0 6px 12px rgba(72, 187, 120, 0.3);\n    transform: translateY(-1px);\n}\n\n\n.add-tool-button svg {\n    width: 20px;\n    height: 20px;\n}\n\n.add-custom-tool-button {\n    background: #6366f1;\n    width: auto;\n    padding: 0.75rem 1.5rem;\n    min-width: 44px;\n}\n\n.add-custom-tool-button:hover:not(:disabled) {\n    background: #4f46e5;\n    box-shadow: 0 6px 12px rgba(99, 102, 241, 0.3);\n    transform: translateY(-1px);\n}\n\n\n.tools-dropdown {\n    position: absolute;\n    top: 100%;\n    right: 0;\n    margin-top: 0.5rem;\n    background: white;\n    border: 2px solid #e2e8f0;\n    border-radius: 12px;\n    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);\n    z-index: 1000;\n    min-width: 250px;\n    max-height: 400px;\n    overflow-y: auto;\n}\n\n.tool-dropdown-item {\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n    padding: 1rem 1.25rem;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    border-bottom: 1px solid #f1f5f9;\n}\n\n.tool-dropdown-item:last-child {\n    border-bottom: none;\n}\n\n.tool-dropdown-item:hover {\n    background: #f8fafc;\n}\n\n.tool-dropdown-image {\n    width: 40px;\n    height: 40px;\n    object-fit: contain;\n}\n\n.tool-dropdown-empty {\n    padding: 1.5rem;\n    text-align: center;\n    color: #94a3b8;\n    font-size: 0.95rem;\n}\n\n.loading-tools {\n    text-align: center;\n    padding: 2rem;\n    color: #64748b;\n    font-size: 1rem;\n}\n\n.tools-list {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));\n    gap: 1.25rem;\n    padding: 0.5rem 0;\n}\n\n.tool-card {\n    display: flex;\n    flex-direction: column;\n    background: white;\n    border: 2px solid #e2e8f0;\n    border-radius: 16px;\n    padding: 1rem;\n    transition: all 0.2s ease;\n    position: relative;\n    overflow: visible;\n}\n\n.tool-card:hover {\n    border-color: #cbd5e1;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n    transform: translateY(-2px);\n}\n\n.tool-card-header {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n    margin-bottom: 0.75rem;\n}\n\n.tool-card-header .tool-delete-button {\n    margin-left: auto;\n}\n\n.tool-badge-wrapper {\n    position: relative;\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n}\n\n.tool-number-badge {\n    min-width: 32px;\n    height: 32px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #1a365d;\n    border-radius: 8px;\n    font-size: 0.875rem;\n    font-weight: 700;\n    flex-shrink: 0;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.tool-number-badge-clickable {\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.tool-number-badge-clickable:hover {\n    transform: scale(1.05);\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n}\n\n.tool-color-picker-input {\n    position: absolute;\n    opacity: 0;\n    width: 0;\n    height: 0;\n    pointer-events: none;\n}\n\n.tool-save-color-btn {\n    width: 24px;\n    height: 24px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: #10b981;\n    color: white;\n    border: none;\n    border-radius: 6px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    padding: 0;\n    box-shadow: 0 2px 4px rgba(16, 185, 129, 0.2);\n}\n\n.tool-save-color-btn:hover {\n    background: #059669;\n    transform: scale(1.1);\n    box-shadow: 0 4px 8px rgba(16, 185, 129, 0.3);\n}\n\n.tool-save-color-btn:active {\n    transform: scale(0.95);\n}\n\n.tool-save-color-btn svg {\n    width: 14px;\n    height: 14px;\n}\n\n.tool-remove-btn {\n    width: 28px;\n    height: 28px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: transparent;\n    border: 1px solid #e2e8f0;\n    border-radius: 6px;\n    color: #64748b;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    padding: 0;\n}\n\n.tool-remove-btn:hover {\n    background: #fee2e2;\n    border-color: #fca5a5;\n    color: #dc2626;\n}\n\n.tool-precision-class {\n    font-size: 0.875rem;\n    color: #6b7280;\n    white-space: nowrap;\n    flex: 1;\n    text-align: center;\n}\n\n.tool-delete-button {\n    width: 32px;\n    height: 32px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: transparent;\n    border: 1px solid #e2e8f0;\n    border-radius: 8px;\n    color: #64748b;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    padding: 0;\n    flex-shrink: 0;\n}\n\n.tool-delete-button:hover:not(:disabled) {\n    background: #fee2e2;\n    border-color: #fca5a5;\n    color: #dc2626;\n    transform: scale(1.05);\n}\n\n.tool-delete-button:disabled {\n    opacity: 0.5;\n}\n\n.tool-delete-button svg {\n    width: 16px;\n    height: 16px;\n}\n\n.tool-remove-btn:disabled {\n    opacity: 0.5;\n}\n\n.tool-card-image {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    min-height: 120px;\n    height: 180px;\n    margin-bottom: 0.75rem;\n    padding: 0.5rem;\n    flex: 1;\n    position: relative;\n    overflow: visible;\n}\n\n.tool-image {\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n}\n\n.tool-image-placeholder {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: #f1f5f9;\n    border: 2px dashed #cbd5e1;\n    border-radius: 8px;\n    color: #94a3b8;\n}\n\n.tool-card-image {\n    position: relative;\n}\n\n.tool-card-footer {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding-top: 0.5rem;\n    border-top: 1px solid #f1f5f9;\n}\n\n.tool-name {\n    font-size: 0.875rem;\n    font-weight: 500;\n    color: #1e293b;\n    text-align: center;\n    line-height: 1.4;\n}\n\n.min-precision-dropdown-container {\n    position: absolute;\n    bottom: 0.25rem;\n    right: 0.25rem;\n    z-index: 20;\n}\n\n.tool-min-precision {\n    position: absolute;\n    bottom: 0.25rem;\n    right: 0.25rem;\n    font-size: 0.875rem;\n    color: #6b7280;\n    white-space: nowrap;\n    z-index: 10;\n}\n\n.min-precision-dropdown-button {\n    display: flex;\n    align-items: center;\n    gap: 0.25rem;\n    padding: 0.375rem 0.625rem;\n    font-size: 0.75rem;\n    font-weight: 500;\n    color: #374151;\n    background-color: #ffffff;\n    border: 1px solid #d1d5db;\n    border-radius: 4px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.min-precision-dropdown-button:hover:not(:disabled) {\n    background-color: #f9fafb;\n    border-color: #9ca3af;\n}\n\n.min-precision-dropdown-button:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n.min-precision-value {\n    min-width: 2rem;\n    text-align: center;\n}\n\n.min-precision-dropdown {\n    position: absolute;\n    bottom: 100%;\n    right: 0;\n    margin-bottom: 0.25rem;\n    background-color: #ffffff;\n    border: 1px solid #d1d5db;\n    border-radius: 6px;\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n    z-index: 30;\n    min-width: 4rem;\n    overflow: hidden;\n}\n\n.min-precision-option {\n    display: block;\n    width: 100%;\n    padding: 0.5rem 0.75rem;\n    font-size: 0.75rem;\n    font-weight: 500;\n    color: #374151;\n    background-color: #ffffff;\n    border: none;\n    border-bottom: 1px solid #f3f4f6;\n    cursor: pointer;\n    text-align: center;\n    transition: background-color 0.15s ease;\n}\n\n.min-precision-option:last-child {\n    border-bottom: none;\n}\n\n.min-precision-option:hover {\n    background-color: #f9fafb;\n}\n\n.min-precision-option.active {\n    background-color: #2563eb;\n    color: #ffffff;\n}\n\n.min-precision-option.active:hover {\n    background-color: #1d4ed8;\n}\n\n@media (max-width: 768px) {\n    .tools-list {\n        grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));\n        gap: 1rem;\n    }\n\n    .tool-card {\n        padding: 0.75rem;\n    }\n\n    .tool-card-image {\n        min-height: 100px;\n        height: 140px;\n    }\n\n    .tool-image {\n        width: 100%;\n        height: 100%;\n    }\n\n    .tool-image-placeholder {\n        width: 100%;\n        height: 100%;\n    }\n}\n\n@media (max-width: 480px) {\n    .tools-list {\n        grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));\n        gap: 0.75rem;\n    }\n\n    .tool-card {\n        padding: 0.625rem;\n    }\n\n    .tool-card-image {\n        min-height: 80px;\n        height: 100px;\n    }\n\n    .tool-image {\n        width: 100%;\n        height: 100%;\n    }\n\n    .tool-image-placeholder {\n        width: 100%;\n        height: 100%;\n    }\n\n    .tool-name {\n        font-size: 0.8125rem;\n    }\n}\n\n.custom-tool-image-preview {\n    position: relative;\n    margin-top: 1rem;\n    display: inline-block;\n}\n\n.preview-image {\n    max-width: 200px;\n    max-height: 200px;\n    border-radius: 8px;\n    border: 2px solid #e2e8f0;\n    object-fit: contain;\n}\n\n.remove-preview-btn {\n    position: absolute;\n    top: -8px;\n    right: -8px;\n    width: 24px;\n    height: 24px;\n    background: #ef4444;\n    color: white;\n    border: none;\n    border-radius: 50%;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: all 0.2s ease;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n}\n\n.remove-preview-btn:hover {\n    background: #dc2626;\n    transform: scale(1.1);\n}\n\n.remove-preview-btn svg {\n    width: 14px;\n    height: 14px;\n}\n\n.color-picker-wrapper {\n    position: relative;\n    margin-top: 0.5rem;\n}\n\n.color-picker-input {\n    position: absolute;\n    opacity: 0;\n    width: 0;\n    height: 0;\n    pointer-events: none;\n}\n\n.color-picker-button {\n    display: inline-flex;\n    align-items: center;\n    gap: 0.75rem;\n    padding: 0.75rem 1.5rem;\n    background: white;\n    border: 1px solid #b0b4b9;\n    border-radius: 12px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    width: 100%;\n    height: 44px;\n    justify-content: flex-start;\n}\n\n.color-picker-button:hover {\n    border-color: #1a365d;\n    box-shadow: 0 0 0 1px #1a365d;\n}\n\n.color-picker-preview {\n    width: 32px;\n    height: 32px;\n    border-radius: 8px;\n    border: 2px solid #e2e8f0;\n    flex-shrink: 0;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 0.875rem;\n    font-weight: 600;\n    color: #1a365d;\n}\n\n.color-picker-text {\n    font-size: 1rem;\n    color: #1a365d;\n    font-weight: 500;\n}\n\n.form-group {\n    margin-bottom: 1.5rem;\n}\n\n.form-group label {\n    display: block;\n    margin-bottom: 0.5rem;\n    font-size: 1rem;\n    color: #2d3748;\n    font-weight: 600;\n}\n\n.form-input {\n    width: 100%;\n    height: 44px;\n    border: 1px solid #b0b4b9;\n    padding: 0.75rem 1rem;\n    margin: 0.5rem 0 0 0;\n    font-size: 1rem;\n    border-radius: 12px;\n    background: white;\n    transition: all 0.2s ease;\n    outline: none;\n    color: #1a365d;\n    font-family: inherit;\n}\n\n.form-input:focus {\n    border-color: #1a365d;\n    box-shadow: 0 0 0 1px #1a365d;\n}\n\n.form-input::placeholder {\n    color: #b0b4b9;\n    font-size: 0.9rem;\n}\n\n.form-input:disabled {\n    background: #f1f5f9;\n    border-color: #cbd5e1;\n    cursor: not-allowed;\n    color: #94a3b8;\n}\n\n.form-input[type=\"file\"] {\n    display: none;\n}\n\n.checkbox-wrapper {\n    margin-top: 0.75rem;\n}\n\n.checkbox-wrapper .checkbox-title {\n    display: block;\n    padding-top: 0.5rem;\n    margin-bottom: 0.5rem;\n    font-size: 1rem;\n    color: #2d3748;\n    font-weight: 600;\n    cursor: pointer;\n}\n\n.checkbox-wrapper .checkbox-row {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n}\n\n.checkbox-wrapper input[type=\"checkbox\"] {\n    width: 20px;\n    height: 20px;\n    cursor: pointer;\n    flex-shrink: 0;\n}\n\n.checkbox-wrapper .checkbox-description {\n    font-size: 0.875rem;\n    color: #718096;\n    font-weight: 400;\n}\n\n.file-input-wrapper {\n    position: relative;\n    display: block;\n    margin-top: 0.5rem;\n    pointer-events: none;\n}\n\n.file-input-wrapper * {\n    pointer-events: auto;\n}\n\n.file-input-label {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0.5rem;\n    padding: 0.75rem 1.5rem;\n    background: #6366f1;\n    color: white;\n    border: none;\n    border-radius: 12px;\n    font-size: 1rem;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    box-shadow: 0 4px 8px rgba(99, 102, 241, 0.2);\n    height: 44px;\n    text-align: center;\n    width: auto;\n    min-width: 200px;\n}\n\n.file-input-label:hover {\n    background: #4f46e5;\n    box-shadow: 0 6px 12px rgba(99, 102, 241, 0.3);\n    transform: translateY(-1px);\n}\n\n.file-input-label:active {\n    transform: translateY(0);\n}\n\n.file-input-label svg {\n    width: 20px;\n    height: 20px;\n    flex-shrink: 0;\n}\n\n.file-input-name {\n    margin-top: 0.5rem;\n    font-size: 0.875rem;\n    color: #64748b;\n    font-style: italic;\n}\n\n.btn-primary {\n    background: #6366f1;\n    color: white;\n    border: none;\n    padding: 10px 24px;\n    border-radius: 12px;\n    font-size: 1rem;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    box-shadow: 0 4px 8px rgba(99, 102, 241, 0.2);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0.5rem;\n    min-height: 44px;\n}\n\n.btn-primary:hover:not(:disabled) {\n    background: #4f46e5;\n    box-shadow: 0 6px 12px rgba(99, 102, 241, 0.3);\n    transform: translateY(-1px);\n}\n\n\n.form-note-text {\n    margin-top: 0.25rem;\n    margin-bottom: 0.5rem;\n    font-size: 0.875rem;\n    color: #64748b;\n    font-style: italic;\n}\n\n.form-help-text {\n    margin-top: 0.5rem;\n    font-size: 0.875rem;\n    color: #64748b;\n    font-style: italic;\n}\n\n.minimum-precision-buttons {\n    display: flex;\n    gap: 0.75rem;\n    margin-top: 0.5rem;\n}\n\n.precision-button {\n    padding: 0.5rem 1rem;\n    font-size: 0.875rem;\n    font-weight: 500;\n    color: #374151;\n    background-color: #ffffff;\n    border: 2px solid #d1d5db;\n    border-radius: 6px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.precision-button:hover {\n    background-color: #f9fafb;\n    border-color: #9ca3af;\n}\n\n.precision-button.active {\n    background-color: #2563eb;\n    color: #ffffff;\n    border-color: #2563eb;\n}\n\n.precision-button.active:hover {\n    background-color: #1d4ed8;\n    border-color: #1d4ed8;\n}\n\n.tool-name {\n    font-size: 1rem;\n    color: #1a365d;\n    font-weight: 500;\n}\n\n.tool-delete-btn {\n    width: 36px;\n    height: 36px;\n    background: white;\n    color: #6b7280;\n    border: 2px solid #cbd5e1;\n    border-radius: 8px;\n    font-size: 1.5rem;\n    font-weight: 700;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: all 0.2s ease;\n    line-height: 1;\n    padding: 0;\n    min-width: 36px;\n    min-height: 36px;\n    max-width: 36px;\n    max-height: 36px;\n    border-color: #ef4444;\n}\n\n.tool-delete-btn svg {\n    display: block;\n}\n\n.tool-delete-btn:hover {\n    background: #fef2f2;\n    border-color: #dc2626;\n    color: #374151;\n    transform: scale(1.1);\n}\n\n.no-tools {\n    text-align: center;\n    padding: 2rem;\n    color: #94a3b8;\n    font-size: 1rem;\n    font-style: italic;\n}\n\n.admin-add-button {\n    background: #3ece81;\n    color: white;\n    border: none;\n    box-shadow: 0 4px 8px rgba(72, 187, 120, 0.2);\n    border-radius: 12px;\n    padding: 0;\n    font-size: 16px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    width: 52px;\n    height: 52px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.admin-add-button svg {\n    width: 20px;\n    height: 20px;\n}\n\n.admin-add-button:hover {\n    background: #3bc475;\n    transform: translateY(-1px);\n    box-shadow: 0 6px 12px rgba(72, 187, 120, 0.3);\n}\n\n.admin-add-button:disabled {\n    background: #94a3b8;\n}\n\n\n\n/* Subscription counters */\n.subscription-counters {\n    display: flex;\n    gap: 1.5rem;\n    justify-content: left;\n    align-items: center;\n    padding: 0.75rem 1rem;\n    font-size: 0.95rem;\n}\n\n.counter-item {\n    display: inline-flex;\n    align-items: center;\n    gap: 0.5rem;\n}\n\n.counter-label {\n    font-weight: 600;\n    color: #64748b;\n}\n\n.counter-value {\n    font-weight: 700;\n    color: #1a365d;\n    transition: color 0.2s ease;\n}\n\n.counter-value.limit-reached {\n    color: #ef4444;\n    font-weight: 800;\n}\n\n/* Email list */\n.email-list-container {\n    margin-top: 1rem;\n    max-height: 200px;\n    overflow-y: auto;\n    border: 2px solid #e2e8f0;\n    border-radius: 16px;\n    background: #f8fafc;\n    padding: 0.5rem;\n}\n\n.email-list-item {\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n    margin-bottom: 0.75rem;\n    padding: 0.75rem 1rem;\n    background: white;\n    border-radius: 12px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n    transition: all 0.2s ease;\n}\n\n.email-list-item:last-child {\n    margin-bottom: 0;\n}\n\n.email-list-item:hover {\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    transform: translateY(-1px);\n}\n\n.email-text {\n    font-size: 1.1rem;\n    color: #2d3748;\n    font-weight: 500;\n    flex: 1;\n}\n\n.email-role-select {\n    padding: 0.5rem 0.75rem;\n    border: 2px solid #e2e8f0;\n    border-radius: 8px;\n    background: white;\n    color: #1a365d;\n    font-size: 0.95rem;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    outline: none;\n    min-width: 120px;\n}\n\n.email-role-select:hover {\n    border-color: #1a365d;\n}\n\n.email-role-select:focus {\n    border-color: #1a365d;\n    box-shadow: 0 0 0 3px rgba(26, 54, 93, 0.1);\n}\n\n.email-role-select:disabled {\n    background: #f1f5f9;\n    color: #64748b;\n    cursor: not-allowed;\n    border-color: #cbd5e1;\n}\n\n.email-role-select:disabled:hover {\n    border-color: #cbd5e1;\n}\n\n.db-indicator {\n    padding: 0.25rem 0.5rem;\n    background: #10b981;\n    color: white;\n    border-radius: 6px;\n    font-size: 0.75rem;\n    font-weight: 700;\n    letter-spacing: 0.5px;\n}\n\n.email-remove-btn {\n    background: #ef4444;\n    color: white;\n    border: none;\n    border-radius: 8px;\n    width: 32px;\n    height: 32px;\n    font-size: 1.5rem;\n    line-height: 1;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.email-remove-btn:hover {\n    background: #dc2626;\n    transform: scale(1.1);\n}\n\n.send-invitations-btn {\n    width: 100%;\n    padding: 1rem;\n    margin-top: 1rem;\n    background: #1a365d;\n    color: white;\n    border: none;\n    border-radius: 12px;\n    font-size: 1.1rem;\n    font-weight: 700;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.send-invitations-btn:hover {\n    background: #2d4a7c;\n    transform: translateY(-2px);\n    box-shadow: 0 4px 12px rgba(26, 54, 93, 0.3);\n}\n\n.send-invitations-btn:disabled {\n    background: #94a3b8;\n}\n\n/* Loading message */\n.loading-message {\n    text-align: center;\n    padding: 2rem;\n    font-size: 1.2rem;\n    color: #6b7280;\n}\n\n/* Role badge */\n.role-badge {\n    text-align: center;\n    margin-bottom: 2rem;\n    padding: 1rem;\n    border-radius: 12px;\n    border: 2px solid;\n}\n\n.role-badge.user-role {\n    background-color: #f0f9ff;\n    border-color: #3b82f6;\n}\n\n.role-badge.editor-role {\n    background-color: #f0fdf4;\n    border-color: #10b981;\n}\n\n.role-text {\n    font-size: 1.4rem;\n    color: #1a365d;\n    font-weight: 600;\n    margin: 0;\n}\n\n/* File button relative positioning */\n.file-btn-relative {\n    position: relative;\n}\n\n/* File remove button */\n.file-remove-btn {\n    position: absolute;\n    right: 12px;\n    top: 50%;\n    transform: translateY(-50%);\n    color: #9ca3af;\n    font-size: 32px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    opacity: 0.7;\n}\n\n.file-remove-btn:hover {\n    color: #6b7280;\n    opacity: 1;\n}\n\n/* Submit button styling */\n.submit-button {\n    background: #3ece81;\n    color: white;\n    border: none;\n    box-shadow: 0 4px 8px rgba(72, 187, 120, 0.2);\n    border-radius: 12px;\n    padding: 12px 24px;\n    font-size: 16px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    text-decoration: none;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    width: 100%;\n    margin-top: 1rem;\n    min-width: 120px;\n    min-height: 48px;\n}\n\n.submit-button:hover:not(:disabled) {\n    background: #3bc475;\n    transform: translateY(-1px);\n    box-shadow: 0 6px 12px rgba(72, 187, 120, 0.3);\n}\n\n\n/* Arrow animation */\n.arrow {\n    font-size: 1.4rem;\n    transition: transform 0.3s ease;\n}\n\n.submit-button:hover:not(:disabled) .arrow {\n    transform: translateX(5px);\n}\n\n/* Container modifications */\n.container {\n    padding-top: 4.8rem;\n}\n\n.form {\n    text-align: left;\n}\n\n/* Home dashboard: white card + history (reports) icon top-right */\n.home-form-card {\n    position: relative;\n    width: 100%;\n    max-width: 560px;\n    margin: 0 auto;\n    background: #ffffff;\n    border-radius: 12px;\n    padding: 2rem;\n    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.08);\n    border: 1px solid #e5e7eb;\n    box-sizing: border-box;\n}\n\n.home-form-card .title {\n    padding-left: 2.75rem;\n    padding-right: 2.75rem;\n}\n\n.home-form-history-btn {\n    position: absolute;\n    top: 1rem;\n    right: 1rem;\n    width: 2.25rem;\n    height: 2.25rem;\n    padding: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: #fff;\n    border: 2px solid #e5e7eb;\n    border-radius: 50%;\n    color: #1a365d;\n    cursor: pointer;\n    z-index: 2;\n    transition: border-color 0.2s ease, background 0.2s ease, transform 0.2s ease;\n}\n\n.home-form-history-btn:hover {\n    border-color: #1a365d;\n    background: #f8fafc;\n    transform: scale(1.06);\n}\n\n.home-form-history-icon {\n    width: 1.125rem;\n    height: 1.125rem;\n    display: block;\n}\n\n/* Home form main title (organization name / HME) */\n.form .title {\n    font-size: 3rem;\n    font-weight: 800;\n    text-align: center;\n    margin-bottom: 2rem;\n    color: #1a365d;\n    max-width: 100%;\n    word-break: break-word;\n    overflow-wrap: anywhere;\n}\n\n/* Invitation Page Styles */\n.invitation-container {\n    max-width: 600px;\n    margin: 0 auto;\n    padding: 2rem;\n    background: #ffffff;\n    border-radius: 12px;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.invitation-title {\n    font-size: 2rem;\n    color: #1a365d;\n    margin-bottom: 2rem;\n    text-align: center;\n}\n\n.invitation-details {\n    display: flex;\n    flex-direction: column;\n    gap: 1.5rem;\n}\n\n.invitation-info-box {\n    background: #f8fafc;\n    padding: 2rem;\n    border-radius: 8px;\n    text-align: center;\n}\n\n.invitation-info-text {\n    font-size: 1.1rem;\n    color: #64748b;\n    margin-bottom: 1rem;\n}\n\n.invitation-company-name {\n    font-size: 1.8rem;\n    color: #1a365d;\n    margin: 1rem 0;\n    font-weight: bold;\n}\n\n.invitation-role-text,\n.invitation-email-text {\n    font-size: 1rem;\n    color: #475569;\n    margin: 0.5rem 0;\n}\n\n.invitation-expired-warning {\n    background: #fef2f2;\n    color: #991b1b;\n    padding: 1rem;\n    border-radius: 8px;\n    text-align: center;\n    font-weight: 500;\n    border: 1px solid #fecaca;\n}\n\n.invitation-actions {\n    display: flex;\n    gap: 1rem;\n    justify-content: center;\n    margin-top: 1rem;\n}\n\n.invitation-accept-button,\n.invitation-reject-button {\n    padding: 0.75rem 2rem;\n    font-size: 1rem;\n    font-weight: 600;\n    border: none;\n    border-radius: 8px;\n    cursor: pointer;\n    transition: all 0.3s ease;\n}\n\n.invitation-accept-button {\n    background: #3b82f6;\n    color: white;\n}\n\n.invitation-accept-button:hover:not(:disabled) {\n    background: #2563eb;\n    transform: translateY(-2px);\n    box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);\n}\n\n.invitation-reject-button {\n    background: #e2e8f0;\n    color: #475569;\n}\n\n.invitation-reject-button:hover:not(:disabled) {\n    background: #cbd5e1;\n    transform: translateY(-2px);\n}\n\n.invitation-accept-button:disabled,\n.invitation-reject-button:disabled {\n    opacity: 0.5;\n}\n\n.invitation-note {\n    background: #e0f2fe;\n    padding: 1rem;\n    border-radius: 8px;\n    text-align: center;\n}\n\n.invitation-note p {\n    margin: 0;\n    color: #0c4a6e;\n    font-size: 0.95rem;\n}\n\n.invitation-error-container {\n    max-width: 500px;\n    margin: 4rem auto;\n    padding: 2rem;\n    background: #ffffff;\n    border-radius: 12px;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n    text-align: center;\n}\n\n.invitation-error-title {\n    font-size: 2rem;\n    color: #991b1b;\n    margin-bottom: 1rem;\n}\n\n.invitation-error-message {\n    font-size: 1.1rem;\n    color: #475569;\n    margin-bottom: 2rem;\n}\n\n.invitation-error-message-inline {\n    background: #fef2f2;\n    color: #991b1b;\n    padding: 1rem;\n    border-radius: 8px;\n    text-align: center;\n    border: 1px solid #fecaca;\n}\n\n.invitation-back-button {\n    padding: 0.75rem 2rem;\n    font-size: 1rem;\n    font-weight: 600;\n    background: #3b82f6;\n    color: white;\n    border: none;\n    border-radius: 8px;\n    cursor: pointer;\n    transition: all 0.3s ease;\n}\n\n.invitation-back-button:hover {\n    background: #2563eb;\n    transform: translateY(-2px);\n    box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);\n}\n\n/* Role selector styles */\n\n/* Invitation info banner */\n.invitation-info-banner {\n    background: #e0f2fe;\n    color: #0c4a6e;\n    padding: 1rem;\n    border-radius: 8px;\n    margin-bottom: 1.5rem;\n    text-align: center;\n    font-size: 0.95rem;\n    border: 1px solid #bae6fd;\n}\n\n/* =================================================================================\n   INVITATIONS MODAL STYLES\n   ================================================================================= */\n\n/* Modal overlay */\n.modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.7);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 10000;\n    padding: 20px;\n}\n\n.modal-container {\n    background: white;\n    border-radius: 12px;\n    max-width: 600px;\n    width: 100%;\n    max-height: 90vh;\n    display: flex;\n    flex-direction: column;\n    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n}\n\n.invitation-modal {\n    max-width: 700px;\n}\n\n.modal-header {\n    padding: 24px;\n    border-bottom: 1px solid #e2e8f0;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.modal-header h2 {\n    margin: 0;\n    color: #1a365d;\n    font-size: 24px;\n}\n\n.modal-close-btn {\n    background: none;\n    border: none;\n    font-size: 32px;\n    color: #64748b;\n    cursor: pointer;\n    padding: 0;\n    width: 40px;\n    height: 40px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 4px;\n    transition: all 0.2s;\n}\n\n.modal-close-btn:hover {\n    background: #f8fafc;\n    color: #1a365d;\n}\n\n.modal-body {\n    padding: 24px;\n    overflow-y: auto;\n    flex: 1;\n}\n\n.password-modal-description {\n    margin-bottom: 20px;\n    color: #475569;\n    font-size: 15px;\n    line-height: 1.6;\n    text-align: center;\n}\n\n.invitation-intro {\n    margin-bottom: 24px;\n    color: #475569;\n    font-size: 15px;\n    line-height: 1.6;\n}\n\n.invitations-list {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n}\n\n.invitation-card {\n    border: 1px solid #e2e8f0;\n    border-radius: 8px;\n    padding: 20px;\n    background: #f8fafc;\n    transition: all 0.2s;\n}\n\n.invitation-card:hover {\n    border-color: #3b82f6;\n    box-shadow: 0 4px 12px rgba(59, 130, 246, 0.1);\n}\n\n.invitation-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 16px;\n}\n\n.invitation-header h3 {\n    margin: 0;\n    color: #1a365d;\n    font-size: 20px;\n}\n\n.invitation-role-badge {\n    background: #3b82f6;\n    color: white;\n    padding: 4px 12px;\n    border-radius: 12px;\n    font-size: 13px;\n    font-weight: 500;\n}\n\n.invitation-details {\n    margin-bottom: 16px;\n}\n\n.invitation-details p {\n    margin: 8px 0;\n    color: #475569;\n    font-size: 14px;\n}\n\n.invitation-details strong {\n    color: #1e293b;\n    font-weight: 600;\n}\n\n.invitation-actions {\n    display: flex;\n    gap: 12px;\n    margin-top: 16px;\n}\n\n.btn-accept {\n    flex: 1;\n    background: #10b981;\n    color: white;\n    border: none;\n    padding: 12px 24px;\n    border-radius: 6px;\n    font-size: 15px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.2s;\n}\n\n.btn-accept:hover:not(:disabled) {\n    background: #059669;\n    transform: translateY(-1px);\n    box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);\n}\n\n\n.btn-reject {\n    flex: 1;\n    background: #ef4444;\n    color: white;\n    border: none;\n    padding: 12px 24px;\n    border-radius: 6px;\n    font-size: 15px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.2s;\n}\n\n.btn-reject:hover:not(:disabled) {\n    background: #dc2626;\n    transform: translateY(-1px);\n    box-shadow: 0 4px 12px rgba(239, 68, 68, 0.3);\n}\n\n\n.modal-footer {\n    padding: 20px 24px;\n    border-top: 1px solid #e2e8f0;\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    gap: 1rem;\n}\n\n/* Primary (OK / Apply / Save) on the right: list cancel/secondary first, then primary */\n.modal-footer > :first-child:not(:only-child) {\n    margin-right: auto;\n}\n\n.modal-footer .btn-active {\n    width: auto;\n    flex: 0 0 auto;\n    margin-top: 0;\n}\n\n.modal-footer .btn-secondary {\n    flex: 0 0 auto;\n}\n\n.modal-footer .btn-delete {\n    flex: 0 0 auto;\n}\n\n.modal-footer .btn-primary {\n    flex: 0 0 auto;\n}\n\n.btn-secondary {\n    background: #f1f5f9;\n    color: #475569;\n    border: none;\n    padding: 10px 24px;\n    border-radius: 6px;\n    font-size: 14px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.2s;\n    height: 52px;\n    box-sizing: border-box;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.btn-secondary:hover {\n    background: #e2e8f0;\n    color: #1e293b;\n}\n\n.btn-delete {\n    background: #ef4444;\n    color: white;\n    border: none;\n    padding: 10px 24px;\n    border-radius: 6px;\n    font-size: 14px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.2s;\n    margin-left: 12px;\n    height: 52px;\n    box-sizing: border-box;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.btn-delete:hover:not(:disabled) {\n    background: #dc2626;\n    transform: translateY(-1px);\n    box-shadow: 0 4px 12px rgba(239, 68, 68, 0.3);\n}\n\n\n.delete-modal {\n    max-width: 480px;\n}\n\n.save-success-modal {\n    max-width: 480px;\n}\n\n.local-server-save-error-detail {\n    margin: 0;\n    white-space: pre-wrap;\n}\n\n.save-success-modal .modal-header h2 {\n    color: #059669;\n}\n\n.save-success-file-label,\n.save-success-folder-label {\n    color: #64748b;\n    font-size: 14px;\n    font-weight: 600;\n    margin: 0 0 4px 0;\n}\n\n.save-success-file-row {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    margin: 0 0 16px 0;\n    padding: 8px 12px;\n    background: #f8fafc;\n    border-radius: 8px;\n    border: 1px solid #e2e8f0;\n}\n\n.save-success-file-row .save-success-file-value {\n    flex: 1;\n    min-width: 0;\n    margin: 0;\n    padding: 0;\n    background: transparent;\n    border: none;\n}\n\n.save-success-modal .save-success-file-row .save-success-open-pdf {\n    flex-shrink: 0;\n    white-space: nowrap;\n    margin: 0;\n    padding: 10px 20px;\n    min-height: 44px;\n    font-family: inherit;\n    font-size: 0.9375rem;\n    font-weight: 600;\n    letter-spacing: 0.02em;\n    color: #dc2626;\n    background: transparent;\n    border: 2px solid #dc2626;\n    border-radius: 12px;\n    cursor: pointer;\n    transition: color 0.2s ease, border-color 0.2s ease;\n}\n\n.save-success-modal .save-success-file-row .save-success-open-pdf:hover:not(:disabled) {\n    color: #b91c1c;\n    border-color: #b91c1c;\n}\n\n.save-success-modal .save-success-file-row .save-success-open-pdf:focus-visible {\n    outline: none;\n    box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.35);\n}\n\n.save-success-file-value,\n.save-success-folder-value {\n    color: #1e293b;\n    font-size: 15px;\n    margin: 0 0 16px 0;\n    padding: 8px 12px;\n    background: #f8fafc;\n    border-radius: 8px;\n    border: 1px solid #e2e8f0;\n    word-break: break-all;\n}\n\n.save-success-folder-value {\n    margin-bottom: 0;\n}\n\n.delete-confirmation-text {\n    color: #374151;\n    font-size: 16px;\n    line-height: 1.6;\n    margin: 0 0 16px 0;\n}\n\n.delete-warning-text {\n    color: #ef4444;\n    font-size: 14px;\n    font-weight: 500;\n    margin: 0;\n}\n\n.delete-password-field {\n    margin-top: 1.5rem;\n}\n\n.delete-password-label {\n    display: block;\n    margin-bottom: 0.5rem;\n    font-size: 0.9rem;\n    font-weight: 600;\n    color: #6b7280;\n}\n\n.delete-password-input {\n    width: 100%;\n    padding: 0.75rem 1rem;\n    font-size: 1rem;\n    border: 2px solid #e5e7eb;\n    border-radius: 8px;\n    background-color: #f9fafb;\n    color: #1a365d;\n    outline: none;\n    transition: all 0.2s;\n}\n\n.delete-password-input:focus {\n    border-color: #1a365d;\n    box-shadow: 0 0 0 3px rgba(26, 54, 93, 0.1);\n}\n\n.delete-password-input.error {\n    border-color: #ef4444;\n}\n\n.delete-password-input:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n}\n\n.delete-password-error {\n    color: #ef4444;\n    font-size: 0.875rem;\n    margin-top: 0.5rem;\n    margin-bottom: 0;\n}\n\n@media (max-width: 768px) {\n    .modal-container {\n        max-width: 100%;\n        max-height: 100vh;\n        border-radius: 0;\n    }\n\n    .modal-header h2 {\n        font-size: 20px;\n    }\n\n    .invitation-actions {\n        flex-direction: column;\n    }\n}\n\n/* Subscription Warning Styles */\n.subscription-warning {\n    display: flex;\n    align-items: flex-start;\n    gap: 1rem;\n    padding: 1.25rem 1.5rem;\n    margin-bottom: 1.5rem;\n    background: #fef2f2;\n    border: 2px solid #fecaca;\n    border-radius: 12px;\n    box-shadow: 0 4px 6px rgba(239, 68, 68, 0.1);\n}\n\n.warning-icon {\n    font-size: 2rem;\n    flex-shrink: 0;\n    line-height: 1;\n}\n\n.warning-content {\n    flex: 1;\n}\n\n.warning-content h3 {\n    margin: 0 0 0.5rem 0;\n    font-size: 1.25rem;\n    font-weight: 700;\n    color: #991b1b;\n}\n\n.warning-content p {\n    margin: 0;\n    font-size: 1rem;\n    color: #7f1d1d;\n    line-height: 1.5;\n}\n\n/* ============================================================\n   Reports page (operator/editor history viewer)\n   ============================================================ */\n.reports-page {\n    max-width: 1200px;\n    margin: 0 auto;\n    padding: 1.5rem;\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n}\n\n.reports-page-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 1rem;\n    flex-wrap: wrap;\n}\n\n.reports-page-header .reports-secondary-title {\n    margin: 0;\n}\n\n.reports-secondary-section {\n    margin-top: 2.5rem;\n    padding-top: 2rem;\n    border-top: 1px solid #e5e7eb;\n}\n\n.reports-secondary-title {\n    margin: 0 0 1rem;\n    font-size: 1.25rem;\n    font-weight: 700;\n    color: #1f2937;\n    text-align: left;\n    align-self: flex-start;\n}\n\n.reports-filters {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 1rem;\n    align-items: stretch;\n    background: #f9fafb;\n    padding: 1rem;\n    border: 1px solid #e5e7eb;\n    border-radius: 10px;\n}\n\n.reports-search-bar {\n    display: flex;\n    align-items: stretch;\n    gap: 0.5rem;\n    width: 100%;\n    min-width: 0;\n}\n\n.reports-search-input {\n    flex: 1;\n    min-width: 0;\n    min-height: 2.75rem;\n    font-size: 1rem;\n}\n\n.reports-search-icon-btn {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    min-width: 2.75rem;\n    padding: 0.5rem;\n    flex-shrink: 0;\n}\n\n.reports-search-icon {\n    width: 1.35rem;\n    height: 1.35rem;\n    display: block;\n}\n\n.reports-empty {\n    padding: 2rem;\n    text-align: center;\n    color: #6b7280;\n    background: #f9fafb;\n    border: 1px dashed #d1d5db;\n    border-radius: 10px;\n}\n\n.reports-table-wrapper {\n    overflow-x: auto;\n    border: 1px solid #e5e7eb;\n    border-radius: 10px;\n    background: #ffffff;\n}\n\n.reports-table {\n    width: 100%;\n    border-collapse: collapse;\n    font-size: 0.875rem;\n}\n\n.reports-table th,\n.reports-table td {\n    padding: 0.75rem 1rem;\n    text-align: left;\n    border-bottom: 1px solid #f3f4f6;\n    vertical-align: middle;\n}\n\n.reports-table th {\n    background: #f9fafb;\n    font-weight: 600;\n    color: #374151;\n    position: sticky;\n    top: 0;\n    z-index: 1;\n}\n\n.reports-table tbody tr:hover {\n    background: #f9fafb;\n}\n\n.reports-table td .profile-secondary-btn {\n    margin-right: 0.5rem;\n    padding: 0.3rem 0.6rem;\n    font-size: 0.8rem;\n}\n\n.reports-open-pdf-btn,\n.reports-edit-settings-btn {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    min-width: 2.25rem;\n    min-height: 2.25rem;\n    padding: 0.35rem;\n    margin-right: 0;\n}\n\n.reports-open-pdf-icon {\n    width: 1.25rem;\n    height: 1.25rem;\n    display: block;\n}\n\n.reports-action-cell {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 0.35rem;\n}\n\n.reports-download-pdf-btn {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    min-width: 2.25rem;\n    min-height: 2.25rem;\n    padding: 0.35rem;\n    margin-right: 0;\n}\n\n.reports-pagination {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 1rem;\n    padding: 0.5rem 0;\n}\n\n.reports-page-info {\n    color: #4b5563;\n    font-size: 0.875rem;\n}\n\n.reports-page-error {\n    font-size: 0.875rem;\n    color: #b91c1c;\n    padding: 0.75rem 1rem;\n    background: #fef2f2;\n    border: 1px solid #fecaca;\n    border-radius: 8px;\n    -webkit-user-select: text;\n    -moz-user-select: text;\n    -ms-user-select: text;\n    user-select: text;\n    cursor: text;\n    white-space: pre-wrap;\n    word-break: break-word;\n    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n    line-height: 1.5;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
